const Rdata = {
  "events": [
    {
      "id": 7,
      "is_custom": 0,
      "sportId": 1000,
      "name": "Virtual Sports",
      "slug": "virtual-sports",
      "sport_icon": "60aff93b67aa0.png",
      "is_deleted": 0,
      "stake_size": {
        "min_match": "NULL",
        "max_match": "NULL",
        "min_bookmaker": "NULL",
        "max_bookmaker": "NULL",
        "min_fancy": "NULL",
        "max_fancy": "NULL",
        "currency_stake": "[{\"id\":1,\"stake\":null},{\"id\":2,\"stake\":null},{\"id\":3,\"stake\":null},{\"id\":4,\"stake\":null}]",
        "sport_id": 7,
        "_id": "61f27105a01795122d2a5724"
      },
      "bet_delay": {
        "match": "NULL",
        "bookmaker": "NULL",
        "fancy": "NULL",
        "sport_id": 7,
        "_id": "61f27105a01795122d2a5722"
      },
      "events": []
    },
    {
      "id": 3,
      "is_custom": 0,
      "sportId": 4,
      "name": "Cricket",
      "slug": "cricket",
      "sport_icon": "60aff93b67aa0.png",
      "is_deleted": 0,
      "stake_size": {
        "min_match": 100,
        "max_match": 1,
        "min_bookmaker": 100,
        "max_bookmaker": 100000,
        "min_fancy": 100,
        "max_fancy": 100000,
        "currency_stake": "[{\"id\":1,\"stake\":\"1\"},{\"id\":2,\"stake\":\"2\"},{\"id\":3,\"stake\":\"0.10\"},{\"id\":4,\"stake\":\"0.10\"}]",
        "sport_id": 3,
        "updated_at": {
          "$date": {
            "$numberLong": "1687388080889"
          }
        },
        "_id": "61e2e6a8857a7a3716228a6a"
      },
      "bet_delay": {
        "match": 5,
        "bookmaker": 0,
        "fancy": 0,
        "sport_id": 3,
        "updated_at": {
          "$date": {
            "$numberLong": "1686060629452"
          }
        },
        "_id": "61e2e6a8857a7a3716228a68"
      },
      "events": [
        {
          "id": 90945,
          "sport_id": 4,
          "league_id": 1215,
          "event_id": -10489445,
          "market_id": "CUS1692401418",
          "event_name": "Bezawada Tigers vs Rayalaseema Kings",
          "slug": "bezawada-tigers-vs-rayalaseema-kings",
          "runners": [
            "Bezawada Tigers",
            "Rayalaseema Kings"
          ],
          "event_date": "2023-08-19T04:30:00.000000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 1,
          "tv_url": "1692366949",
          "event_timestamp_date": 1692419400,
          "is_added_tv": 1,
          "inplay_status": 0,
          "sport_radar_id": 42990635,
          "is_deleted": 0,
          "league_name": "Andhra Premier League.",
          "league_slug": "andhra-premier-league-1",
          "league_code": 4154141,
          "markets": [],
          "main_market": {
            "id": 646631,
            "match_id": 90945,
            "event_id": -10489445,
            "market_id": "CUS1692401418",
            "market_name": "Match Odds",
            "runners": "[\"Bezawada Tigers\",\"Rayalaseema Kings\"]",
            "stake_limit": null,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": null,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": null,
            "selection_runner": "[{\"runner_name\":\"Bezawada Tigers\",\"selection_id\":1774611509389565},{\"runner_name\":\"Rayalaseema Kings\",\"selection_id\":1774611509389568}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": null,
          "inplay": true,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": null,
          "inplay_stake_limit": null,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 21
        },
        {
          "id": 90927,
          "sport_id": 4,
          "league_id": 1214,
          "event_id": -10489415,
          "market_id": "CUS1692396872",
          "event_name": "Bengaluru Blasters vs Mysore Warriors",
          "slug": "bengaluru-blasters-vs-mysore-warriors",
          "runners": [
            "Bengaluru Blasters",
            "Mysore Warriors"
          ],
          "event_date": "2023-08-19T07:30:00.000000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 1,
          "tv_url": null,
          "event_timestamp_date": 1692430200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42726517,
          "is_deleted": 0,
          "league_name": "Maharaja T20 Trophy.",
          "league_slug": "maharaja-t20-trophy-1",
          "league_code": 4745743,
          "markets": [],
          "main_market": {
            "id": 646581,
            "match_id": 90927,
            "event_id": -10489415,
            "market_id": "CUS1692396872",
            "market_name": "Match Odds",
            "runners": "[\"Bengaluru Blasters\",\"Mysore Warriors\"]",
            "stake_limit": null,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": null,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": null,
            "selection_runner": "[{\"runner_name\":\"Bengaluru Blasters\",\"selection_id\":1774606742772570},{\"runner_name\":\"Mysore Warriors\",\"selection_id\":1774606742772573}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": null,
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": null,
          "inplay_stake_limit": null,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90946,
          "sport_id": 4,
          "league_id": 1215,
          "event_id": -10489446,
          "market_id": "CUS1692401769",
          "event_name": "Uttarandhra Lions vs Coastal Riders",
          "slug": "uttarandhra-lions-vs-coastal-riders",
          "runners": [
            "Uttarandhra Lions",
            "Coastal Riders"
          ],
          "event_date": "2023-08-19T09:30:00.000000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 1,
          "tv_url": null,
          "event_timestamp_date": 1692437400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": "42990637",
          "is_deleted": 0,
          "league_name": "Andhra Premier League.",
          "league_slug": "andhra-premier-league-1",
          "league_code": 4154141,
          "markets": [],
          "main_market": {
            "id": 646632,
            "match_id": 90946,
            "event_id": -10489446,
            "market_id": "CUS1692401769",
            "market_name": "Match Odds",
            "runners": "[\"Uttarandhra Lions\",\"Coastal Riders\"]",
            "stake_limit": null,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": null,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": null,
            "selection_runner": "[{\"runner_name\":\"Uttarandhra Lions\",\"selection_id\":1774611877913291},{\"runner_name\":\"Coastal Riders\",\"selection_id\":1774611877913294}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": null,
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": null,
          "inplay_stake_limit": null,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90611,
          "sport_id": 4,
          "league_id": 607,
          "event_id": 32562500,
          "market_id": "1.217183763",
          "event_name": "Trent Rockets Women v Birmingham Phoenix Women",
          "slug": "trent-rockets-women-v-birmingham-phoenix-women",
          "runners": [
            "Trent Rockets Women",
            "Birmingham Phoenix Women"
          ],
          "event_date": "2023-08-19T10:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692439200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38928069,
          "is_deleted": 0,
          "league_name": "The Hundred - Womens",
          "league_slug": "the-hundred-womens",
          "league_code": 12351359,
          "markets": [],
          "main_market": {
            "id": 644188,
            "match_id": 90611,
            "event_id": 32562500,
            "market_id": "1.217183763",
            "market_name": "Match Odds",
            "runners": "[\"Trent Rockets Women\",\"Birmingham Phoenix Women\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Trent Rockets Women\",\"selection_id\":40096580},{\"runner_name\":\"Birmingham Phoenix Women\",\"selection_id\":40096575}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217183763",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 40096580,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.57,
                      "size": 226.42
                    },
                    {
                      "price": 1.56,
                      "size": 927.04
                    },
                    {
                      "price": 1.55,
                      "size": 757.34
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.6,
                      "size": 4072.17
                    },
                    {
                      "price": 1.61,
                      "size": 7283.68
                    },
                    {
                      "price": 1.64,
                      "size": 542.6
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 40096575,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.66,
                      "size": 2552.1
                    },
                    {
                      "price": 2.64,
                      "size": 4257.59
                    },
                    {
                      "price": 2.62,
                      "size": 81.52
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.76,
                      "size": 219.46
                    },
                    {
                      "price": 2.8,
                      "size": 427.12
                    },
                    {
                      "price": 2.82,
                      "size": 416.27
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 2,
          "fancies_count": 48
        },
        {
          "id": 90928,
          "sport_id": 4,
          "league_id": 1214,
          "event_id": -10489417,
          "market_id": "CUS1692397188",
          "event_name": "Hubli Tigers vs Shivamogga Lions",
          "slug": "hubli-tigers-vs-shivamogga-lions",
          "runners": [
            "Hubli Tigers",
            "Shivamogga Lions"
          ],
          "event_date": "2023-08-19T12:00:00.000000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 1,
          "tv_url": null,
          "event_timestamp_date": 1692446400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42879627,
          "is_deleted": 0,
          "league_name": "Maharaja T20 Trophy.",
          "league_slug": "maharaja-t20-trophy-1",
          "league_code": 4745743,
          "markets": [],
          "main_market": {
            "id": 646582,
            "match_id": 90928,
            "event_id": -10489417,
            "market_id": "CUS1692397188",
            "market_name": "Match Odds",
            "runners": "[\"Hubli Tigers\",\"Shivamogga Lions\"]",
            "stake_limit": null,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": null,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": null,
            "selection_runner": "[{\"runner_name\":\"Hubli Tigers\",\"selection_id\":1774607074380403},{\"runner_name\":\"Shivamogga Lions\",\"selection_id\":1774607074380407}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": null,
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": null,
          "inplay_stake_limit": null,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90689,
          "sport_id": 4,
          "league_id": 1216,
          "event_id": 32565150,
          "market_id": "1.217221358",
          "event_name": "Texas Chargers v California Knights",
          "slug": "texas-chargers-v-california-knights",
          "runners": [
            "Texas Chargers",
            "California Knights"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42880929,
          "is_deleted": 0,
          "league_name": "US Masters T10",
          "league_slug": "us-masters-t10",
          "league_code": 12608032,
          "markets": [],
          "main_market": {
            "id": 644484,
            "match_id": 90689,
            "event_id": 32565150,
            "market_id": "1.217221358",
            "market_name": "Match Odds",
            "runners": "[\"Texas Chargers\",\"California Knights\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Texas Chargers\",\"selection_id\":59465077},{\"runner_name\":\"California Knights\",\"selection_id\":59465558}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217221358",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 59465077,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.97,
                      "size": 51.43
                    },
                    {
                      "price": 1.96,
                      "size": 363.32
                    },
                    {
                      "price": 1.95,
                      "size": 236.89
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.06,
                      "size": 224.24
                    },
                    {
                      "price": 2.08,
                      "size": 91.89
                    },
                    {
                      "price": 2.5,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 59465558,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.95,
                      "size": 236.89
                    },
                    {
                      "price": 1.93,
                      "size": 99.03
                    },
                    {
                      "price": 1.66,
                      "size": 30.04
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.04,
                      "size": 49.67
                    },
                    {
                      "price": 2.06,
                      "size": 569.92
                    },
                    {
                      "price": 2.5,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90536,
          "sport_id": 4,
          "league_id": 607,
          "event_id": 32560843,
          "market_id": "1.217161532",
          "event_name": "Southern Brave Women v Oval Invincibles Women",
          "slug": "southern-brave-women-v-oval-invincibles-women",
          "runners": [
            "Southern Brave Women",
            "Oval Invincibles Women"
          ],
          "event_date": "2023-08-19T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692451800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38928075,
          "is_deleted": 0,
          "league_name": "The Hundred - Womens",
          "league_slug": "the-hundred-womens",
          "league_code": 12351359,
          "markets": [],
          "main_market": {
            "id": 643689,
            "match_id": 90536,
            "event_id": 32560843,
            "market_id": "1.217161532",
            "market_name": "Match Odds",
            "runners": "[\"Southern Brave Women\",\"Oval Invincibles Women\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Southern Brave Women\",\"selection_id\":40096579},{\"runner_name\":\"Oval Invincibles Women\",\"selection_id\":40096582}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217161532",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 40096579,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.78,
                      "size": 44.46
                    },
                    {
                      "price": 1.76,
                      "size": 339.82
                    },
                    {
                      "price": 1.74,
                      "size": 99.74
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.85,
                      "size": 11.37
                    },
                    {
                      "price": 1.87,
                      "size": 784
                    },
                    {
                      "price": 1.9,
                      "size": 218.43
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 40096582,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.16,
                      "size": 688.48
                    },
                    {
                      "price": 2.1,
                      "size": 197.63
                    },
                    {
                      "price": 2.08,
                      "size": 483.37
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.28,
                      "size": 34.71
                    },
                    {
                      "price": 2.32,
                      "size": 257.8
                    },
                    {
                      "price": 2.36,
                      "size": 73.54
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 2,
          "fancies_count": 48
        },
        {
          "id": 90613,
          "sport_id": 4,
          "league_id": 608,
          "event_id": 32562761,
          "market_id": "1.217190192",
          "event_name": "Trent Rockets v Birmingham Phoenix",
          "slug": "trent-rockets-v-birmingham-phoenix-30",
          "runners": [
            "Trent Rockets",
            "Birmingham Phoenix"
          ],
          "event_date": "2023-08-19T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692451800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38927963,
          "is_deleted": 0,
          "league_name": "The Hundred",
          "league_slug": "the-hundred",
          "league_code": 12267948,
          "markets": [],
          "main_market": {
            "id": 644194,
            "match_id": 90613,
            "event_id": 32562761,
            "market_id": "1.217190192",
            "market_name": "Match Odds",
            "runners": "[\"Trent Rockets\",\"Birmingham Phoenix\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"Trent Rockets\",\"selection_id\":26354925},{\"runner_name\":\"Birmingham Phoenix\",\"selection_id\":26354921}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217190192",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 26354925,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.76,
                      "size": 273.59
                    },
                    {
                      "price": 1.75,
                      "size": 4220.1
                    },
                    {
                      "price": 1.74,
                      "size": 779.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.79,
                      "size": 371.77
                    },
                    {
                      "price": 1.8,
                      "size": 107.52
                    },
                    {
                      "price": 1.84,
                      "size": 250.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 26354921,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.26,
                      "size": 294.45
                    },
                    {
                      "price": 2.24,
                      "size": 86.4
                    },
                    {
                      "price": 2.2,
                      "size": 209.46
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.32,
                      "size": 207.55
                    },
                    {
                      "price": 2.34,
                      "size": 3607.36
                    },
                    {
                      "price": 2.36,
                      "size": 127.37
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 2,
          "fancies_count": 54
        },
        {
          "id": 90678,
          "sport_id": 4,
          "league_id": 6,
          "event_id": 32565633,
          "market_id": "1.217225582",
          "event_name": "UAE v New Zealand",
          "slug": "uae-v-new-zealand-25",
          "runners": [
            "UAE",
            "New Zealand"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 39871125,
          "is_deleted": 0,
          "league_name": "International Twenty20 Matches",
          "league_slug": "international-twenty20-matches",
          "league_code": 9992899,
          "markets": [],
          "main_market": {
            "id": 644451,
            "match_id": 90678,
            "event_id": 32565633,
            "market_id": "1.217225582",
            "market_name": "Match Odds",
            "runners": "[\"UAE\",\"New Zealand\"]",
            "stake_limit": 10000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 300000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "30",
            "selection_runner": "[{\"runner_name\":\"UAE\",\"selection_id\":871131},{\"runner_name\":\"New Zealand\",\"selection_id\":448}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217225582",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 871131,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 6,
                      "size": 3946.3
                    },
                    {
                      "price": 5.8,
                      "size": 119.9
                    },
                    {
                      "price": 5.7,
                      "size": 565.6
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.4,
                      "size": 300.21
                    },
                    {
                      "price": 6.6,
                      "size": 79.45
                    },
                    {
                      "price": 7,
                      "size": 157.43
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 448,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.18,
                      "size": 2072.65
                    },
                    {
                      "price": 1.17,
                      "size": 941.86
                    },
                    {
                      "price": 1.16,
                      "size": 1296.65
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.2,
                      "size": 19731.5
                    },
                    {
                      "price": 1.21,
                      "size": 3239.15
                    },
                    {
                      "price": 1.22,
                      "size": 2244.2
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 10000,
          "inplay_stake_limit": 300000,
          "stack_conversion": 1,
          "bookmakers_count": 2,
          "fancies_count": 74
        },
        {
          "id": 90679,
          "sport_id": 4,
          "league_id": 657,
          "event_id": 32564341,
          "market_id": "1.217212933",
          "event_name": "Trinbago Knight Riders v St Kitts & Nevis Patriots",
          "slug": "trinbago-knight-riders-v-st-kitts-nevis-patriots",
          "runners": [
            "Trinbago Knight Riders",
            "St Kitts & Nevis Patriots"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 40743161,
          "is_deleted": 0,
          "league_name": "Caribbean Premier League",
          "league_slug": "caribbean-premier-league",
          "league_code": 11416933,
          "markets": [],
          "main_market": {
            "id": 644454,
            "match_id": 90679,
            "event_id": 32564341,
            "market_id": "1.217212933",
            "market_name": "Match Odds",
            "runners": "[\"Trinbago Knight Riders\",\"St Kitts & Nevis Patriots\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"Trinbago Knight Riders\",\"selection_id\":11056084},{\"runner_name\":\"St Kitts & Nevis Patriots\",\"selection_id\":13755592}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217212933",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 11056084,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.58,
                      "size": 297.79
                    },
                    {
                      "price": 1.57,
                      "size": 359.07
                    },
                    {
                      "price": 1.56,
                      "size": 249.36
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.6,
                      "size": 9942.48
                    },
                    {
                      "price": 1.63,
                      "size": 14641.89
                    },
                    {
                      "price": 1.67,
                      "size": 204.67
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 13755592,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.66,
                      "size": 5980.44
                    },
                    {
                      "price": 2.6,
                      "size": 160.49
                    },
                    {
                      "price": 2.58,
                      "size": 9088.76
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.74,
                      "size": 171.72
                    },
                    {
                      "price": 2.76,
                      "size": 204.25
                    },
                    {
                      "price": 2.8,
                      "size": 138.93
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 2,
          "fancies_count": 74
        },
        {
          "id": 90680,
          "sport_id": 4,
          "league_id": 887,
          "event_id": 32565589,
          "market_id": "1.217225140",
          "event_name": "Galle Titans v B Love Kandy",
          "slug": "galle-titans-v-b-love-kandy-4",
          "runners": [
            "Galle Titans",
            "B Love Kandy"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 43064683,
          "is_deleted": 0,
          "league_name": "Lanka Premier League",
          "league_slug": "lanka-premier-league",
          "league_code": 12304154,
          "markets": [],
          "main_market": {
            "id": 644457,
            "match_id": 90680,
            "event_id": 32565589,
            "market_id": "1.217225140",
            "market_name": "Match Odds",
            "runners": "[\"Galle Titans\",\"B Love Kandy\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Galle Titans\",\"selection_id\":58703863},{\"runner_name\":\"B Love Kandy\",\"selection_id\":58710944}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217225140",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 58703863,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.24,
                      "size": 144.11
                    },
                    {
                      "price": 2.16,
                      "size": 255.02
                    },
                    {
                      "price": 2.14,
                      "size": 1148.29
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.3,
                      "size": 1571.29
                    },
                    {
                      "price": 2.32,
                      "size": 75.67
                    },
                    {
                      "price": 2.36,
                      "size": 333.28
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58710944,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.78,
                      "size": 1848.42
                    },
                    {
                      "price": 1.77,
                      "size": 182.93
                    },
                    {
                      "price": 1.76,
                      "size": 99.74
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.8,
                      "size": 179.34
                    },
                    {
                      "price": 1.85,
                      "size": 89.97
                    },
                    {
                      "price": 1.86,
                      "size": 206.67
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 2,
          "fancies_count": 74
        },
        {
          "id": 90690,
          "sport_id": 4,
          "league_id": 1216,
          "event_id": 32565153,
          "market_id": "1.217221403",
          "event_name": "New York Warriors v Atlanta Riders",
          "slug": "new-york-warriors-v-atlanta-riders",
          "runners": [
            "New York Warriors",
            "Atlanta Riders"
          ],
          "event_date": "2023-08-19T15:15:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692458100,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42880931,
          "is_deleted": 0,
          "league_name": "US Masters T10",
          "league_slug": "us-masters-t10",
          "league_code": 12608032,
          "markets": [],
          "main_market": {
            "id": 644487,
            "match_id": 90690,
            "event_id": 32565153,
            "market_id": "1.217221403",
            "market_name": "Match Odds",
            "runners": "[\"New York Warriors\",\"Atlanta Riders\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"New York Warriors\",\"selection_id\":59465560},{\"runner_name\":\"Atlanta Riders\",\"selection_id\":59465076}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217221403",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 59465560,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.7,
                      "size": 18.36
                    },
                    {
                      "price": 1.66,
                      "size": 30.04
                    },
                    {
                      "price": 1.13,
                      "size": 15344.91
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.1,
                      "size": 17.87
                    },
                    {
                      "price": 2.18,
                      "size": 16.08
                    },
                    {
                      "price": 2.5,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 59465076,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.9,
                      "size": 19.33
                    },
                    {
                      "price": 1.85,
                      "size": 18.95
                    },
                    {
                      "price": 1.66,
                      "size": 30.04
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.44,
                      "size": 12.97
                    },
                    {
                      "price": 2.5,
                      "size": 19.95
                    },
                    {
                      "price": 8.8,
                      "size": 1970.43
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90537,
          "sport_id": 4,
          "league_id": 608,
          "event_id": 32560939,
          "market_id": "1.217162917",
          "event_name": "Southern Brave v Oval Invincibles",
          "slug": "southern-brave-v-oval-invincibles",
          "runners": [
            "Southern Brave",
            "Oval Invincibles"
          ],
          "event_date": "2023-08-19T17:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692464400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38927967,
          "is_deleted": 0,
          "league_name": "The Hundred",
          "league_slug": "the-hundred",
          "league_code": 12267948,
          "markets": [],
          "main_market": {
            "id": 643692,
            "match_id": 90537,
            "event_id": 32560939,
            "market_id": "1.217162917",
            "market_name": "Match Odds",
            "runners": "[\"Southern Brave\",\"Oval Invincibles\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"Southern Brave\",\"selection_id\":26354926},{\"runner_name\":\"Oval Invincibles\",\"selection_id\":26354923}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217162917",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 26354926,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.06,
                      "size": 1094.58
                    },
                    {
                      "price": 2.04,
                      "size": 2025.1
                    },
                    {
                      "price": 2.02,
                      "size": 977.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.12,
                      "size": 85
                    },
                    {
                      "price": 2.14,
                      "size": 1356.94
                    },
                    {
                      "price": 2.16,
                      "size": 976.71
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 26354923,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.89,
                      "size": 95.34
                    },
                    {
                      "price": 1.88,
                      "size": 1544.6
                    },
                    {
                      "price": 1.87,
                      "size": 1128.18
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.94,
                      "size": 182.5
                    },
                    {
                      "price": 1.95,
                      "size": 1473.47
                    },
                    {
                      "price": 1.97,
                      "size": 1603.41
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 2,
          "fancies_count": 54
        },
        {
          "id": 90691,
          "sport_id": 4,
          "league_id": 1216,
          "event_id": 32565154,
          "market_id": "1.217221447",
          "event_name": "Morrisville Unity v New Jersey Tritons",
          "slug": "morrisville-unity-v-new-jersey-tritons",
          "runners": [
            "Morrisville Unity",
            "New Jersey Tritons"
          ],
          "event_date": "2023-08-19T17:15:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692465300,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "US Masters T10",
          "league_slug": "us-masters-t10",
          "league_code": 12608032,
          "markets": [],
          "main_market": {
            "id": 644490,
            "match_id": 90691,
            "event_id": 32565154,
            "market_id": "1.217221447",
            "market_name": "Match Odds",
            "runners": "[\"Morrisville Unity\",\"New Jersey Tritons\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Morrisville Unity\",\"selection_id\":59465561},{\"runner_name\":\"New Jersey Tritons\",\"selection_id\":59465557}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217221447",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 59465561,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.8,
                      "size": 25.63
                    },
                    {
                      "price": 1.7,
                      "size": 39.9
                    },
                    {
                      "price": 1.18,
                      "size": 11082.43
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.8,
                      "size": 20.67
                    },
                    {
                      "price": 7,
                      "size": 1973.59
                    },
                    {
                      "price": 7.8,
                      "size": 147.06
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 59465557,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.17,
                      "size": 11923.77
                    },
                    {
                      "price": 1.15,
                      "size": 997.42
                    },
                    {
                      "price": 1.05,
                      "size": 26.23
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.26,
                      "size": 20.42
                    },
                    {
                      "price": 2.44,
                      "size": 27.8
                    },
                    {
                      "price": 6.6,
                      "size": 1981.4
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90810,
          "sport_id": 4,
          "league_id": 657,
          "event_id": 32567688,
          "market_id": "1.217259043",
          "event_name": "St Lucia Kings v Guyana Amazon Warriors",
          "slug": "st-lucia-kings-v-guyana-amazon-warriors-63",
          "runners": [
            "St Lucia Kings",
            "Guyana Amazon Warriors"
          ],
          "event_date": "2023-08-19T23:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 40743167,
          "is_deleted": 0,
          "league_name": "Caribbean Premier League",
          "league_slug": "caribbean-premier-league",
          "league_code": 11416933,
          "markets": [],
          "main_market": {
            "id": 645464,
            "match_id": 90810,
            "event_id": 32567688,
            "market_id": "1.217259043",
            "market_name": "Match Odds",
            "runners": "[\"St Lucia Kings\",\"Guyana Amazon Warriors\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"St Lucia Kings\",\"selection_id\":40497468},{\"runner_name\":\"Guyana Amazon Warriors\",\"selection_id\":7591770}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217259043",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 40497468,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.87,
                      "size": 905.06
                    },
                    {
                      "price": 1.74,
                      "size": 172.75
                    },
                    {
                      "price": 1.73,
                      "size": 148.82
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.95,
                      "size": 19.95
                    },
                    {
                      "price": 2,
                      "size": 204.87
                    },
                    {
                      "price": 2.12,
                      "size": 35.76
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7591770,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.04,
                      "size": 19.07
                    },
                    {
                      "price": 2,
                      "size": 204.87
                    },
                    {
                      "price": 1.9,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.16,
                      "size": 783.55
                    },
                    {
                      "price": 2.36,
                      "size": 127.37
                    },
                    {
                      "price": 2.38,
                      "size": 108.17
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90813,
          "sport_id": 4,
          "league_id": 607,
          "event_id": 32565816,
          "market_id": "1.217230552",
          "event_name": "Manchester Originals Women v Northern Supercharger",
          "slug": "manchester-originals-women-v-northern-supercharger",
          "runners": [
            "Manchester Originals Women",
            "Northern Supercharger"
          ],
          "event_date": "2023-08-20T10:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692525600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38928079,
          "is_deleted": 0,
          "league_name": "The Hundred - Womens",
          "league_slug": "the-hundred-womens",
          "league_code": 12351359,
          "markets": [],
          "main_market": {
            "id": 645473,
            "match_id": 90813,
            "event_id": 32565816,
            "market_id": "1.217230552",
            "market_name": "Match Odds",
            "runners": "[\"Manchester Originals Women\",\"Northern Supercharger\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Manchester Originals Women\",\"selection_id\":40096590},{\"runner_name\":\"Northern Supercharger\",\"selection_id\":40328606}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217230552",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 40096590,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.16,
                      "size": 456.09
                    },
                    {
                      "price": 1.86,
                      "size": 34.75
                    },
                    {
                      "price": 1.83,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 653.4
                    },
                    {
                      "price": 3.1,
                      "size": 33.88
                    },
                    {
                      "price": 36,
                      "size": 272.22
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 40328606,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.49,
                      "size": 1337.29
                    },
                    {
                      "price": 1.48,
                      "size": 70.96
                    },
                    {
                      "price": 1.05,
                      "size": 26.23
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.85,
                      "size": 532.83
                    },
                    {
                      "price": 2.16,
                      "size": 29.92
                    },
                    {
                      "price": 2.22,
                      "size": 32.89
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90681,
          "sport_id": 4,
          "league_id": 607,
          "event_id": 32565182,
          "market_id": "1.217221544",
          "event_name": "Welsh Fire Women v London Spirit Women",
          "slug": "welsh-fire-women-v-london-spirit-women",
          "runners": [
            "Welsh Fire Women",
            "London Spirit Women"
          ],
          "event_date": "2023-08-20T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692538200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38928089,
          "is_deleted": 0,
          "league_name": "The Hundred - Womens",
          "league_slug": "the-hundred-womens",
          "league_code": 12351359,
          "markets": [],
          "main_market": {
            "id": 644460,
            "match_id": 90681,
            "event_id": 32565182,
            "market_id": "1.217221544",
            "market_name": "Match Odds",
            "runners": "[\"Welsh Fire Women\",\"London Spirit Women\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Welsh Fire Women\",\"selection_id\":40096581},{\"runner_name\":\"London Spirit Women\",\"selection_id\":40096576}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217221544",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 40096581,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.68,
                      "size": 1158
                    },
                    {
                      "price": 1.62,
                      "size": 785.47
                    },
                    {
                      "price": 1.04,
                      "size": 109.22
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.75,
                      "size": 785.68
                    },
                    {
                      "price": 36,
                      "size": 272.22
                    },
                    {
                      "price": 55,
                      "size": 376.24
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 40096576,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.34,
                      "size": 587.58
                    },
                    {
                      "price": 1.05,
                      "size": 26.23
                    },
                    {
                      "price": 1.04,
                      "size": 109.22
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.48,
                      "size": 784.45
                    },
                    {
                      "price": 2.62,
                      "size": 485.67
                    },
                    {
                      "price": 36,
                      "size": 270.91
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90814,
          "sport_id": 4,
          "league_id": 608,
          "event_id": 32565804,
          "market_id": "1.217230410",
          "event_name": "Manchester Originals v Northern Superchargers",
          "slug": "manchester-originals-v-northern-superchargers-75",
          "runners": [
            "Manchester Originals",
            "Northern Superchargers"
          ],
          "event_date": "2023-08-20T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692538200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38927969,
          "is_deleted": 0,
          "league_name": "The Hundred",
          "league_slug": "the-hundred",
          "league_code": 12267948,
          "markets": [],
          "main_market": {
            "id": 645476,
            "match_id": 90814,
            "event_id": 32565804,
            "market_id": "1.217230410",
            "market_name": "Match Odds",
            "runners": "[\"Manchester Originals\",\"Northern Superchargers\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"Manchester Originals\",\"selection_id\":26354922},{\"runner_name\":\"Northern Superchargers\",\"selection_id\":26354924}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217230410",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 26354922,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.79,
                      "size": 198.08
                    },
                    {
                      "price": 1.78,
                      "size": 29.51
                    },
                    {
                      "price": 1.77,
                      "size": 568.53
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.97,
                      "size": 439.57
                    },
                    {
                      "price": 1.99,
                      "size": 23.67
                    },
                    {
                      "price": 2.04,
                      "size": 783.94
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 26354924,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.02,
                      "size": 428.51
                    },
                    {
                      "price": 2,
                      "size": 23.55
                    },
                    {
                      "price": 1.97,
                      "size": 811.8
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.26,
                      "size": 157.03
                    },
                    {
                      "price": 2.3,
                      "size": 460.36
                    },
                    {
                      "price": 2.44,
                      "size": 69.49
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90809,
          "sport_id": 4,
          "league_id": 6,
          "event_id": 32568399,
          "market_id": "1.217273399",
          "event_name": "Ireland v India",
          "slug": "ireland-v-india-63",
          "runners": [
            "Ireland",
            "India"
          ],
          "event_date": "2023-08-20T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692540000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42144193,
          "is_deleted": 0,
          "league_name": "International Twenty20 Matches",
          "league_slug": "international-twenty20-matches",
          "league_code": 9992899,
          "markets": [],
          "main_market": {
            "id": 645461,
            "match_id": 90809,
            "event_id": 32568399,
            "market_id": "1.217273399",
            "market_name": "Match Odds",
            "runners": "[\"Ireland\",\"India\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 300000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "30",
            "selection_runner": "[{\"runner_name\":\"Ireland\",\"selection_id\":152530},{\"runner_name\":\"India\",\"selection_id\":414464}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217273399",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 152530,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 976.59
                    },
                    {
                      "price": 4.4,
                      "size": 4172.98
                    },
                    {
                      "price": 4.3,
                      "size": 2085.31
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.8,
                      "size": 1616.18
                    },
                    {
                      "price": 4.9,
                      "size": 2631.66
                    },
                    {
                      "price": 5,
                      "size": 787.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 414464,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.27,
                      "size": 6108.4
                    },
                    {
                      "price": 1.26,
                      "size": 6347.78
                    },
                    {
                      "price": 1.25,
                      "size": 7067.28
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.28,
                      "size": 3433.32
                    },
                    {
                      "price": 1.29,
                      "size": 13988.52
                    },
                    {
                      "price": 1.3,
                      "size": 6351.43
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 300000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90811,
          "sport_id": 4,
          "league_id": 657,
          "event_id": 32566505,
          "market_id": "1.217238658",
          "event_name": "Jamaica Tallawahs v Barbados Royals",
          "slug": "jamaica-tallawahs-v-barbados-royals-30",
          "runners": [
            "Jamaica Tallawahs",
            "Barbados Royals"
          ],
          "event_date": "2023-08-20T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692540000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 40743171,
          "is_deleted": 0,
          "league_name": "Caribbean Premier League",
          "league_slug": "caribbean-premier-league",
          "league_code": 11416933,
          "markets": [],
          "main_market": {
            "id": 645467,
            "match_id": 90811,
            "event_id": 32566505,
            "market_id": "1.217238658",
            "market_name": "Match Odds",
            "runners": "[\"Jamaica Tallawahs\",\"Barbados Royals\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"Jamaica Tallawahs\",\"selection_id\":7591874},{\"runner_name\":\"Barbados Royals\",\"selection_id\":40497467}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217238658",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 7591874,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.75,
                      "size": 39.9
                    },
                    {
                      "price": 1.72,
                      "size": 1093.67
                    },
                    {
                      "price": 1.66,
                      "size": 30.04
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.79,
                      "size": 783.49
                    },
                    {
                      "price": 1.9,
                      "size": 523.65
                    },
                    {
                      "price": 1.94,
                      "size": 523.65
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 40497467,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.28,
                      "size": 615.11
                    },
                    {
                      "price": 2.1,
                      "size": 473.77
                    },
                    {
                      "price": 2.06,
                      "size": 493.14
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.34,
                      "size": 29.84
                    },
                    {
                      "price": 2.4,
                      "size": 783.8
                    },
                    {
                      "price": 2.5,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90815,
          "sport_id": 4,
          "league_id": 608,
          "event_id": 32567402,
          "market_id": "1.217251406",
          "event_name": "Welsh Fire v London Spirit",
          "slug": "welsh-fire-v-london-spirit",
          "runners": [
            "Welsh Fire",
            "London Spirit"
          ],
          "event_date": "2023-08-20T17:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692550800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38927971,
          "is_deleted": 0,
          "league_name": "The Hundred",
          "league_slug": "the-hundred",
          "league_code": 12267948,
          "markets": [],
          "main_market": {
            "id": 645479,
            "match_id": 90815,
            "event_id": 32567402,
            "market_id": "1.217251406",
            "market_name": "Match Odds",
            "runners": "[\"Welsh Fire\",\"London Spirit\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"Welsh Fire\",\"selection_id\":26354927},{\"runner_name\":\"London Spirit\",\"selection_id\":26354928}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217251406",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 26354927,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.81,
                      "size": 77.86
                    },
                    {
                      "price": 1.8,
                      "size": 2998.64
                    },
                    {
                      "price": 1.79,
                      "size": 188.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.26,
                      "size": 149.61
                    },
                    {
                      "price": 2.44,
                      "size": 69.49
                    },
                    {
                      "price": 36,
                      "size": 356.4
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 26354928,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.79,
                      "size": 188.9
                    },
                    {
                      "price": 1.7,
                      "size": 99.74
                    },
                    {
                      "price": 1.04,
                      "size": 106.32
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.24,
                      "size": 62.91
                    },
                    {
                      "price": 2.26,
                      "size": 2537.91
                    },
                    {
                      "price": 2.44,
                      "size": 69.49
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90812,
          "sport_id": 4,
          "league_id": 657,
          "event_id": 32567004,
          "market_id": "1.217245484",
          "event_name": "St Lucia Kings v St Kitts and Nevis Patriots",
          "slug": "st-lucia-kings-v-st-kitts-and-nevis-patriots",
          "runners": [
            "St Lucia Kings",
            "St Kitts & Nevis Patriots"
          ],
          "event_date": "2023-08-20T23:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692572400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 40743169,
          "is_deleted": 0,
          "league_name": "Caribbean Premier League",
          "league_slug": "caribbean-premier-league",
          "league_code": 11416933,
          "markets": [],
          "main_market": {
            "id": 645470,
            "match_id": 90812,
            "event_id": 32567004,
            "market_id": "1.217245484",
            "market_name": "Match Odds",
            "runners": "[\"St Lucia Kings\",\"St Kitts & Nevis Patriots\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "25",
            "selection_runner": "[{\"runner_name\":\"St Lucia Kings\",\"selection_id\":40497468},{\"runner_name\":\"St Kitts & Nevis Patriots\",\"selection_id\":9665950}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217245484",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 40497468,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.6,
                      "size": 49.08
                    },
                    {
                      "price": 1.35,
                      "size": 191.8
                    },
                    {
                      "price": 1.04,
                      "size": 106.32
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.42,
                      "size": 66.05
                    },
                    {
                      "price": 2.44,
                      "size": 27.8
                    },
                    {
                      "price": 3,
                      "size": 114.7
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 9665950,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.76,
                      "size": 12
                    },
                    {
                      "price": 1.71,
                      "size": 80.48
                    },
                    {
                      "price": 1.7,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.68,
                      "size": 29.65
                    },
                    {
                      "price": 3.9,
                      "size": 66.39
                    },
                    {
                      "price": 110,
                      "size": 102.73
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 90808,
          "sport_id": 4,
          "league_id": 83,
          "event_id": 32568432,
          "market_id": "1.217275171",
          "event_name": "Afghanistan v Pakistan",
          "slug": "afghanistan-v-pakistan-86",
          "runners": [
            "Afghanistan",
            "Pakistan"
          ],
          "event_date": "2023-08-22T08:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692691200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42689979,
          "is_deleted": 0,
          "league_name": "One Day Internationals",
          "league_slug": "one-day-internationals",
          "league_code": 9962116,
          "markets": [],
          "main_market": {
            "id": 645458,
            "match_id": 90808,
            "event_id": 32568432,
            "market_id": "1.217275171",
            "market_name": "Match Odds",
            "runners": "[\"Afghanistan\",\"Pakistan\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "35",
            "selection_runner": "[{\"runner_name\":\"Afghanistan\",\"selection_id\":3786094},{\"runner_name\":\"Pakistan\",\"selection_id\":7461}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217275171",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 3786094,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 39.9
                    },
                    {
                      "price": 1.5,
                      "size": 498.71
                    },
                    {
                      "price": 1.04,
                      "size": 358215.24
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 21,
                      "size": 498.71
                    },
                    {
                      "price": 26,
                      "size": 14328.61
                    },
                    {
                      "price": 36,
                      "size": 10399.67
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7461,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.05,
                      "size": 9974.2
                    },
                    {
                      "price": 1.04,
                      "size": 358215.24
                    },
                    {
                      "price": 1.03,
                      "size": 363483.52
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.5,
                      "size": 79.79
                    },
                    {
                      "price": 3,
                      "size": 249.36
                    },
                    {
                      "price": 26,
                      "size": 14328.61
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 89897,
          "sport_id": 4,
          "league_id": 649,
          "event_id": 32549906,
          "market_id": "1.216976595",
          "event_name": "Pakistan v Nepal",
          "slug": "pakistan-v-nepal",
          "runners": [
            "Pakistan",
            "Nepal"
          ],
          "event_date": "2023-08-30T10:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1693389600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42442837,
          "is_deleted": 0,
          "league_name": "Asia Cup",
          "league_slug": "asia-cup",
          "league_code": 12039039,
          "markets": [],
          "main_market": {
            "id": 640142,
            "match_id": 89897,
            "event_id": 32549906,
            "market_id": "1.216976595",
            "market_name": "Match Odds",
            "runners": "[\"Pakistan\",\"Nepal\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "30",
            "selection_runner": "[{\"runner_name\":\"Pakistan\",\"selection_id\":7461},{\"runner_name\":\"Nepal\",\"selection_id\":2857971}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216976595",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 7461,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.06,
                      "size": 414.73
                    },
                    {
                      "price": 1.05,
                      "size": 247385.39
                    },
                    {
                      "price": 1.04,
                      "size": 249373.15
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.07,
                      "size": 4525.21
                    },
                    {
                      "price": 1.08,
                      "size": 2498.42
                    },
                    {
                      "price": 1.1,
                      "size": 2498.42
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 2857971,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 17,
                      "size": 29.98
                    },
                    {
                      "price": 16,
                      "size": 99.74
                    },
                    {
                      "price": 15,
                      "size": 182.43
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 18,
                      "size": 24.42
                    },
                    {
                      "price": 21,
                      "size": 12369.27
                    },
                    {
                      "price": 26,
                      "size": 9974.93
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 89898,
          "sport_id": 4,
          "league_id": 649,
          "event_id": 32549923,
          "market_id": "1.216977232",
          "event_name": "Bangladesh v Sri Lanka",
          "slug": "bangladesh-v-sri-lanka",
          "runners": [
            "Bangladesh",
            "Sri Lanka"
          ],
          "event_date": "2023-08-31T07:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1693467000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42442861,
          "is_deleted": 0,
          "league_name": "Asia Cup",
          "league_slug": "asia-cup",
          "league_code": 12039039,
          "markets": [],
          "main_market": {
            "id": 640145,
            "match_id": 89898,
            "event_id": 32549923,
            "market_id": "1.216977232",
            "market_name": "Match Odds",
            "runners": "[\"Bangladesh\",\"Sri Lanka\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "30",
            "selection_runner": "[{\"runner_name\":\"Bangladesh\",\"selection_id\":7659},{\"runner_name\":\"Sri Lanka\",\"selection_id\":7337}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216977232",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 7659,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.88,
                      "size": 26.02
                    },
                    {
                      "price": 2.76,
                      "size": 223.62
                    },
                    {
                      "price": 1.1,
                      "size": 249364.97
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.94,
                      "size": 391.45
                    },
                    {
                      "price": 11,
                      "size": 24935.5
                    },
                    {
                      "price": 12.5,
                      "size": 21743.76
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7337,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.52,
                      "size": 757.14
                    },
                    {
                      "price": 1.1,
                      "size": 249355
                    },
                    {
                      "price": 1.09,
                      "size": 249355
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.53,
                      "size": 48.97
                    },
                    {
                      "price": 1.57,
                      "size": 393.12
                    },
                    {
                      "price": 11,
                      "size": 24942.45
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        },
        {
          "id": 89899,
          "sport_id": 4,
          "league_id": 649,
          "event_id": 32549927,
          "market_id": "1.216977303",
          "event_name": "Pakistan v India",
          "slug": "pakistan-v-india",
          "runners": [
            "Pakistan",
            "India"
          ],
          "event_date": "2023-09-02T07:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1693639800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42144191,
          "is_deleted": 0,
          "league_name": "Asia Cup",
          "league_slug": "asia-cup",
          "league_code": 12039039,
          "markets": [],
          "main_market": {
            "id": 640148,
            "match_id": 89899,
            "event_id": 32549927,
            "market_id": "1.216977303",
            "market_name": "Match Odds",
            "runners": "[\"Pakistan\",\"India\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "30",
            "selection_runner": "[{\"runner_name\":\"Pakistan\",\"selection_id\":7461},{\"runner_name\":\"India\",\"selection_id\":414464}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216977303",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 7461,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.14,
                      "size": 33.12
                    },
                    {
                      "price": 1.29,
                      "size": 76.89
                    },
                    {
                      "price": 1.1,
                      "size": 249355
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.5,
                      "size": 296.85
                    },
                    {
                      "price": 2.52,
                      "size": 1975.3
                    },
                    {
                      "price": 2.6,
                      "size": 4222.34
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 414464,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.67,
                      "size": 189.06
                    },
                    {
                      "price": 1.66,
                      "size": 3255.51
                    },
                    {
                      "price": 1.63,
                      "size": 6735.02
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.87,
                      "size": 37.9
                    },
                    {
                      "price": 4.4,
                      "size": 22.54
                    },
                    {
                      "price": 11,
                      "size": 24935.5
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 1,
          "fancies_count": 0
        }
      ]
    },
    {
      "id": 2,
      "is_custom": 0,
      "sportId": 2,
      "name": "Tennis",
      "slug": "tennis",
      "sport_icon": "60ae83d9726fb.png",
      "is_deleted": 0,
      "stake_size": {
        "min_match": 100,
        "max_match": 1,
        "min_bookmaker": 100,
        "max_bookmaker": 100000,
        "min_fancy": 100,
        "max_fancy": 100000,
        "currency_stake": "[{\"id\":1,\"stake\":\"1\"},{\"id\":2,\"stake\":\"2\"},{\"id\":3,\"stake\":\"0.04\"},{\"id\":4,\"stake\":\"0.04\"}]",
        "sport_id": 2,
        "updated_at": {
          "$date": {
            "$numberLong": "1657532739119"
          }
        },
        "_id": "61e2e6a8857a7a3716228a67"
      },
      "bet_delay": {
        "match": 4,
        "bookmaker": 2,
        "fancy": 2,
        "sport_id": 2,
        "updated_at": {
          "$date": {
            "$numberLong": "1665765384383"
          }
        },
        "_id": "61e2e6a8857a7a3716228a65"
      },
      "events": [
        {
          "id": 88395,
          "sport_id": 2,
          "league_id": 1193,
          "event_id": 32523382,
          "market_id": "1.216593878",
          "event_name": "Zhukayev v Ivashka",
          "slug": "zhukayev-v-ivashka",
          "runners": [
            "Beibit Zhukayev",
            "Ilya Ivashka"
          ],
          "event_date": "2023-08-02T03:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1690945200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42655965,
          "is_deleted": 0,
          "league_name": "ATP Los Cabos 2023",
          "league_slug": "atp-los-cabos-2023",
          "league_code": 12602225,
          "markets": [],
          "main_market": null,
          "match_setting": null,
          "data": null,
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": null,
          "inplay_stake_limit": null,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 88773,
          "sport_id": 2,
          "league_id": 1186,
          "event_id": 32530036,
          "market_id": "1.216695082",
          "event_name": "Fritz v Murray",
          "slug": "fritz-v-murray",
          "runners": [
            "Taylor Fritz",
            "Andy Murray"
          ],
          "event_date": "2023-08-04T18:22:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1691173320,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42570285,
          "is_deleted": 0,
          "league_name": "ATP Washington 2023",
          "league_slug": "atp-washington-2023",
          "league_code": 12602029,
          "markets": [],
          "main_market": null,
          "match_setting": null,
          "data": null,
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": null,
          "inplay_stake_limit": null,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90781,
          "sport_id": 2,
          "league_id": 1208,
          "event_id": 32566507,
          "market_id": "1.217238579",
          "event_name": "Cash/Patten v Galloway/Smith",
          "slug": "cashpatten-v-gallowaysmith",
          "runners": [
            "Cash/Patten",
            "Galloway/Smith"
          ],
          "event_date": "2023-08-18T22:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 1,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692396000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42852139,
          "is_deleted": 0,
          "league_name": "Stanford Challenger 2023",
          "league_slug": "stanford-challenger-2023",
          "league_code": 12606750,
          "markets": [],
          "main_market": null,
          "match_setting": null,
          "data": null,
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": null,
          "inplay_stake_limit": null,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90939,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568770,
          "market_id": "1.217278138",
          "event_name": "Frech v Guil Naya",
          "slug": "frech-v-guil-naya",
          "runners": [
            "Magdalena Frech",
            "Guillermina Naya"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646613,
            "match_id": 90939,
            "event_id": 32568770,
            "market_id": "1.217278138",
            "market_name": "Match Odds",
            "runners": "[\"Magdalena Frech\",\"Guillermina Naya\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Magdalena Frech\",\"selection_id\":8444351},{\"runner_name\":\"Guillermina Naya\",\"selection_id\":10141697}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217278138",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 8444351,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 1189.9
                    }
                  ],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10141697,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 1189.9
                    }
                  ],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90944,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568735,
          "market_id": "1.217277670",
          "event_name": "X Wang v Maria Tig",
          "slug": "x-wang-v-maria-tig",
          "runners": [
            "Xinyu Wang",
            "Patricia Maria Tig"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646628,
            "match_id": 90944,
            "event_id": 32568735,
            "market_id": "1.217277670",
            "market_name": "Match Odds",
            "runners": "[\"Xinyu Wang\",\"Patricia Maria Tig\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Xinyu Wang\",\"selection_id\":13578400},{\"runner_name\":\"Patricia Maria Tig\",\"selection_id\":8679189}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277670",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 13578400,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 46157.61
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 11,
                      "size": 232.63
                    },
                    {
                      "price": 12.5,
                      "size": 217.2
                    },
                    {
                      "price": 13.5,
                      "size": 214.93
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 8679189,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.1,
                      "size": 2326.32
                    },
                    {
                      "price": 1.09,
                      "size": 2490.81
                    },
                    {
                      "price": 1.08,
                      "size": 2686.63
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 424.27
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90943,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568740,
          "market_id": "1.217277679",
          "event_name": "Burel v Dala Hewitt",
          "slug": "burel-v-dala-hewitt",
          "runners": [
            "Clara Burel",
            "Dalayna Hewitt"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646625,
            "match_id": 90943,
            "event_id": 32568740,
            "market_id": "1.217277679",
            "market_name": "Match Odds",
            "runners": "[\"Clara Burel\",\"Dalayna Hewitt\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Clara Burel\",\"selection_id\":10351066},{\"runner_name\":\"Dalayna Hewitt\",\"selection_id\":10350465}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277679",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 10351066,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 3612.38
                    },
                    {
                      "price": 1.01,
                      "size": 5372.58
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 49.79
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10350465,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 5372.58
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 55,
                      "size": 66.99
                    },
                    {
                      "price": 110,
                      "size": 49.33
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90942,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568755,
          "market_id": "1.217277928",
          "event_name": "Vict Hu v C Tauson",
          "slug": "vict-hu-v-c-tauson",
          "runners": [
            "Victoria Hu",
            "Clara Tauson"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646622,
            "match_id": 90942,
            "event_id": 32568755,
            "market_id": "1.217277928",
            "market_name": "Match Odds",
            "runners": "[\"Victoria Hu\",\"Clara Tauson\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Victoria Hu\",\"selection_id\":12737380},{\"runner_name\":\"Clara Tauson\",\"selection_id\":18848679}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277928",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 12737380,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 1189.9
                    }
                  ],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 18848679,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 1189.9
                    }
                  ],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90941,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568730,
          "market_id": "1.217277666",
          "event_name": "Perez v Tama Korpatsch",
          "slug": "perez-v-tama-korpatsch",
          "runners": [
            "Ellen Perez",
            "Tamara Korpatsch"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646619,
            "match_id": 90941,
            "event_id": 32568730,
            "market_id": "1.217277666",
            "market_name": "Match Odds",
            "runners": "[\"Ellen Perez\",\"Tamara Korpatsch\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Ellen Perez\",\"selection_id\":9629680},{\"runner_name\":\"Tamara Korpatsch\",\"selection_id\":9166525}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277666",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 9629680,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 44418.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 36,
                      "size": 87.4
                    },
                    {
                      "price": 55,
                      "size": 65.1
                    },
                    {
                      "price": 110,
                      "size": 407.84
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 9166525,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.03,
                      "size": 3054.77
                    },
                    {
                      "price": 1.02,
                      "size": 3510.55
                    },
                    {
                      "price": 1.01,
                      "size": 44418.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 408.31
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90940,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568750,
          "market_id": "1.217277797",
          "event_name": "Asia Muhammad v Sorribes Tormo",
          "slug": "asia-muhammad-v-sorribes-tormo",
          "runners": [
            "Asia Muhammad",
            "Sara Sorribes Tormo"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646616,
            "match_id": 90940,
            "event_id": 32568750,
            "market_id": "1.217277797",
            "market_name": "Match Odds",
            "runners": "[\"Asia Muhammad\",\"Sara Sorribes Tormo\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Asia Muhammad\",\"selection_id\":3288385},{\"runner_name\":\"Sara Sorribes Tormo\",\"selection_id\":6356637}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277797",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 3288385,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 44301.26
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 18,
                      "size": 126.85
                    },
                    {
                      "price": 21,
                      "size": 118.67
                    },
                    {
                      "price": 26,
                      "size": 105.27
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 6356637,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.06,
                      "size": 2154
                    },
                    {
                      "price": 1.05,
                      "size": 2373.32
                    },
                    {
                      "price": 1.04,
                      "size": 2631.8
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 407.23
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90938,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568785,
          "market_id": "1.217277914",
          "event_name": "M Trevisan v Ala Smith",
          "slug": "m-trevisan-v-ala-smith",
          "runners": [
            "Martina Trevisan",
            "Alana Smith"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646610,
            "match_id": 90938,
            "event_id": 32568785,
            "market_id": "1.217277914",
            "market_name": "Match Odds",
            "runners": "[\"Martina Trevisan\",\"Alana Smith\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Martina Trevisan\",\"selection_id\":9345630},{\"runner_name\":\"Alana Smith\",\"selection_id\":10348024}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277914",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 9345630,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 3565.38
                    },
                    {
                      "price": 1.01,
                      "size": 5317.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 49.29
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10348024,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 5317.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 55,
                      "size": 66.12
                    },
                    {
                      "price": 110,
                      "size": 48.83
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90937,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568780,
          "market_id": "1.217278050",
          "event_name": "Podoroska v Erin Routliffe",
          "slug": "podoroska-v-erin-routliffe",
          "runners": [
            "Nadia Podoroska",
            "Erin Routliffe"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646607,
            "match_id": 90937,
            "event_id": 32568780,
            "market_id": "1.217278050",
            "market_name": "Match Odds",
            "runners": "[\"Nadia Podoroska\",\"Erin Routliffe\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Nadia Podoroska\",\"selection_id\":9042349},{\"runner_name\":\"Erin Routliffe\",\"selection_id\":6564412}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217278050",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 9042349,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 44348.25
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 407.66
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 6564412,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 44348.25
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 407.66
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90936,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568745,
          "market_id": "1.217277778",
          "event_name": "Strakhova v Xin Wang",
          "slug": "strakhova-v-xin-wang",
          "runners": [
            "Valeriya Strakhova",
            "Xiyu Wang"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646604,
            "match_id": 90936,
            "event_id": 32568745,
            "market_id": "1.217277778",
            "market_name": "Match Odds",
            "runners": "[\"Valeriya Strakhova\",\"Xiyu Wang\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Valeriya Strakhova\",\"selection_id\":8490642},{\"runner_name\":\"Xiyu Wang\",\"selection_id\":11352357}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277778",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 8490642,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 44426.58
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 15.5,
                      "size": 141.13
                    },
                    {
                      "price": 18,
                      "size": 131
                    },
                    {
                      "price": 21,
                      "size": 122.58
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 11352357,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.07,
                      "size": 2044.34
                    },
                    {
                      "price": 1.06,
                      "size": 2224.5
                    },
                    {
                      "price": 1.05,
                      "size": 2451.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 408.38
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90935,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568775,
          "market_id": "1.217277922",
          "event_name": "Ry Hanford v Loeb",
          "slug": "ry-hanford-v-loeb",
          "runners": [
            "Rylie Hanford",
            "Jamie Loeb"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646601,
            "match_id": 90935,
            "event_id": 32568775,
            "market_id": "1.217277922",
            "market_name": "Match Odds",
            "runners": "[\"Rylie Hanford\",\"Jamie Loeb\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Rylie Hanford\",\"selection_id\":42338207},{\"runner_name\":\"Jamie Loeb\",\"selection_id\":7593252}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277922",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 42338207,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 1189.9
                    }
                  ],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7593252,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 1189.9
                    }
                  ],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90934,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568765,
          "market_id": "1.217277785",
          "event_name": "A Sasnovich v Gan Poznikhirenko",
          "slug": "a-sasnovich-v-gan-poznikhirenko",
          "runners": [
            "Aliaksandra Sasnovich",
            "Ganna Poznikhirenko"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646598,
            "match_id": 90934,
            "event_id": 32568765,
            "market_id": "1.217277785",
            "market_name": "Match Odds",
            "runners": "[\"Aliaksandra Sasnovich\",\"Ganna Poznikhirenko\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Aliaksandra Sasnovich\",\"selection_id\":7283310},{\"runner_name\":\"Ganna Poznikhirenko\",\"selection_id\":9166526}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277785",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 7283310,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 40353.56
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 55,
                      "size": 726.77
                    },
                    {
                      "price": 110,
                      "size": 370.52
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 9166526,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 39188.64
                    },
                    {
                      "price": 1.01,
                      "size": 40353.56
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 370.98
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90933,
          "sport_id": 2,
          "league_id": 1217,
          "event_id": 32568760,
          "market_id": "1.217278054",
          "event_name": "Aney v Fer Contreras Gomez",
          "slug": "aney-v-fer-contreras-gomez",
          "runners": [
            "Jessie Aney",
            "Fernanda Contreras Gome"
          ],
          "event_date": "2023-08-19T00:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692403200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cleveland 2023",
          "league_slug": "wta-cleveland-2023",
          "league_code": 12608696,
          "markets": [],
          "main_market": {
            "id": 646595,
            "match_id": 90933,
            "event_id": 32568760,
            "market_id": "1.217278054",
            "market_name": "Match Odds",
            "runners": "[\"Jessie Aney\",\"Fernanda Contreras Gome\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Jessie Aney\",\"selection_id\":9631481},{\"runner_name\":\"Fernanda Contreras Gome\",\"selection_id\":9632169}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217278054",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 9631481,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.02,
                      "size": 24.98
                    },
                    {
                      "price": 1.01,
                      "size": 4221.17
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 11,
                      "size": 121.41
                    },
                    {
                      "price": 12.5,
                      "size": 113.38
                    },
                    {
                      "price": 13.5,
                      "size": 112.16
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 9632169,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.1,
                      "size": 1214.07
                    },
                    {
                      "price": 1.09,
                      "size": 1300.23
                    },
                    {
                      "price": 1.08,
                      "size": 1402.06
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 110,
                      "size": 39.22
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90806,
          "sport_id": 2,
          "league_id": 1208,
          "event_id": 32566586,
          "market_id": "1.217239128",
          "event_name": "Em Nava v Tr Boyer",
          "slug": "em-nava-v-tr-boyer",
          "runners": [
            "Emilio Nava",
            "Tristan Boyer"
          ],
          "event_date": "2023-08-19T03:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692414000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42851645,
          "is_deleted": 0,
          "league_name": "Stanford Challenger 2023",
          "league_slug": "stanford-challenger-2023",
          "league_code": 12606750,
          "markets": [],
          "main_market": {
            "id": 645452,
            "match_id": 90806,
            "event_id": 32566586,
            "market_id": "1.217239128",
            "market_name": "Match Odds",
            "runners": "[\"Emilio Nava\",\"Tristan Boyer\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Emilio Nava\",\"selection_id\":12646384},{\"runner_name\":\"Tristan Boyer\",\"selection_id\":15134228}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217239128",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 3,
            "inplay": true,
            "runners": [
              {
                "selectionId": 12646384,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.88,
                      "size": 102.53
                    },
                    {
                      "price": 2.38,
                      "size": 299.98
                    },
                    {
                      "price": 2.36,
                      "size": 4346.52
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.15,
                      "size": 25.16
                    },
                    {
                      "price": 3.25,
                      "size": 33.24
                    },
                    {
                      "price": 3.95,
                      "size": 4234.14
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 15134228,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.46,
                      "size": 54.28
                    },
                    {
                      "price": 1.45,
                      "size": 74.5
                    },
                    {
                      "price": 1.34,
                      "size": 12481.22
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.54,
                      "size": 191.75
                    },
                    {
                      "price": 1.73,
                      "size": 6342.59
                    },
                    {
                      "price": 1.75,
                      "size": 8222.9
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": true,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90805,
          "sport_id": 2,
          "league_id": 1209,
          "event_id": 32567907,
          "market_id": "1.217269057",
          "event_name": "Ben Hassan v J De Jong",
          "slug": "ben-hassan-v-j-de-jong",
          "runners": [
            "Benjamin Hassan",
            "Jesper De Jong"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42851353,
          "is_deleted": 0,
          "league_name": "Grodzisk Mazowiecki Challenger 2023",
          "league_slug": "grodzisk-mazowiecki-challenger-2023",
          "league_code": 12606894,
          "markets": [],
          "main_market": {
            "id": 645449,
            "match_id": 90805,
            "event_id": 32567907,
            "market_id": "1.217269057",
            "market_name": "Match Odds",
            "runners": "[\"Benjamin Hassan\",\"Jesper De Jong\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Benjamin Hassan\",\"selection_id\":9631799},{\"runner_name\":\"Jesper De Jong\",\"selection_id\":13426866}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217269057",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 9631799,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.86,
                      "size": 402.5
                    },
                    {
                      "price": 2.84,
                      "size": 538.31
                    },
                    {
                      "price": 2.72,
                      "size": 579.33
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.9,
                      "size": 120.19
                    },
                    {
                      "price": 3,
                      "size": 486.46
                    },
                    {
                      "price": 3.05,
                      "size": 485.74
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 13426866,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.52,
                      "size": 229.31
                    },
                    {
                      "price": 1.5,
                      "size": 972.91
                    },
                    {
                      "price": 1.48,
                      "size": 2340.16
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.54,
                      "size": 747.5
                    },
                    {
                      "price": 1.55,
                      "size": 986.32
                    },
                    {
                      "price": 1.58,
                      "size": 997.32
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90929,
          "sport_id": 2,
          "league_id": 1205,
          "event_id": 32568652,
          "market_id": "1.217277432",
          "event_name": "Carlos Alcaraz v Hurkacz",
          "slug": "carlos-alcaraz-v-hurkacz-15",
          "runners": [
            "Carlos Alcaraz",
            "Hubert Hurkacz"
          ],
          "event_date": "2023-08-19T15:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692457200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "ATP Cincinnati 2023",
          "league_slug": "atp-cincinnati-2023",
          "league_code": 12606532,
          "markets": [],
          "main_market": {
            "id": 646583,
            "match_id": 90929,
            "event_id": 32568652,
            "market_id": "1.217277432",
            "market_name": "Match Odds",
            "runners": "[\"Carlos Alcaraz\",\"Hubert Hurkacz\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Carlos Alcaraz\",\"selection_id\":25215583},{\"runner_name\":\"Hubert Hurkacz\",\"selection_id\":19924838}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277432",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 25215583,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.44,
                      "size": 1645.46
                    },
                    {
                      "price": 1.43,
                      "size": 1002.3
                    },
                    {
                      "price": 1.42,
                      "size": 6465.33
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.45,
                      "size": 3138.21
                    },
                    {
                      "price": 1.46,
                      "size": 6723.8
                    },
                    {
                      "price": 1.47,
                      "size": 7204.21
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 19924838,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.25,
                      "size": 221.63
                    },
                    {
                      "price": 3.2,
                      "size": 1833.09
                    },
                    {
                      "price": 3.15,
                      "size": 3455.25
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.3,
                      "size": 963.88
                    },
                    {
                      "price": 3.35,
                      "size": 441.49
                    },
                    {
                      "price": 3.4,
                      "size": 2448.15
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90930,
          "sport_id": 2,
          "league_id": 1206,
          "event_id": 32568523,
          "market_id": "1.217275613",
          "event_name": "I Swiatek v C Gauff",
          "slug": "i-swiatek-v-c-gauff-37",
          "runners": [
            "I Swiatek",
            "Coco Gauff"
          ],
          "event_date": "2023-08-19T15:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692457200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "WTA Cincinnati 2023",
          "league_slug": "wta-cincinnati-2023",
          "league_code": 12606606,
          "markets": [],
          "main_market": {
            "id": 646586,
            "match_id": 90930,
            "event_id": 32568523,
            "market_id": "1.217275613",
            "market_name": "Match Odds",
            "runners": "[\"I Swiatek\",\"Coco Gauff\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"I Swiatek\",\"selection_id\":55228386},{\"runner_name\":\"Coco Gauff\",\"selection_id\":27552403}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217275613",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 55228386,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.4,
                      "size": 270.67
                    },
                    {
                      "price": 1.39,
                      "size": 588.42
                    },
                    {
                      "price": 1.38,
                      "size": 1133.02
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.41,
                      "size": 124.79
                    },
                    {
                      "price": 1.42,
                      "size": 6456.36
                    },
                    {
                      "price": 1.43,
                      "size": 21479.11
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 27552403,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.4,
                      "size": 51.75
                    },
                    {
                      "price": 3.35,
                      "size": 3452.55
                    },
                    {
                      "price": 3.3,
                      "size": 8839.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.5,
                      "size": 108.27
                    },
                    {
                      "price": 3.6,
                      "size": 661.52
                    },
                    {
                      "price": 3.65,
                      "size": 997.32
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90932,
          "sport_id": 2,
          "league_id": 1213,
          "event_id": 32568687,
          "market_id": "1.217277621",
          "event_name": "Ry Peniston v Riedi",
          "slug": "ry-peniston-v-riedi",
          "runners": [
            "Ryan Peniston",
            "Leandro Riedi"
          ],
          "event_date": "2023-08-19T16:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692460800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Winnipeg Challenger 2023",
          "league_slug": "winnipeg-challenger-2023",
          "league_code": 12607095,
          "markets": [],
          "main_market": {
            "id": 646592,
            "match_id": 90932,
            "event_id": 32568687,
            "market_id": "1.217277621",
            "market_name": "Match Odds",
            "runners": "[\"Ryan Peniston\",\"Leandro Riedi\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Ryan Peniston\",\"selection_id\":9629249},{\"runner_name\":\"Leandro Riedi\",\"selection_id\":28081306}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277621",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 9629249,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.24,
                      "size": 5524.81
                    },
                    {
                      "price": 2.14,
                      "size": 3030.13
                    },
                    {
                      "price": 2,
                      "size": 21.4
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.48,
                      "size": 997.32
                    },
                    {
                      "price": 2.5,
                      "size": 159.59
                    },
                    {
                      "price": 2.52,
                      "size": 8491.33
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 28081306,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.67,
                      "size": 1481.05
                    },
                    {
                      "price": 1.66,
                      "size": 13130.8
                    },
                    {
                      "price": 1.61,
                      "size": 249.36
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.81,
                      "size": 6837.33
                    },
                    {
                      "price": 1.87,
                      "size": 3467.63
                    },
                    {
                      "price": 2,
                      "size": 21.4
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90931,
          "sport_id": 2,
          "league_id": 1210,
          "event_id": 32568659,
          "market_id": "1.217277560",
          "event_name": "Cl Tabur v Darderi",
          "slug": "cl-tabur-v-darderi",
          "runners": [
            "Clement Tabur",
            "Luciano Darderi"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Todi Challenger 2023",
          "league_slug": "todi-challenger-2023",
          "league_code": 12606874,
          "markets": [],
          "main_market": {
            "id": 646589,
            "match_id": 90931,
            "event_id": 32568659,
            "market_id": "1.217277560",
            "market_name": "Match Odds",
            "runners": "[\"Clement Tabur\",\"Luciano Darderi\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 5000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Clement Tabur\",\"selection_id\":10941747},{\"runner_name\":\"Luciano Darderi\",\"selection_id\":26309941}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217277560",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 10941747,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.55,
                      "size": 932
                    },
                    {
                      "price": 2.34,
                      "size": 29.12
                    },
                    {
                      "price": 1.01,
                      "size": 3744.81
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.3,
                      "size": 6385.51
                    },
                    {
                      "price": 4.5,
                      "size": 997.32
                    },
                    {
                      "price": 5.4,
                      "size": 39.16
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 26309941,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.31,
                      "size": 20960.08
                    },
                    {
                      "price": 1.28,
                      "size": 3506.2
                    },
                    {
                      "price": 1.22,
                      "size": 173.35
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.39,
                      "size": 997.32
                    },
                    {
                      "price": 1.4,
                      "size": 1373.09
                    },
                    {
                      "price": 1.74,
                      "size": 39.16
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 5000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        }
      ]
    },
    {
      "id": 1,
      "is_custom": 0,
      "sportId": 1,
      "name": "Soccer",
      "slug": "soccer",
      "sport_icon": "60eed362a0e2b.png",
      "is_deleted": 0,
      "stake_size": {
        "min_match": 100,
        "max_match": 1,
        "min_bookmaker": 100,
        "max_bookmaker": 200000,
        "min_fancy": 100,
        "max_fancy": 100000,
        "currency_stake": "[{\"id\":1,\"stake\":\"1\"},{\"id\":2,\"stake\":\"2\"},{\"id\":3,\"stake\":\"0.04\"},{\"id\":4,\"stake\":\"0.04\"}]",
        "sport_id": 1,
        "updated_at": {
          "$date": {
            "$numberLong": "1669460828634"
          }
        },
        "_id": "61e2e6a8857a7a3716228a64"
      },
      "bet_delay": {
        "match": 4,
        "bookmaker": 1,
        "fancy": 1,
        "sport_id": 1,
        "updated_at": {
          "$date": {
            "$numberLong": "1670409490967"
          }
        },
        "_id": "61e2e6a8857a7a3716228a62"
      },
      "events": [
        {
          "id": 90926,
          "sport_id": 1,
          "league_id": 216,
          "event_id": 32566949,
          "market_id": "1.217244221",
          "event_name": "Caja Oblatos C.FD v Canoneros Marina",
          "slug": "caja-oblatos-cfd-v-canoneros-marina",
          "runners": [
            "Caja Oblatos C.FD",
            "Canoneros Marina",
            "The Draw"
          ],
          "event_date": "2023-08-18T16:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692374400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42646371,
          "is_deleted": 0,
          "league_name": "Mexican Segunda Division",
          "league_slug": "mexican-segunda-division",
          "league_code": 12201163,
          "markets": [],
          "main_market": {
            "id": 646571,
            "match_id": 90926,
            "event_id": 32566949,
            "market_id": "1.217244221",
            "market_name": "Match Odds",
            "runners": "[\"Caja Oblatos C.FD\",\"Canoneros Marina\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Caja Oblatos C.FD\",\"selection_id\":53205996},{\"runner_name\":\"Canoneros Marina\",\"selection_id\":21637050},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217244221",
            "status": "CLOSED",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 53205996,
                "status": "REMOVED",
                "ex": {
                  "availableToBack": [],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 21637050,
                "status": "REMOVED",
                "ex": {
                  "availableToBack": [],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "REMOVED",
                "ex": {
                  "availableToBack": [],
                  "availableToLay": [],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90922,
          "sport_id": 1,
          "league_id": 1170,
          "event_id": 32562569,
          "market_id": "1.217185118",
          "event_name": "Sweden (W) v Australia (W)",
          "slug": "sweden-w-v-australia-w",
          "runners": [
            "Sweden (W)",
            "Australia (W)",
            "The Draw"
          ],
          "event_date": "2023-08-19T08:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692432000,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 36887589,
          "is_deleted": 0,
          "league_name": "FIFA Women's World Cup",
          "league_slug": "fifa-womens-world-cup",
          "league_code": 12220485,
          "markets": [],
          "main_market": {
            "id": 646542,
            "match_id": 90922,
            "event_id": 32562569,
            "market_id": "1.217185118",
            "market_name": "Match Odds",
            "runners": "[\"Sweden (W)\",\"Australia (W)\",\"The Draw\"]",
            "stake_limit": 10000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Sweden (W)\",\"selection_id\":541860},{\"runner_name\":\"Australia (W)\",\"selection_id\":541865},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217185118",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 541860,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.52,
                      "size": 796.79
                    },
                    {
                      "price": 2.5,
                      "size": 12790.78
                    },
                    {
                      "price": 2.48,
                      "size": 8976.76
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.54,
                      "size": 3408.26
                    },
                    {
                      "price": 2.56,
                      "size": 6287.63
                    },
                    {
                      "price": 2.58,
                      "size": 9805.47
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 541865,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 924.24
                    },
                    {
                      "price": 2.98,
                      "size": 2998.07
                    },
                    {
                      "price": 2.96,
                      "size": 9144.44
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 7988.97
                    },
                    {
                      "price": 3.1,
                      "size": 11042.47
                    },
                    {
                      "price": 3.15,
                      "size": 22584.1
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.65,
                      "size": 2655.37
                    },
                    {
                      "price": 3.6,
                      "size": 12915.7
                    },
                    {
                      "price": 3.55,
                      "size": 25271.62
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.7,
                      "size": 2852.14
                    },
                    {
                      "price": 3.75,
                      "size": 6563.28
                    },
                    {
                      "price": 3.8,
                      "size": 16892.96
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 10000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90906,
          "sport_id": 1,
          "league_id": 211,
          "event_id": 32565815,
          "market_id": "1.217231553",
          "event_name": "RANS Nusantara FC v Dewa United FC",
          "slug": "rans-nusantara-fc-v-dewa-united-fc-44",
          "runners": [
            "RANS Nusantara FC",
            "Dewa United FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T08:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692432000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41960883,
          "is_deleted": 0,
          "league_name": "Indonesian Liga 1",
          "league_slug": "indonesian-liga-1",
          "league_code": 12006302,
          "markets": [],
          "main_market": {
            "id": 646382,
            "match_id": 90906,
            "event_id": 32565815,
            "market_id": "1.217231553",
            "market_name": "Match Odds",
            "runners": "[\"RANS Nusantara FC\",\"Dewa United FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"RANS Nusantara FC\",\"selection_id\":52729394},{\"runner_name\":\"Dewa United FC\",\"selection_id\":48145055},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217231553",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 52729394,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.26,
                      "size": 121.19
                    },
                    {
                      "price": 2.22,
                      "size": 34.71
                    },
                    {
                      "price": 2.2,
                      "size": 69.82
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.34,
                      "size": 114.9
                    },
                    {
                      "price": 2.36,
                      "size": 49.87
                    },
                    {
                      "price": 2.38,
                      "size": 299.62
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 48145055,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.25,
                      "size": 79.1
                    },
                    {
                      "price": 3.2,
                      "size": 39.9
                    },
                    {
                      "price": 3.15,
                      "size": 215.74
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.5,
                      "size": 26.93
                    },
                    {
                      "price": 3.55,
                      "size": 117.05
                    },
                    {
                      "price": 3.6,
                      "size": 214.05
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.65,
                      "size": 212.45
                    },
                    {
                      "price": 3.6,
                      "size": 268.48
                    },
                    {
                      "price": 3.55,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.95,
                      "size": 59.25
                    },
                    {
                      "price": 4,
                      "size": 121.29
                    },
                    {
                      "price": 4.1,
                      "size": 96.72
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90907,
          "sport_id": 1,
          "league_id": 211,
          "event_id": 32565811,
          "market_id": "1.217231643",
          "event_name": "PS TIRA v Madura Utd",
          "slug": "ps-tira-v-madura-utd-72",
          "runners": [
            "PS TIRA",
            "Madura Utd",
            "The Draw"
          ],
          "event_date": "2023-08-19T08:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692432000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41960885,
          "is_deleted": 0,
          "league_name": "Indonesian Liga 1",
          "league_slug": "indonesian-liga-1",
          "league_code": 12006302,
          "markets": [],
          "main_market": {
            "id": 646392,
            "match_id": 90907,
            "event_id": 32565811,
            "market_id": "1.217231643",
            "market_name": "Match Odds",
            "runners": "[\"PS TIRA\",\"Madura Utd\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"PS TIRA\",\"selection_id\":25066834},{\"runner_name\":\"Madura Utd\",\"selection_id\":11195376},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217231643",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 25066834,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.3,
                      "size": 66.33
                    },
                    {
                      "price": 3.2,
                      "size": 27.53
                    },
                    {
                      "price": 3.15,
                      "size": 69.82
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.45,
                      "size": 261.39
                    },
                    {
                      "price": 3.5,
                      "size": 61.82
                    },
                    {
                      "price": 3.55,
                      "size": 133.39
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 11195376,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.28,
                      "size": 28.93
                    },
                    {
                      "price": 2.26,
                      "size": 181.03
                    },
                    {
                      "price": 2.24,
                      "size": 306.91
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.36,
                      "size": 89.25
                    },
                    {
                      "price": 2.38,
                      "size": 46.69
                    },
                    {
                      "price": 2.42,
                      "size": 86.27
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.7,
                      "size": 29.12
                    },
                    {
                      "price": 3.65,
                      "size": 228.58
                    },
                    {
                      "price": 3.6,
                      "size": 58.65
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.9,
                      "size": 116.65
                    },
                    {
                      "price": 3.95,
                      "size": 201.3
                    },
                    {
                      "price": 4,
                      "size": 101.34
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90849,
          "sport_id": 1,
          "league_id": 58,
          "event_id": 32553306,
          "market_id": "1.217029715",
          "event_name": "Kashima v Tosu",
          "slug": "kashima-v-tosu",
          "runners": [
            "Kashima",
            "Tosu",
            "The Draw"
          ],
          "event_date": "2023-08-19T09:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692435600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38871953,
          "is_deleted": 0,
          "league_name": "Japanese J League",
          "league_slug": "japanese-j-league",
          "league_code": 89,
          "markets": [],
          "main_market": {
            "id": 645812,
            "match_id": 90849,
            "event_id": 32553306,
            "market_id": "1.217029715",
            "market_name": "Match Odds",
            "runners": "[\"Kashima\",\"Tosu\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Kashima\",\"selection_id\":441079},{\"runner_name\":\"Tosu\",\"selection_id\":3455676},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217029715",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 441079,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.72,
                      "size": 1303.53
                    },
                    {
                      "price": 1.71,
                      "size": 1640.96
                    },
                    {
                      "price": 1.7,
                      "size": 5477.47
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.75,
                      "size": 110.09
                    },
                    {
                      "price": 1.76,
                      "size": 365.8
                    },
                    {
                      "price": 1.77,
                      "size": 969
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 3455676,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.3,
                      "size": 152.63
                    },
                    {
                      "price": 5.2,
                      "size": 513.38
                    },
                    {
                      "price": 5.1,
                      "size": 1228.78
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.5,
                      "size": 428.89
                    },
                    {
                      "price": 5.6,
                      "size": 473.77
                    },
                    {
                      "price": 5.7,
                      "size": 1601.13
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.1,
                      "size": 13.12
                    },
                    {
                      "price": 4,
                      "size": 3229.27
                    },
                    {
                      "price": 3.95,
                      "size": 457.49
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 3020.88
                    },
                    {
                      "price": 4.5,
                      "size": 1012.16
                    },
                    {
                      "price": 4.6,
                      "size": 720.23
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90824,
          "sport_id": 1,
          "league_id": 56,
          "event_id": 32555475,
          "market_id": "1.217067084",
          "event_name": "Mafra v Pacos Ferreira",
          "slug": "mafra-v-pacos-ferreira",
          "runners": [
            "Mafra",
            "Pacos Ferreira",
            "The Draw"
          ],
          "event_date": "2023-08-19T10:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692439200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42146995,
          "is_deleted": 0,
          "league_name": "Portuguese Segunda Liga",
          "league_slug": "portuguese-segunda-liga",
          "league_code": 9513,
          "markets": [],
          "main_market": {
            "id": 645562,
            "match_id": 90824,
            "event_id": 32555475,
            "market_id": "1.217067084",
            "market_name": "Match Odds",
            "runners": "[\"Mafra\",\"Pacos Ferreira\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "7",
            "selection_runner": "[{\"runner_name\":\"Mafra\",\"selection_id\":2268747},{\"runner_name\":\"Pacos Ferreira\",\"selection_id\":48787},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217067084",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 2268747,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.88,
                      "size": 76.76
                    },
                    {
                      "price": 2.86,
                      "size": 59.85
                    },
                    {
                      "price": 2.84,
                      "size": 563.24
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 195.58
                    },
                    {
                      "price": 3.1,
                      "size": 708.6
                    },
                    {
                      "price": 3.15,
                      "size": 200.22
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 48787,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.58,
                      "size": 136.99
                    },
                    {
                      "price": 2.56,
                      "size": 79.79
                    },
                    {
                      "price": 2.54,
                      "size": 69.82
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.7,
                      "size": 122.68
                    },
                    {
                      "price": 2.72,
                      "size": 647.43
                    },
                    {
                      "price": 2.74,
                      "size": 69.82
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.45,
                      "size": 34.91
                    },
                    {
                      "price": 3.4,
                      "size": 623.99
                    },
                    {
                      "price": 3.35,
                      "size": 89.77
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.65,
                      "size": 142.33
                    },
                    {
                      "price": 3.7,
                      "size": 72.31
                    },
                    {
                      "price": 3.75,
                      "size": 461.87
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90850,
          "sport_id": 1,
          "league_id": 58,
          "event_id": 32543556,
          "market_id": "1.216894468",
          "event_name": "Kobe v Kashiwa",
          "slug": "kobe-v-kashiwa-41",
          "runners": [
            "Kobe",
            "Kashiwa",
            "The Draw"
          ],
          "event_date": "2023-08-19T10:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692439200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38871961,
          "is_deleted": 0,
          "league_name": "Japanese J League",
          "league_slug": "japanese-j-league",
          "league_code": 89,
          "markets": [],
          "main_market": {
            "id": 645822,
            "match_id": 90850,
            "event_id": 32543556,
            "market_id": "1.216894468",
            "market_name": "Match Odds",
            "runners": "[\"Kobe\",\"Kashiwa\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Kobe\",\"selection_id\":441082},{\"runner_name\":\"Kashiwa\",\"selection_id\":441080},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216894468",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 441082,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.81,
                      "size": 882.89
                    },
                    {
                      "price": 1.8,
                      "size": 368.7
                    },
                    {
                      "price": 1.79,
                      "size": 1337.83
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.82,
                      "size": 99.74
                    },
                    {
                      "price": 1.83,
                      "size": 849.1
                    },
                    {
                      "price": 1.84,
                      "size": 837.31
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 441080,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5,
                      "size": 228.92
                    },
                    {
                      "price": 4.9,
                      "size": 2833.21
                    },
                    {
                      "price": 4.8,
                      "size": 854.81
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.2,
                      "size": 867.08
                    },
                    {
                      "price": 5.3,
                      "size": 454.23
                    },
                    {
                      "price": 5.4,
                      "size": 2450.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.9,
                      "size": 79.75
                    },
                    {
                      "price": 3.85,
                      "size": 1726.18
                    },
                    {
                      "price": 3.8,
                      "size": 758.01
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4,
                      "size": 83.78
                    },
                    {
                      "price": 4.1,
                      "size": 310.42
                    },
                    {
                      "price": 4.2,
                      "size": 2408.53
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90851,
          "sport_id": 1,
          "league_id": 58,
          "event_id": 32552844,
          "market_id": "1.217023762",
          "event_name": "Kyoto v Sapporo",
          "slug": "kyoto-v-sapporo",
          "runners": [
            "Kyoto",
            "Sapporo",
            "The Draw"
          ],
          "event_date": "2023-08-19T10:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692439200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38871957,
          "is_deleted": 0,
          "league_name": "Japanese J League",
          "league_slug": "japanese-j-league",
          "league_code": 89,
          "markets": [],
          "main_market": {
            "id": 645832,
            "match_id": 90851,
            "event_id": 32552844,
            "market_id": "1.217023762",
            "market_name": "Match Odds",
            "runners": "[\"Kyoto\",\"Sapporo\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Kyoto\",\"selection_id\":441085},{\"runner_name\":\"Sapporo\",\"selection_id\":2245760},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217023762",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 441085,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.3,
                      "size": 1309.52
                    },
                    {
                      "price": 3.25,
                      "size": 73.16
                    },
                    {
                      "price": 3.2,
                      "size": 166.37
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 385.6
                    },
                    {
                      "price": 3.4,
                      "size": 3174.75
                    },
                    {
                      "price": 3.45,
                      "size": 841.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 2245760,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.18,
                      "size": 1587.19
                    },
                    {
                      "price": 2.16,
                      "size": 3652.77
                    },
                    {
                      "price": 2.14,
                      "size": 4163.44
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.22,
                      "size": 38.03
                    },
                    {
                      "price": 2.24,
                      "size": 117.36
                    },
                    {
                      "price": 2.26,
                      "size": 1813.21
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.1,
                      "size": 20.35
                    },
                    {
                      "price": 4,
                      "size": 54.8
                    },
                    {
                      "price": 3.95,
                      "size": 734.53
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.2,
                      "size": 1799.8
                    },
                    {
                      "price": 4.3,
                      "size": 2188.5
                    },
                    {
                      "price": 4.4,
                      "size": 531.34
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90852,
          "sport_id": 1,
          "league_id": 58,
          "event_id": 32553670,
          "market_id": "1.217036611",
          "event_name": "Hiroshima v Kawasaki",
          "slug": "hiroshima-v-kawasaki",
          "runners": [
            "Hiroshima",
            "Kawasaki",
            "The Draw"
          ],
          "event_date": "2023-08-19T10:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692439200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38871963,
          "is_deleted": 0,
          "league_name": "Japanese J League",
          "league_slug": "japanese-j-league",
          "league_code": 89,
          "markets": [],
          "main_market": {
            "id": 645842,
            "match_id": 90852,
            "event_id": 32553670,
            "market_id": "1.217036611",
            "market_name": "Match Odds",
            "runners": "[\"Hiroshima\",\"Kawasaki\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Hiroshima\",\"selection_id\":744103},{\"runner_name\":\"Kawasaki\",\"selection_id\":1080507},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217036611",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 744103,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.42,
                      "size": 272.99
                    },
                    {
                      "price": 2.4,
                      "size": 1201.79
                    },
                    {
                      "price": 2.38,
                      "size": 1221
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.48,
                      "size": 930.59
                    },
                    {
                      "price": 2.5,
                      "size": 2525.96
                    },
                    {
                      "price": 2.52,
                      "size": 1352.85
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 1080507,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.1,
                      "size": 890.39
                    },
                    {
                      "price": 3.05,
                      "size": 2828.9
                    },
                    {
                      "price": 3,
                      "size": 3335.79
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.2,
                      "size": 263.62
                    },
                    {
                      "price": 3.25,
                      "size": 723.23
                    },
                    {
                      "price": 3.3,
                      "size": 1549.33
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.6,
                      "size": 22.6
                    },
                    {
                      "price": 3.55,
                      "size": 5665.83
                    },
                    {
                      "price": 3.5,
                      "size": 2923.11
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.7,
                      "size": 652.21
                    },
                    {
                      "price": 3.75,
                      "size": 2030.38
                    },
                    {
                      "price": 3.8,
                      "size": 3134.76
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90853,
          "sport_id": 1,
          "league_id": 58,
          "event_id": 32543539,
          "market_id": "1.216894576",
          "event_name": "Yokohama FM v FC Tokyo",
          "slug": "yokohama-fm-v-fc-tokyo",
          "runners": [
            "Yokohama FM",
            "FC Tokyo",
            "The Draw"
          ],
          "event_date": "2023-08-19T10:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692441000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38871965,
          "is_deleted": 0,
          "league_name": "Japanese J League",
          "league_slug": "japanese-j-league",
          "league_code": 89,
          "markets": [],
          "main_market": {
            "id": 645852,
            "match_id": 90853,
            "event_id": 32543539,
            "market_id": "1.216894576",
            "market_name": "Match Odds",
            "runners": "[\"Yokohama FM\",\"FC Tokyo\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Yokohama FM\",\"selection_id\":441087},{\"runner_name\":\"FC Tokyo\",\"selection_id\":350849},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216894576",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 441087,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.72,
                      "size": 1310.41
                    },
                    {
                      "price": 1.71,
                      "size": 1243.83
                    },
                    {
                      "price": 1.7,
                      "size": 1886.56
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.75,
                      "size": 606.39
                    },
                    {
                      "price": 1.76,
                      "size": 1586.65
                    },
                    {
                      "price": 1.77,
                      "size": 2800.78
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 350849,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.6,
                      "size": 1129.93
                    },
                    {
                      "price": 4.5,
                      "size": 877.44
                    },
                    {
                      "price": 4.4,
                      "size": 1663.17
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.9,
                      "size": 2578.18
                    },
                    {
                      "price": 5,
                      "size": 765.2
                    },
                    {
                      "price": 5.1,
                      "size": 916.19
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.7,
                      "size": 241.35
                    },
                    {
                      "price": 4.6,
                      "size": 586.54
                    },
                    {
                      "price": 4.5,
                      "size": 562.7
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.9,
                      "size": 827.33
                    },
                    {
                      "price": 5,
                      "size": 1382.09
                    },
                    {
                      "price": 5.1,
                      "size": 2456.27
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90876,
          "sport_id": 1,
          "league_id": 264,
          "event_id": 32546667,
          "market_id": "1.216931895",
          "event_name": "Skovde Aik v Sundsvall",
          "slug": "skovde-aik-v-sundsvall",
          "runners": [
            "Skovde AIK",
            "Sundsvall",
            "The Draw"
          ],
          "event_date": "2023-08-19T11:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692442800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37899241,
          "is_deleted": 0,
          "league_name": "Swedish Superettan",
          "league_slug": "swedish-superettan",
          "league_code": 12202373,
          "markets": [],
          "main_market": {
            "id": 646082,
            "match_id": 90876,
            "event_id": 32546667,
            "market_id": "1.216931895",
            "market_name": "Match Odds",
            "runners": "[\"Skovde AIK\",\"Sundsvall\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Skovde AIK\",\"selection_id\":14112862},{\"runner_name\":\"Sundsvall\",\"selection_id\":30680},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216931895",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 14112862,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.36,
                      "size": 197.34
                    },
                    {
                      "price": 2.34,
                      "size": 1295.53
                    },
                    {
                      "price": 2.32,
                      "size": 179.65
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.4,
                      "size": 811.8
                    },
                    {
                      "price": 2.42,
                      "size": 40.29
                    },
                    {
                      "price": 2.44,
                      "size": 241.38
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 30680,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 597.35
                    },
                    {
                      "price": 2.98,
                      "size": 137.24
                    },
                    {
                      "price": 2.96,
                      "size": 89.77
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.1,
                      "size": 339.02
                    },
                    {
                      "price": 3.15,
                      "size": 195.43
                    },
                    {
                      "price": 3.2,
                      "size": 1768.74
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.85,
                      "size": 401.96
                    },
                    {
                      "price": 3.8,
                      "size": 1401.81
                    },
                    {
                      "price": 3.75,
                      "size": 248.96
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.95,
                      "size": 74.15
                    },
                    {
                      "price": 4.1,
                      "size": 584.18
                    },
                    {
                      "price": 4.2,
                      "size": 1332.71
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90877,
          "sport_id": 1,
          "league_id": 264,
          "event_id": 32546658,
          "market_id": "1.216931985",
          "event_name": "Landskrona v IK Brage",
          "slug": "landskrona-v-ik-brage",
          "runners": [
            "Landskrona",
            "IK Brage",
            "The Draw"
          ],
          "event_date": "2023-08-19T11:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692442800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37899235,
          "is_deleted": 0,
          "league_name": "Swedish Superettan",
          "league_slug": "swedish-superettan",
          "league_code": 12202373,
          "markets": [],
          "main_market": {
            "id": 646092,
            "match_id": 90877,
            "event_id": 32546658,
            "market_id": "1.216931985",
            "market_name": "Match Odds",
            "runners": "[\"Landskrona\",\"IK Brage\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Landskrona\",\"selection_id\":130432},{\"runner_name\":\"IK Brage\",\"selection_id\":502308},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216931985",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 130432,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.38,
                      "size": 197.89
                    },
                    {
                      "price": 2.36,
                      "size": 199.48
                    },
                    {
                      "price": 2.34,
                      "size": 149.61
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.46,
                      "size": 199.48
                    },
                    {
                      "price": 2.48,
                      "size": 2209.2
                    },
                    {
                      "price": 2.5,
                      "size": 1064.94
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 502308,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.05,
                      "size": 302.02
                    },
                    {
                      "price": 3,
                      "size": 2899.8
                    },
                    {
                      "price": 2.98,
                      "size": 368.96
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.2,
                      "size": 430.29
                    },
                    {
                      "price": 3.25,
                      "size": 207.92
                    },
                    {
                      "price": 3.3,
                      "size": 1251.72
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.7,
                      "size": 24.94
                    },
                    {
                      "price": 3.65,
                      "size": 1042.96
                    },
                    {
                      "price": 3.6,
                      "size": 710.19
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.85,
                      "size": 188.41
                    },
                    {
                      "price": 3.9,
                      "size": 161.18
                    },
                    {
                      "price": 3.95,
                      "size": 714.25
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90847,
          "sport_id": 1,
          "league_id": 19,
          "event_id": 32524116,
          "market_id": "1.216608283",
          "event_name": "Hansa Rostock v Hannover",
          "slug": "hansa-rostock-v-hannover",
          "runners": [
            "Hansa Rostock",
            "Hannover",
            "The Draw"
          ],
          "event_date": "2023-08-19T11:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692442800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42023751,
          "is_deleted": 0,
          "league_name": "German Bundesliga 2",
          "league_slug": "german-bundesliga-2",
          "league_code": 61,
          "markets": [],
          "main_market": {
            "id": 645792,
            "match_id": 90847,
            "event_id": 32524116,
            "market_id": "1.216608283",
            "market_name": "Match Odds",
            "runners": "[\"Hansa Rostock\",\"Hannover\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Hansa Rostock\",\"selection_id\":44524},{\"runner_name\":\"Hannover\",\"selection_id\":197307},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216608283",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 44524,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.54,
                      "size": 273.24
                    },
                    {
                      "price": 2.52,
                      "size": 874.15
                    },
                    {
                      "price": 2.5,
                      "size": 577.36
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.62,
                      "size": 1029.64
                    },
                    {
                      "price": 2.64,
                      "size": 794.31
                    },
                    {
                      "price": 2.66,
                      "size": 2377.25
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 197307,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.86,
                      "size": 191.01
                    },
                    {
                      "price": 2.84,
                      "size": 676.58
                    },
                    {
                      "price": 2.82,
                      "size": 149.61
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.94,
                      "size": 17.55
                    },
                    {
                      "price": 2.96,
                      "size": 506.79
                    },
                    {
                      "price": 2.98,
                      "size": 179.54
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.65,
                      "size": 468.69
                    },
                    {
                      "price": 3.6,
                      "size": 1293.11
                    },
                    {
                      "price": 3.55,
                      "size": 5359.58
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.75,
                      "size": 317.81
                    },
                    {
                      "price": 3.8,
                      "size": 5065.71
                    },
                    {
                      "price": 3.85,
                      "size": 129.66
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90846,
          "sport_id": 1,
          "league_id": 19,
          "event_id": 32522786,
          "market_id": "1.216609995",
          "event_name": "Fortuna Dusseldorf v Paderborn",
          "slug": "fortuna-dusseldorf-v-paderborn",
          "runners": [
            "Fortuna Dusseldorf",
            "Paderborn",
            "The Draw"
          ],
          "event_date": "2023-08-19T11:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692442800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42023743,
          "is_deleted": 0,
          "league_name": "German Bundesliga 2",
          "league_slug": "german-bundesliga-2",
          "league_code": 61,
          "markets": [],
          "main_market": {
            "id": 645782,
            "match_id": 90846,
            "event_id": 32522786,
            "market_id": "1.216609995",
            "market_name": "Match Odds",
            "runners": "[\"Fortuna Dusseldorf\",\"Paderborn\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Fortuna Dusseldorf\",\"selection_id\":879210},{\"runner_name\":\"Paderborn\",\"selection_id\":208035},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216609995",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 879210,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.1,
                      "size": 319.97
                    },
                    {
                      "price": 2.08,
                      "size": 918.24
                    },
                    {
                      "price": 2.06,
                      "size": 1959.74
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.12,
                      "size": 405.56
                    },
                    {
                      "price": 2.14,
                      "size": 1570.33
                    },
                    {
                      "price": 2.16,
                      "size": 3457.62
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 208035,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.6,
                      "size": 75.3
                    },
                    {
                      "price": 3.55,
                      "size": 740.46
                    },
                    {
                      "price": 3.5,
                      "size": 1331.12
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.65,
                      "size": 362.26
                    },
                    {
                      "price": 3.7,
                      "size": 647.63
                    },
                    {
                      "price": 3.75,
                      "size": 2465.82
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 161.08
                    },
                    {
                      "price": 3.95,
                      "size": 4041.04
                    },
                    {
                      "price": 3.9,
                      "size": 654.91
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 355.37
                    },
                    {
                      "price": 4.2,
                      "size": 1335.95
                    },
                    {
                      "price": 4.3,
                      "size": 3017.13
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90845,
          "sport_id": 1,
          "league_id": 19,
          "event_id": 32524115,
          "market_id": "1.216608373",
          "event_name": "Greuther Furth v St Pauli",
          "slug": "greuther-furth-v-st-pauli-33",
          "runners": [
            "Greuther Furth",
            "St Pauli",
            "The Draw"
          ],
          "event_date": "2023-08-19T11:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692442800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42023749,
          "is_deleted": 0,
          "league_name": "German Bundesliga 2",
          "league_slug": "german-bundesliga-2",
          "league_code": 61,
          "markets": [],
          "main_market": {
            "id": 645772,
            "match_id": 90845,
            "event_id": 32524115,
            "market_id": "1.216608373",
            "market_name": "Match Odds",
            "runners": "[\"Greuther Furth\",\"St Pauli\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Greuther Furth\",\"selection_id\":64375},{\"runner_name\":\"St Pauli\",\"selection_id\":44526},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216608373",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 64375,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.72,
                      "size": 676.69
                    },
                    {
                      "price": 2.7,
                      "size": 408.44
                    },
                    {
                      "price": 2.68,
                      "size": 2208.37
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.74,
                      "size": 209.86
                    },
                    {
                      "price": 2.76,
                      "size": 39.9
                    },
                    {
                      "price": 2.78,
                      "size": 124.99
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 44526,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.72,
                      "size": 127.68
                    },
                    {
                      "price": 2.7,
                      "size": 374.28
                    },
                    {
                      "price": 2.68,
                      "size": 263.26
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.78,
                      "size": 765.62
                    },
                    {
                      "price": 2.8,
                      "size": 2343.9
                    },
                    {
                      "price": 2.82,
                      "size": 910.99
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.6,
                      "size": 437.38
                    },
                    {
                      "price": 3.55,
                      "size": 8407.57
                    },
                    {
                      "price": 3.5,
                      "size": 590.02
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.75,
                      "size": 5969.89
                    },
                    {
                      "price": 3.8,
                      "size": 260.59
                    },
                    {
                      "price": 3.85,
                      "size": 242.79
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90827,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555289,
          "market_id": "1.217061441",
          "event_name": "Bolton v Wigan",
          "slug": "bolton-v-wigan",
          "runners": [
            "Bolton",
            "Wigan",
            "The Draw"
          ],
          "event_date": "2023-08-19T11:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692444600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888847,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645594,
            "match_id": 90827,
            "event_id": 32555289,
            "market_id": "1.217061441",
            "market_name": "Match Odds",
            "runners": "[\"Bolton\",\"Wigan\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Bolton\",\"selection_id\":48322},{\"runner_name\":\"Wigan\",\"selection_id\":69746},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217061441",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 48322,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.82,
                      "size": 2178.46
                    },
                    {
                      "price": 1.81,
                      "size": 1422.59
                    },
                    {
                      "price": 1.8,
                      "size": 2054.11
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.83,
                      "size": 263.98
                    },
                    {
                      "price": 1.84,
                      "size": 132.13
                    },
                    {
                      "price": 1.85,
                      "size": 79.95
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 69746,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5,
                      "size": 211.03
                    },
                    {
                      "price": 4.9,
                      "size": 286.24
                    },
                    {
                      "price": 4.8,
                      "size": 237.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.1,
                      "size": 59.85
                    },
                    {
                      "price": 5.2,
                      "size": 676.32
                    },
                    {
                      "price": 5.3,
                      "size": 544.19
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.85,
                      "size": 618.23
                    },
                    {
                      "price": 3.8,
                      "size": 1581.47
                    },
                    {
                      "price": 3.75,
                      "size": 418.18
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.9,
                      "size": 47.73
                    },
                    {
                      "price": 3.95,
                      "size": 314.74
                    },
                    {
                      "price": 4,
                      "size": 1417.76
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90875,
          "sport_id": 1,
          "league_id": 28,
          "event_id": 32567763,
          "market_id": "1.217259922",
          "event_name": "Tottenham U21 v Newcastle U21",
          "slug": "tottenham-u21-v-newcastle-u21",
          "runners": [
            "Tottenham U21",
            "Newcastle U21",
            "The Draw"
          ],
          "event_date": "2023-08-19T12:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692446400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42793699,
          "is_deleted": 0,
          "league_name": "English Premier League 2 - Div 1",
          "league_slug": "english-premier-league-2-div-1",
          "league_code": 12199685,
          "markets": [],
          "main_market": {
            "id": 646072,
            "match_id": 90875,
            "event_id": 32567763,
            "market_id": "1.217259922",
            "market_name": "Match Odds",
            "runners": "[\"Tottenham U21\",\"Newcastle U21\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Tottenham U21\",\"selection_id\":6615322},{\"runner_name\":\"Newcastle U21\",\"selection_id\":6630668},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217259922",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 6615322,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.92,
                      "size": 69.67
                    },
                    {
                      "price": 1.91,
                      "size": 177.79
                    },
                    {
                      "price": 1.89,
                      "size": 15.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.04,
                      "size": 213.19
                    },
                    {
                      "price": 2.06,
                      "size": 1428.03
                    },
                    {
                      "price": 2.08,
                      "size": 19.93
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 6630668,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.2,
                      "size": 16.96
                    },
                    {
                      "price": 3.15,
                      "size": 13.16
                    },
                    {
                      "price": 3.1,
                      "size": 430.06
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.75,
                      "size": 209.51
                    },
                    {
                      "price": 3.8,
                      "size": 491.89
                    },
                    {
                      "price": 3.85,
                      "size": 173.09
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.6,
                      "size": 309.12
                    },
                    {
                      "price": 4.5,
                      "size": 89.03
                    },
                    {
                      "price": 4.3,
                      "size": 129.96
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.6,
                      "size": 87.67
                    },
                    {
                      "price": 5.7,
                      "size": 65.33
                    },
                    {
                      "price": 5.8,
                      "size": 49.69
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90908,
          "sport_id": 1,
          "league_id": 211,
          "event_id": 32566259,
          "market_id": "1.217238492",
          "event_name": "PS Barito Putera v Persik Kediri",
          "slug": "ps-barito-putera-v-persik-kediri",
          "runners": [
            "PS Barito Putera",
            "Persik Kediri",
            "The Draw"
          ],
          "event_date": "2023-08-19T12:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692446400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41960889,
          "is_deleted": 0,
          "league_name": "Indonesian Liga 1",
          "league_slug": "indonesian-liga-1",
          "league_code": 12006302,
          "markets": [],
          "main_market": {
            "id": 646402,
            "match_id": 90908,
            "event_id": 32566259,
            "market_id": "1.217238492",
            "market_name": "Match Odds",
            "runners": "[\"PS Barito Putera\",\"Persik Kediri\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"PS Barito Putera\",\"selection_id\":11802591},{\"runner_name\":\"Persik Kediri\",\"selection_id\":2373015},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217238492",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 11802591,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.89,
                      "size": 24.94
                    },
                    {
                      "price": 1.88,
                      "size": 49.87
                    },
                    {
                      "price": 1.87,
                      "size": 49.87
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.91,
                      "size": 21.8
                    },
                    {
                      "price": 1.96,
                      "size": 66.43
                    },
                    {
                      "price": 1.97,
                      "size": 39.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 2373015,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.1,
                      "size": 123.06
                    },
                    {
                      "price": 4,
                      "size": 19.95
                    },
                    {
                      "price": 3.95,
                      "size": 195.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.5,
                      "size": 86.78
                    },
                    {
                      "price": 4.6,
                      "size": 205.33
                    },
                    {
                      "price": 4.7,
                      "size": 38.17
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 25.53
                    },
                    {
                      "price": 3.95,
                      "size": 228.58
                    },
                    {
                      "price": 3.9,
                      "size": 56.66
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.2,
                      "size": 49.87
                    },
                    {
                      "price": 4.3,
                      "size": 188.01
                    },
                    {
                      "price": 4.4,
                      "size": 29.92
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90909,
          "sport_id": 1,
          "league_id": 211,
          "event_id": 32566260,
          "market_id": "1.217238402",
          "event_name": "Persis Solo v Bali Utd Pusam",
          "slug": "persis-solo-v-bali-utd-pusam-20",
          "runners": [
            "Persis Solo",
            "Bali Utd Pusam",
            "The Draw"
          ],
          "event_date": "2023-08-19T12:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692446400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41960887,
          "is_deleted": 0,
          "league_name": "Indonesian Liga 1",
          "league_slug": "indonesian-liga-1",
          "league_code": 12006302,
          "markets": [],
          "main_market": {
            "id": 646412,
            "match_id": 90909,
            "event_id": 32566260,
            "market_id": "1.217238402",
            "market_name": "Match Odds",
            "runners": "[\"Persis Solo\",\"Bali Utd Pusam\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Persis Solo\",\"selection_id\":9587704},{\"runner_name\":\"Bali Utd Pusam\",\"selection_id\":10228030},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217238402",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 9587704,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.64,
                      "size": 39.9
                    },
                    {
                      "price": 2.62,
                      "size": 39.9
                    },
                    {
                      "price": 2.6,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.82,
                      "size": 61.24
                    },
                    {
                      "price": 2.84,
                      "size": 229.71
                    },
                    {
                      "price": 2.86,
                      "size": 29.92
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10228030,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.6,
                      "size": 39.9
                    },
                    {
                      "price": 2.58,
                      "size": 39.9
                    },
                    {
                      "price": 2.56,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.78,
                      "size": 257.63
                    },
                    {
                      "price": 2.8,
                      "size": 29.92
                    },
                    {
                      "price": 2.82,
                      "size": 29.92
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 181.43
                    },
                    {
                      "price": 3.7,
                      "size": 49.47
                    },
                    {
                      "price": 3.65,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4,
                      "size": 59.85
                    },
                    {
                      "price": 4.1,
                      "size": 49.87
                    },
                    {
                      "price": 4.2,
                      "size": 79.39
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90785,
          "sport_id": 1,
          "league_id": 9,
          "event_id": 32545980,
          "market_id": "1.216922418",
          "event_name": "FC Dornbirn v Admira Wacker",
          "slug": "fc-dornbirn-v-admira-wacker-61",
          "runners": [
            "FC Dornbirn",
            "Admira Wacker",
            "The Draw"
          ],
          "event_date": "2023-08-19T12:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692448200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41967947,
          "is_deleted": 0,
          "league_name": "Austrian Erste Liga",
          "league_slug": "austrian-erste-liga",
          "league_code": 9,
          "markets": [],
          "main_market": {
            "id": 645263,
            "match_id": 90785,
            "event_id": 32545980,
            "market_id": "1.216922418",
            "market_name": "Match Odds",
            "runners": "[\"FC Dornbirn\",\"Admira Wacker\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"FC Dornbirn\",\"selection_id\":14144163},{\"runner_name\":\"Admira Wacker\",\"selection_id\":729699},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216922418",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 14144163,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.15,
                      "size": 138.14
                    },
                    {
                      "price": 3.1,
                      "size": 522.05
                    },
                    {
                      "price": 3.05,
                      "size": 216.54
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.3,
                      "size": 130.2
                    },
                    {
                      "price": 3.35,
                      "size": 100.69
                    },
                    {
                      "price": 3.4,
                      "size": 496.1
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 729699,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.3,
                      "size": 127.34
                    },
                    {
                      "price": 2.28,
                      "size": 89.77
                    },
                    {
                      "price": 2.26,
                      "size": 89.77
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.38,
                      "size": 535.51
                    },
                    {
                      "price": 2.4,
                      "size": 79.79
                    },
                    {
                      "price": 2.42,
                      "size": 113.1
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 27.93
                    },
                    {
                      "price": 3.7,
                      "size": 369.84
                    },
                    {
                      "price": 3.65,
                      "size": 59.85
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.95,
                      "size": 40.24
                    },
                    {
                      "price": 4,
                      "size": 160.58
                    },
                    {
                      "price": 4.1,
                      "size": 1178.43
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90825,
          "sport_id": 1,
          "league_id": 56,
          "event_id": 32555536,
          "market_id": "1.217067629",
          "event_name": "Leiria v Benfica B",
          "slug": "leiria-v-benfica-b",
          "runners": [
            "Leiria",
            "Benfica B",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42147005,
          "is_deleted": 0,
          "league_name": "Portuguese Segunda Liga",
          "league_slug": "portuguese-segunda-liga",
          "league_code": 9513,
          "markets": [],
          "main_market": {
            "id": 645572,
            "match_id": 90825,
            "event_id": 32555536,
            "market_id": "1.217067629",
            "market_name": "Match Odds",
            "runners": "[\"Leiria\",\"Benfica B\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "7",
            "selection_runner": "[{\"runner_name\":\"Leiria\",\"selection_id\":191603},{\"runner_name\":\"Benfica B\",\"selection_id\":6563318},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217067629",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 191603,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.97,
                      "size": 89.47
                    },
                    {
                      "price": 1.95,
                      "size": 30.92
                    },
                    {
                      "price": 1.94,
                      "size": 140.54
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.04,
                      "size": 253.34
                    },
                    {
                      "price": 2.06,
                      "size": 152.11
                    },
                    {
                      "price": 2.08,
                      "size": 88.23
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 6563318,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 45.88
                    },
                    {
                      "price": 3.95,
                      "size": 64.93
                    },
                    {
                      "price": 3.75,
                      "size": 693.41
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.3,
                      "size": 63.34
                    },
                    {
                      "price": 4.4,
                      "size": 21.05
                    },
                    {
                      "price": 4.5,
                      "size": 519.02
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 150.81
                    },
                    {
                      "price": 3.6,
                      "size": 260.14
                    },
                    {
                      "price": 3.5,
                      "size": 69.85
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 79.29
                    },
                    {
                      "price": 4.2,
                      "size": 41.97
                    },
                    {
                      "price": 4.3,
                      "size": 145.28
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90854,
          "sport_id": 1,
          "league_id": 21,
          "event_id": 32550821,
          "market_id": "1.216991889",
          "event_name": "Radomiak Radom v Warta Poznan",
          "slug": "radomiak-radom-v-warta-poznan-13",
          "runners": [
            "Radomiak Radom",
            "Warta Poznan",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41755133,
          "is_deleted": 0,
          "league_name": "Polish Ekstraklasa",
          "league_slug": "polish-ekstraklasa",
          "league_code": 97,
          "markets": [],
          "main_market": {
            "id": 645862,
            "match_id": 90854,
            "event_id": 32550821,
            "market_id": "1.216991889",
            "market_name": "Match Odds",
            "runners": "[\"Radomiak Radom\",\"Warta Poznan\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Radomiak Radom\",\"selection_id\":1306561},{\"runner_name\":\"Warta Poznan\",\"selection_id\":3348521},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216991889",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 1306561,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.08,
                      "size": 23.54
                    },
                    {
                      "price": 2.06,
                      "size": 309.2
                    },
                    {
                      "price": 2.04,
                      "size": 503.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.14,
                      "size": 383.33
                    },
                    {
                      "price": 2.16,
                      "size": 1584.69
                    },
                    {
                      "price": 2.18,
                      "size": 3011.3
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 3348521,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.2,
                      "size": 1435.84
                    },
                    {
                      "price": 4.1,
                      "size": 713.87
                    },
                    {
                      "price": 4,
                      "size": 518.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 124.68
                    },
                    {
                      "price": 4.5,
                      "size": 159.59
                    },
                    {
                      "price": 4.6,
                      "size": 120.36
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 164.05
                    },
                    {
                      "price": 3.3,
                      "size": 188.67
                    },
                    {
                      "price": 3.25,
                      "size": 298.46
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.5,
                      "size": 16.26
                    },
                    {
                      "price": 3.55,
                      "size": 887.13
                    },
                    {
                      "price": 3.6,
                      "size": 808.9
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90864,
          "sport_id": 1,
          "league_id": 272,
          "event_id": 32545109,
          "market_id": "1.217182038",
          "event_name": "Brommapojkarna v Halmstads",
          "slug": "brommapojkarna-v-halmstads",
          "runners": [
            "Brommapojkarna",
            "Halmstads",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37844293,
          "is_deleted": 0,
          "league_name": "Swedish Allsvenskan",
          "league_slug": "swedish-allsvenskan",
          "league_code": 129,
          "markets": [],
          "main_market": {
            "id": 645962,
            "match_id": 90864,
            "event_id": 32545109,
            "market_id": "1.217182038",
            "market_name": "Match Odds",
            "runners": "[\"Brommapojkarna\",\"Halmstads\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Brommapojkarna\",\"selection_id\":151472},{\"runner_name\":\"Halmstads\",\"selection_id\":10765},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217182038",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 151472,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.02,
                      "size": 684.98
                    },
                    {
                      "price": 2,
                      "size": 3718.84
                    },
                    {
                      "price": 1.99,
                      "size": 568.26
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.06,
                      "size": 90.81
                    },
                    {
                      "price": 2.08,
                      "size": 789.32
                    },
                    {
                      "price": 2.1,
                      "size": 3107.55
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10765,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 72.43
                    },
                    {
                      "price": 3.95,
                      "size": 88.61
                    },
                    {
                      "price": 3.9,
                      "size": 162.76
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 357.19
                    },
                    {
                      "price": 4.2,
                      "size": 1647.78
                    },
                    {
                      "price": 4.3,
                      "size": 3727.37
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 1445.9
                    },
                    {
                      "price": 3.7,
                      "size": 1246.95
                    },
                    {
                      "price": 3.65,
                      "size": 1070.74
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.8,
                      "size": 106.04
                    },
                    {
                      "price": 3.85,
                      "size": 72.87
                    },
                    {
                      "price": 3.95,
                      "size": 80.76
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90865,
          "sport_id": 1,
          "league_id": 272,
          "event_id": 32545387,
          "market_id": "1.216915054",
          "event_name": "Degerfors v IFK Goteborg",
          "slug": "degerfors-v-ifk-goteborg",
          "runners": [
            "Degerfors",
            "IFK Goteborg",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37844295,
          "is_deleted": 0,
          "league_name": "Swedish Allsvenskan",
          "league_slug": "swedish-allsvenskan",
          "league_code": 129,
          "markets": [],
          "main_market": {
            "id": 645972,
            "match_id": 90865,
            "event_id": 32545387,
            "market_id": "1.216915054",
            "market_name": "Match Odds",
            "runners": "[\"Degerfors\",\"IFK Goteborg\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Degerfors\",\"selection_id\":784612},{\"runner_name\":\"IFK Goteborg\",\"selection_id\":30689},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216915054",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 784612,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.1,
                      "size": 277.45
                    },
                    {
                      "price": 3.05,
                      "size": 905.78
                    },
                    {
                      "price": 3,
                      "size": 1950.54
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.2,
                      "size": 769.63
                    },
                    {
                      "price": 3.25,
                      "size": 2726.09
                    },
                    {
                      "price": 3.3,
                      "size": 926
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 30689,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.46,
                      "size": 557.92
                    },
                    {
                      "price": 2.44,
                      "size": 1324.33
                    },
                    {
                      "price": 2.42,
                      "size": 3171.48
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.52,
                      "size": 512.05
                    },
                    {
                      "price": 2.54,
                      "size": 58.99
                    },
                    {
                      "price": 2.56,
                      "size": 672.68
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.5,
                      "size": 942.56
                    },
                    {
                      "price": 3.45,
                      "size": 184.53
                    },
                    {
                      "price": 3.4,
                      "size": 820.57
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 5008.66
                    },
                    {
                      "price": 3.65,
                      "size": 1351.77
                    },
                    {
                      "price": 3.7,
                      "size": 415.24
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90878,
          "sport_id": 1,
          "league_id": 264,
          "event_id": 32553269,
          "market_id": "1.217028691",
          "event_name": "Jonkopings Sodra v Helsingborgs",
          "slug": "jonkopings-sodra-v-helsingborgs",
          "runners": [
            "Jonkopings Sodra",
            "Helsingborgs",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37899237,
          "is_deleted": 0,
          "league_name": "Swedish Superettan",
          "league_slug": "swedish-superettan",
          "league_code": 12202373,
          "markets": [],
          "main_market": {
            "id": 646102,
            "match_id": 90878,
            "event_id": 32553269,
            "market_id": "1.217028691",
            "market_name": "Match Odds",
            "runners": "[\"Jonkopings Sodra\",\"Helsingborgs\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Jonkopings Sodra\",\"selection_id\":503361},{\"runner_name\":\"Helsingborgs\",\"selection_id\":764222},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217028691",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 503361,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.46,
                      "size": 188.01
                    },
                    {
                      "price": 2.44,
                      "size": 159.59
                    },
                    {
                      "price": 2.42,
                      "size": 678.77
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.54,
                      "size": 79.79
                    },
                    {
                      "price": 2.56,
                      "size": 1111.33
                    },
                    {
                      "price": 2.58,
                      "size": 129.66
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 764222,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 109.72
                    },
                    {
                      "price": 2.98,
                      "size": 89.77
                    },
                    {
                      "price": 2.96,
                      "size": 79.79
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.15,
                      "size": 225.92
                    },
                    {
                      "price": 3.2,
                      "size": 2730.44
                    },
                    {
                      "price": 3.25,
                      "size": 440.66
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.55,
                      "size": 799.83
                    },
                    {
                      "price": 3.5,
                      "size": 183.03
                    },
                    {
                      "price": 3.45,
                      "size": 168.46
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.8,
                      "size": 243.67
                    },
                    {
                      "price": 3.85,
                      "size": 195.21
                    },
                    {
                      "price": 3.9,
                      "size": 827.64
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90889,
          "sport_id": 1,
          "league_id": 37,
          "event_id": 32557273,
          "market_id": "1.217104484",
          "event_name": "River Plate (Uru) v Cerro Largo FC",
          "slug": "river-plate-uru-v-cerro-largo-fc",
          "runners": [
            "River Plate (Uru)",
            "Cerro Largo FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692450000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42708143,
          "is_deleted": 0,
          "league_name": "Uruguayan Primera Division",
          "league_slug": "uruguayan-primera-division",
          "league_code": 843454,
          "markets": [],
          "main_market": {
            "id": 646212,
            "match_id": 90889,
            "event_id": 32557273,
            "market_id": "1.217104484",
            "market_name": "Match Odds",
            "runners": "[\"River Plate (Uru)\",\"Cerro Largo FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"River Plate (Uru)\",\"selection_id\":3206731},{\"runner_name\":\"Cerro Largo FC\",\"selection_id\":10573041},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217104484",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 3206731,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.46,
                      "size": 164.54
                    },
                    {
                      "price": 2.44,
                      "size": 248.12
                    },
                    {
                      "price": 2.42,
                      "size": 94.63
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.54,
                      "size": 128.22
                    },
                    {
                      "price": 2.56,
                      "size": 95.23
                    },
                    {
                      "price": 2.58,
                      "size": 79.79
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10573041,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.5,
                      "size": 11.29
                    },
                    {
                      "price": 3.45,
                      "size": 39.9
                    },
                    {
                      "price": 3.4,
                      "size": 619.04
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 109.18
                    },
                    {
                      "price": 3.65,
                      "size": 80.94
                    },
                    {
                      "price": 3.7,
                      "size": 180.17
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.1,
                      "size": 109.72
                    },
                    {
                      "price": 3.05,
                      "size": 113.85
                    },
                    {
                      "price": 3,
                      "size": 760.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.2,
                      "size": 187.5
                    },
                    {
                      "price": 3.25,
                      "size": 436.06
                    },
                    {
                      "price": 3.3,
                      "size": 131.48
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90842,
          "sport_id": 1,
          "league_id": 18,
          "event_id": 32456080,
          "market_id": "1.215653287",
          "event_name": "Hoffenheim v Freiburg",
          "slug": "hoffenheim-v-freiburg",
          "runners": [
            "Hoffenheim",
            "Freiburg",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692451800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42022945,
          "is_deleted": 0,
          "league_name": "German Bundesliga",
          "league_slug": "german-bundesliga",
          "league_code": 59,
          "markets": [],
          "main_market": {
            "id": 645746,
            "match_id": 90842,
            "event_id": 32456080,
            "market_id": "1.215653287",
            "market_name": "Match Odds",
            "runners": "[\"Hoffenheim\",\"Freiburg\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Hoffenheim\",\"selection_id\":208026},{\"runner_name\":\"Freiburg\",\"selection_id\":44520},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.215653287",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 208026,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.44,
                      "size": 133.36
                    },
                    {
                      "price": 2.42,
                      "size": 961.46
                    },
                    {
                      "price": 2.4,
                      "size": 3878.31
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.46,
                      "size": 787.86
                    },
                    {
                      "price": 2.48,
                      "size": 5925.72
                    },
                    {
                      "price": 2.5,
                      "size": 3489.51
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 44520,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 2009.4
                    },
                    {
                      "price": 2.98,
                      "size": 3207.34
                    },
                    {
                      "price": 2.96,
                      "size": 4498.58
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.1,
                      "size": 3631.74
                    },
                    {
                      "price": 3.15,
                      "size": 6374.16
                    },
                    {
                      "price": 3.2,
                      "size": 9056.04
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.8,
                      "size": 1637.66
                    },
                    {
                      "price": 3.75,
                      "size": 3976.69
                    },
                    {
                      "price": 3.7,
                      "size": 12466.01
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.85,
                      "size": 7419.59
                    },
                    {
                      "price": 3.9,
                      "size": 10346.4
                    },
                    {
                      "price": 3.95,
                      "size": 918.14
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90843,
          "sport_id": 1,
          "league_id": 18,
          "event_id": 32456082,
          "market_id": "1.215652340",
          "event_name": "Leverkusen v RB Leipzig",
          "slug": "leverkusen-v-rb-leipzig-88",
          "runners": [
            "Leverkusen",
            "RB Leipzig",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692451800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42022939,
          "is_deleted": 0,
          "league_name": "German Bundesliga",
          "league_slug": "german-bundesliga",
          "league_code": 59,
          "markets": [],
          "main_market": {
            "id": 645756,
            "match_id": 90843,
            "event_id": 32456082,
            "market_id": "1.215652340",
            "market_name": "Match Odds",
            "runners": "[\"Leverkusen\",\"RB Leipzig\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Leverkusen\",\"selection_id\":44787},{\"runner_name\":\"RB Leipzig\",\"selection_id\":5340398},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.215652340",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 44787,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.6,
                      "size": 1080.24
                    },
                    {
                      "price": 2.58,
                      "size": 1557.16
                    },
                    {
                      "price": 2.56,
                      "size": 8931.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.64,
                      "size": 5063.05
                    },
                    {
                      "price": 2.66,
                      "size": 1403.55
                    },
                    {
                      "price": 2.68,
                      "size": 5476.39
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 5340398,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.84,
                      "size": 634.36
                    },
                    {
                      "price": 2.82,
                      "size": 2286.99
                    },
                    {
                      "price": 2.8,
                      "size": 3382.29
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.88,
                      "size": 3408.06
                    },
                    {
                      "price": 2.9,
                      "size": 2783.25
                    },
                    {
                      "price": 2.92,
                      "size": 5997.36
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 1209.67
                    },
                    {
                      "price": 3.7,
                      "size": 17463.62
                    },
                    {
                      "price": 3.65,
                      "size": 1498.14
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.8,
                      "size": 3422.26
                    },
                    {
                      "price": 3.85,
                      "size": 13771
                    },
                    {
                      "price": 3.9,
                      "size": 1598.36
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90840,
          "sport_id": 1,
          "league_id": 18,
          "event_id": 32456081,
          "market_id": "1.215652897",
          "event_name": "Stuttgart v Bochum",
          "slug": "stuttgart-v-bochum",
          "runners": [
            "Stuttgart",
            "Bochum",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692451800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42022949,
          "is_deleted": 0,
          "league_name": "German Bundesliga",
          "league_slug": "german-bundesliga",
          "league_code": 59,
          "markets": [],
          "main_market": {
            "id": 645726,
            "match_id": 90840,
            "event_id": 32456081,
            "market_id": "1.215652897",
            "market_name": "Match Odds",
            "runners": "[\"Stuttgart\",\"Bochum\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Stuttgart\",\"selection_id\":44519},{\"runner_name\":\"Bochum\",\"selection_id\":67143},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.215652897",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 44519,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.74,
                      "size": 1185.74
                    },
                    {
                      "price": 1.73,
                      "size": 2074.47
                    },
                    {
                      "price": 1.72,
                      "size": 7034.91
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.75,
                      "size": 434.97
                    },
                    {
                      "price": 1.76,
                      "size": 1987.56
                    },
                    {
                      "price": 1.77,
                      "size": 5026.57
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 67143,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5,
                      "size": 1643.45
                    },
                    {
                      "price": 4.9,
                      "size": 1614.46
                    },
                    {
                      "price": 4.8,
                      "size": 3756.52
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.1,
                      "size": 516.01
                    },
                    {
                      "price": 5.2,
                      "size": 1478.64
                    },
                    {
                      "price": 5.3,
                      "size": 3365.54
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.3,
                      "size": 1197.98
                    },
                    {
                      "price": 4.2,
                      "size": 12948.83
                    },
                    {
                      "price": 4.1,
                      "size": 8773.35
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 34.31
                    },
                    {
                      "price": 4.5,
                      "size": 4267.76
                    },
                    {
                      "price": 4.6,
                      "size": 2295.09
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90841,
          "sport_id": 1,
          "league_id": 18,
          "event_id": 32456050,
          "market_id": "1.215651783",
          "event_name": "Augsburg v Mgladbach",
          "slug": "augsburg-v-mgladbach",
          "runners": [
            "Augsburg",
            "Mgladbach",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692451800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42022947,
          "is_deleted": 0,
          "league_name": "German Bundesliga",
          "league_slug": "german-bundesliga",
          "league_code": 59,
          "markets": [],
          "main_market": {
            "id": 645736,
            "match_id": 90841,
            "event_id": 32456050,
            "market_id": "1.215651783",
            "market_name": "Match Odds",
            "runners": "[\"Augsburg\",\"Mgladbach\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Augsburg\",\"selection_id\":498560},{\"runner_name\":\"Mgladbach\",\"selection_id\":84649},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.215651783",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 498560,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.84,
                      "size": 549.17
                    },
                    {
                      "price": 2.82,
                      "size": 991.07
                    },
                    {
                      "price": 2.8,
                      "size": 4157.03
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.86,
                      "size": 57.75
                    },
                    {
                      "price": 2.88,
                      "size": 822.66
                    },
                    {
                      "price": 2.9,
                      "size": 4079.93
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 84649,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.54,
                      "size": 1059.38
                    },
                    {
                      "price": 2.52,
                      "size": 3262.38
                    },
                    {
                      "price": 2.5,
                      "size": 6233.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.56,
                      "size": 239.04
                    },
                    {
                      "price": 2.58,
                      "size": 2100.02
                    },
                    {
                      "price": 2.6,
                      "size": 6006.75
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.85,
                      "size": 9099.72
                    },
                    {
                      "price": 3.8,
                      "size": 4687.97
                    },
                    {
                      "price": 3.75,
                      "size": 7272.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.9,
                      "size": 5559.3
                    },
                    {
                      "price": 3.95,
                      "size": 1461.82
                    },
                    {
                      "price": 4,
                      "size": 1200.42
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90839,
          "sport_id": 1,
          "league_id": 18,
          "event_id": 32456055,
          "market_id": "1.215651663",
          "event_name": "Wolfsburg v FC Heidenheim",
          "slug": "wolfsburg-v-fc-heidenheim",
          "runners": [
            "Wolfsburg",
            "FC Heidenheim",
            "The Draw"
          ],
          "event_date": "2023-08-19T13:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692451800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42022943,
          "is_deleted": 0,
          "league_name": "German Bundesliga",
          "league_slug": "german-bundesliga",
          "league_code": 59,
          "markets": [],
          "main_market": {
            "id": 645716,
            "match_id": 90839,
            "event_id": 32456055,
            "market_id": "1.215651663",
            "market_name": "Match Odds",
            "runners": "[\"Wolfsburg\",\"FC Heidenheim\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Wolfsburg\",\"selection_id\":44521},{\"runner_name\":\"FC Heidenheim\",\"selection_id\":3237590},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.215651663",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 44521,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.66,
                      "size": 1226.4
                    },
                    {
                      "price": 1.65,
                      "size": 2435.39
                    },
                    {
                      "price": 1.64,
                      "size": 4234.53
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.67,
                      "size": 1392.21
                    },
                    {
                      "price": 1.68,
                      "size": 1317.34
                    },
                    {
                      "price": 1.69,
                      "size": 6064.42
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 3237590,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.6,
                      "size": 1666.89
                    },
                    {
                      "price": 5.5,
                      "size": 3761.03
                    },
                    {
                      "price": 5.4,
                      "size": 1219.93
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.7,
                      "size": 110.91
                    },
                    {
                      "price": 5.8,
                      "size": 1200.55
                    },
                    {
                      "price": 5.9,
                      "size": 2267.55
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 516.66
                    },
                    {
                      "price": 4.4,
                      "size": 6129.7
                    },
                    {
                      "price": 4.3,
                      "size": 1678.05
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 941.4
                    },
                    {
                      "price": 4.7,
                      "size": 8648.2
                    },
                    {
                      "price": 4.8,
                      "size": 2346.34
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90834,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555294,
          "market_id": "1.217061213",
          "event_name": "Northampton v Peterborough",
          "slug": "northampton-v-peterborough",
          "runners": [
            "Northampton",
            "Peterborough",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888857,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645664,
            "match_id": 90834,
            "event_id": 32555294,
            "market_id": "1.217061213",
            "market_name": "Match Odds",
            "runners": "[\"Northampton\",\"Peterborough\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Northampton\",\"selection_id\":5034},{\"runner_name\":\"Peterborough\",\"selection_id\":18563},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217061213",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5034,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.7,
                      "size": 772.83
                    },
                    {
                      "price": 3.65,
                      "size": 552.93
                    },
                    {
                      "price": 3.6,
                      "size": 1543.72
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.75,
                      "size": 225.55
                    },
                    {
                      "price": 3.8,
                      "size": 257.75
                    },
                    {
                      "price": 3.85,
                      "size": 819.42
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 18563,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.14,
                      "size": 270.19
                    },
                    {
                      "price": 2.12,
                      "size": 2043.36
                    },
                    {
                      "price": 2.1,
                      "size": 1961.82
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.16,
                      "size": 362.46
                    },
                    {
                      "price": 2.18,
                      "size": 2411.18
                    },
                    {
                      "price": 2.2,
                      "size": 548.56
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.7,
                      "size": 924.03
                    },
                    {
                      "price": 3.65,
                      "size": 272.71
                    },
                    {
                      "price": 3.6,
                      "size": 448.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.8,
                      "size": 872.76
                    },
                    {
                      "price": 3.85,
                      "size": 206.77
                    },
                    {
                      "price": 3.9,
                      "size": 1330.08
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90880,
          "sport_id": 1,
          "league_id": 245,
          "event_id": 32560361,
          "market_id": "1.217154444",
          "event_name": "KFCO Beerschot Wilrijk v Zulte-Waregem",
          "slug": "kfco-beerschot-wilrijk-v-zulte-waregem",
          "runners": [
            "Kfco Beerschot Wilrijk",
            "Zulte-Waregem",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41894189,
          "is_deleted": 0,
          "league_name": "Belgian First Division B",
          "league_slug": "belgian-first-division-b",
          "league_code": 11717188,
          "markets": [],
          "main_market": {
            "id": 646122,
            "match_id": 90880,
            "event_id": 32560361,
            "market_id": "1.217154444",
            "market_name": "Match Odds",
            "runners": "[\"Kfco Beerschot Wilrijk\",\"Zulte-Waregem\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Kfco Beerschot Wilrijk\",\"selection_id\":13734279},{\"runner_name\":\"Zulte-Waregem\",\"selection_id\":505726},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217154444",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 13734279,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.5,
                      "size": 102.84
                    },
                    {
                      "price": 2.48,
                      "size": 79.79
                    },
                    {
                      "price": 2.46,
                      "size": 455.53
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.58,
                      "size": 94.5
                    },
                    {
                      "price": 2.6,
                      "size": 59.85
                    },
                    {
                      "price": 2.62,
                      "size": 71.65
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 505726,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.78,
                      "size": 32.17
                    },
                    {
                      "price": 2.76,
                      "size": 49.87
                    },
                    {
                      "price": 2.74,
                      "size": 29.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.86,
                      "size": 75.37
                    },
                    {
                      "price": 2.88,
                      "size": 292.14
                    },
                    {
                      "price": 2.9,
                      "size": 49.87
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.9,
                      "size": 27.63
                    },
                    {
                      "price": 3.85,
                      "size": 239.08
                    },
                    {
                      "price": 3.8,
                      "size": 56.73
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 121.27
                    },
                    {
                      "price": 4.2,
                      "size": 89.63
                    },
                    {
                      "price": 4.3,
                      "size": 302.81
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90867,
          "sport_id": 1,
          "league_id": 25,
          "event_id": 32552320,
          "market_id": "1.217014999",
          "event_name": "Botosani v Otelul Galati",
          "slug": "botosani-v-otelul-galati",
          "runners": [
            "Botosani",
            "Otelul Galati",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41978211,
          "is_deleted": 0,
          "league_name": "Romanian Liga I",
          "league_slug": "romanian-liga-i",
          "league_code": 4905,
          "markets": [],
          "main_market": {
            "id": 645992,
            "match_id": 90867,
            "event_id": 32552320,
            "market_id": "1.217014999",
            "market_name": "Match Odds",
            "runners": "[\"Botosani\",\"Otelul Galati\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Botosani\",\"selection_id\":3465177},{\"runner_name\":\"Otelul Galati\",\"selection_id\":866238},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217014999",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 3465177,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.12,
                      "size": 880.12
                    },
                    {
                      "price": 2.1,
                      "size": 109.72
                    },
                    {
                      "price": 2.08,
                      "size": 243.27
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.18,
                      "size": 249.4
                    },
                    {
                      "price": 2.2,
                      "size": 933.73
                    },
                    {
                      "price": 2.22,
                      "size": 69.82
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 866238,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 339.12
                    },
                    {
                      "price": 4.4,
                      "size": 271.9
                    },
                    {
                      "price": 4.3,
                      "size": 79.79
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 49.87
                    },
                    {
                      "price": 4.7,
                      "size": 69.82
                    },
                    {
                      "price": 4.8,
                      "size": 108.78
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.15,
                      "size": 89.77
                    },
                    {
                      "price": 3.1,
                      "size": 139.34
                    },
                    {
                      "price": 3.05,
                      "size": 634.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.3,
                      "size": 462.44
                    },
                    {
                      "price": 3.35,
                      "size": 171.25
                    },
                    {
                      "price": 3.4,
                      "size": 554.41
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90837,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555301,
          "market_id": "1.217060673",
          "event_name": "Shrewsbury v Lincoln",
          "slug": "shrewsbury-v-lincoln",
          "runners": [
            "Shrewsbury",
            "Lincoln",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888863,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645694,
            "match_id": 90837,
            "event_id": 32555301,
            "market_id": "1.217060673",
            "market_name": "Match Odds",
            "runners": "[\"Shrewsbury\",\"Lincoln\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Shrewsbury\",\"selection_id\":148735},{\"runner_name\":\"Lincoln\",\"selection_id\":148737},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217060673",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 148735,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.76,
                      "size": 97.62
                    },
                    {
                      "price": 2.74,
                      "size": 142.49
                    },
                    {
                      "price": 2.72,
                      "size": 164.93
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.8,
                      "size": 159.72
                    },
                    {
                      "price": 2.82,
                      "size": 18.74
                    },
                    {
                      "price": 2.84,
                      "size": 631.38
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 148737,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 455.1
                    },
                    {
                      "price": 2.98,
                      "size": 107.55
                    },
                    {
                      "price": 2.96,
                      "size": 202.32
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 148.88
                    },
                    {
                      "price": 3.1,
                      "size": 1740.9
                    },
                    {
                      "price": 3.15,
                      "size": 1245.15
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.2,
                      "size": 407.38
                    },
                    {
                      "price": 3.15,
                      "size": 1819.01
                    },
                    {
                      "price": 3.1,
                      "size": 1232.29
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.3,
                      "size": 318.25
                    },
                    {
                      "price": 3.35,
                      "size": 983.68
                    },
                    {
                      "price": 3.4,
                      "size": 833.3
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90836,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555283,
          "market_id": "1.217061767",
          "event_name": "Cambridge Utd v Bristol Rovers",
          "slug": "cambridge-utd-v-bristol-rovers-86",
          "runners": [
            "Cambridge Utd",
            "Bristol Rovers",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888849,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645684,
            "match_id": 90836,
            "event_id": 32555283,
            "market_id": "1.217061767",
            "market_name": "Match Odds",
            "runners": "[\"Cambridge Utd\",\"Bristol Rovers\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Cambridge Utd\",\"selection_id\":256400},{\"runner_name\":\"Bristol Rovers\",\"selection_id\":69821},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217061767",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 256400,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.88,
                      "size": 12.59
                    },
                    {
                      "price": 2.86,
                      "size": 2511.1
                    },
                    {
                      "price": 2.84,
                      "size": 494.87
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.92,
                      "size": 301.46
                    },
                    {
                      "price": 2.94,
                      "size": 333.84
                    },
                    {
                      "price": 2.96,
                      "size": 1770.18
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 69821,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.66,
                      "size": 882.36
                    },
                    {
                      "price": 2.64,
                      "size": 2373.73
                    },
                    {
                      "price": 2.62,
                      "size": 363.18
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.72,
                      "size": 419.71
                    },
                    {
                      "price": 2.74,
                      "size": 1880.64
                    },
                    {
                      "price": 2.76,
                      "size": 343.59
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.5,
                      "size": 162.59
                    },
                    {
                      "price": 3.45,
                      "size": 1082.04
                    },
                    {
                      "price": 3.4,
                      "size": 801.98
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.55,
                      "size": 430.99
                    },
                    {
                      "price": 3.6,
                      "size": 90.56
                    },
                    {
                      "price": 3.65,
                      "size": 1141.83
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90835,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555288,
          "market_id": "1.217061549",
          "event_name": "Wycombe v Burton Albion",
          "slug": "wycombe-v-burton-albion",
          "runners": [
            "Wycombe",
            "Burton Albion",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888865,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645674,
            "match_id": 90835,
            "event_id": 32555288,
            "market_id": "1.217061549",
            "market_name": "Match Odds",
            "runners": "[\"Wycombe\",\"Burton Albion\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Wycombe\",\"selection_id\":49584},{\"runner_name\":\"Burton Albion\",\"selection_id\":28592},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217061549",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 49584,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.99,
                      "size": 554.71
                    },
                    {
                      "price": 1.98,
                      "size": 5923.48
                    },
                    {
                      "price": 1.97,
                      "size": 823.49
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2,
                      "size": 234.36
                    },
                    {
                      "price": 2.02,
                      "size": 322.03
                    },
                    {
                      "price": 2.04,
                      "size": 3218.24
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 28592,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.2,
                      "size": 1358.46
                    },
                    {
                      "price": 4.1,
                      "size": 470.99
                    },
                    {
                      "price": 4,
                      "size": 1384.24
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.3,
                      "size": 249.9
                    },
                    {
                      "price": 4.4,
                      "size": 736.48
                    },
                    {
                      "price": 4.5,
                      "size": 3029.33
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.7,
                      "size": 1686.87
                    },
                    {
                      "price": 3.65,
                      "size": 1086.41
                    },
                    {
                      "price": 3.6,
                      "size": 464.2
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.8,
                      "size": 907.56
                    },
                    {
                      "price": 3.85,
                      "size": 1490.95
                    },
                    {
                      "price": 3.9,
                      "size": 1465.31
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90838,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555297,
          "market_id": "1.217060889",
          "event_name": "Charlton v Port Vale",
          "slug": "charlton-v-port-vale-25",
          "runners": [
            "Charlton",
            "Port Vale",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888853,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645704,
            "match_id": 90838,
            "event_id": 32555297,
            "market_id": "1.217060889",
            "market_name": "Match Odds",
            "runners": "[\"Charlton\",\"Port Vale\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Charlton\",\"selection_id\":48349},{\"runner_name\":\"Port Vale\",\"selection_id\":256373},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217060889",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 48349,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.04,
                      "size": 234.4
                    },
                    {
                      "price": 2.02,
                      "size": 2634.6
                    },
                    {
                      "price": 2,
                      "size": 646.69
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.08,
                      "size": 467.8
                    },
                    {
                      "price": 2.1,
                      "size": 1102.17
                    },
                    {
                      "price": 2.12,
                      "size": 2090.35
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 256373,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 1289.65
                    },
                    {
                      "price": 3.95,
                      "size": 237.51
                    },
                    {
                      "price": 3.9,
                      "size": 302.55
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 175.56
                    },
                    {
                      "price": 4.2,
                      "size": 1074.21
                    },
                    {
                      "price": 4.3,
                      "size": 173.05
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 136.66
                    },
                    {
                      "price": 3.7,
                      "size": 93.46
                    },
                    {
                      "price": 3.65,
                      "size": 960.34
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.8,
                      "size": 49.28
                    },
                    {
                      "price": 3.85,
                      "size": 231.69
                    },
                    {
                      "price": 3.9,
                      "size": 692.57
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90833,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555296,
          "market_id": "1.217060997",
          "event_name": "Reading v Stevenage",
          "slug": "reading-v-stevenage-33",
          "runners": [
            "Reading",
            "Stevenage",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888861,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645654,
            "match_id": 90833,
            "event_id": 32555296,
            "market_id": "1.217060997",
            "market_name": "Match Odds",
            "runners": "[\"Reading\",\"Stevenage\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Reading\",\"selection_id\":103122},{\"runner_name\":\"Stevenage\",\"selection_id\":49204},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217060997",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 103122,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.9,
                      "size": 135.46
                    },
                    {
                      "price": 2.88,
                      "size": 303.05
                    },
                    {
                      "price": 2.86,
                      "size": 237.66
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.92,
                      "size": 253.55
                    },
                    {
                      "price": 2.94,
                      "size": 646.69
                    },
                    {
                      "price": 2.96,
                      "size": 112.57
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 49204,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.78,
                      "size": 3277.89
                    },
                    {
                      "price": 2.76,
                      "size": 169.23
                    },
                    {
                      "price": 2.74,
                      "size": 1204.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.8,
                      "size": 120.19
                    },
                    {
                      "price": 2.82,
                      "size": 370.4
                    },
                    {
                      "price": 2.84,
                      "size": 2049.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 464.36
                    },
                    {
                      "price": 3.3,
                      "size": 1562.88
                    },
                    {
                      "price": 3.25,
                      "size": 1699.13
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.4,
                      "size": 314.16
                    },
                    {
                      "price": 3.45,
                      "size": 2019.31
                    },
                    {
                      "price": 3.5,
                      "size": 301.85
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90832,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555298,
          "market_id": "1.217060781",
          "event_name": "Portsmouth v Cheltenham",
          "slug": "portsmouth-v-cheltenham",
          "runners": [
            "Portsmouth",
            "Cheltenham",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888859,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645644,
            "match_id": 90832,
            "event_id": 32555298,
            "market_id": "1.217060781",
            "market_name": "Match Odds",
            "runners": "[\"Portsmouth\",\"Cheltenham\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Portsmouth\",\"selection_id\":58344},{\"runner_name\":\"Cheltenham\",\"selection_id\":18559},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217060781",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 58344,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.51,
                      "size": 147.32
                    },
                    {
                      "price": 1.5,
                      "size": 3656.09
                    },
                    {
                      "price": 1.49,
                      "size": 8353.4
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.52,
                      "size": 1163.44
                    },
                    {
                      "price": 1.53,
                      "size": 6370.28
                    },
                    {
                      "price": 1.54,
                      "size": 2496.78
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 18559,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 8,
                      "size": 2145.26
                    },
                    {
                      "price": 7.8,
                      "size": 845.31
                    },
                    {
                      "price": 7.6,
                      "size": 243.24
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 8.2,
                      "size": 25.69
                    },
                    {
                      "price": 8.4,
                      "size": 448.59
                    },
                    {
                      "price": 8.6,
                      "size": 643.56
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 501.29
                    },
                    {
                      "price": 4.4,
                      "size": 1445.61
                    },
                    {
                      "price": 4.3,
                      "size": 2200.66
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 276.26
                    },
                    {
                      "price": 4.7,
                      "size": 1519.65
                    },
                    {
                      "price": 4.8,
                      "size": 1121.6
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90831,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555291,
          "market_id": "1.217061333",
          "event_name": "Derby v Fleetwood Town",
          "slug": "derby-v-fleetwood-town-22",
          "runners": [
            "Derby",
            "Fleetwood Town",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888855,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645634,
            "match_id": 90831,
            "event_id": 32555291,
            "market_id": "1.217061333",
            "market_name": "Match Odds",
            "runners": "[\"Derby\",\"Fleetwood Town\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Derby\",\"selection_id\":48325},{\"runner_name\":\"Fleetwood Town\",\"selection_id\":3396710},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217061333",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 48325,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.65,
                      "size": 829.34
                    },
                    {
                      "price": 1.64,
                      "size": 127.68
                    },
                    {
                      "price": 1.63,
                      "size": 895.27
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.67,
                      "size": 217.3
                    },
                    {
                      "price": 1.68,
                      "size": 521.43
                    },
                    {
                      "price": 1.69,
                      "size": 1683.6
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 3396710,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.9,
                      "size": 73.96
                    },
                    {
                      "price": 5.8,
                      "size": 441.01
                    },
                    {
                      "price": 5.7,
                      "size": 225.09
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.2,
                      "size": 145.43
                    },
                    {
                      "price": 6.4,
                      "size": 721.95
                    },
                    {
                      "price": 6.6,
                      "size": 913.6
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.3,
                      "size": 64.3
                    },
                    {
                      "price": 4.2,
                      "size": 232.14
                    },
                    {
                      "price": 4.1,
                      "size": 906.2
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 272.6
                    },
                    {
                      "price": 4.5,
                      "size": 191.21
                    },
                    {
                      "price": 4.6,
                      "size": 1071.2
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90830,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555295,
          "market_id": "1.217061105",
          "event_name": "Blackpool v Leyton Orient",
          "slug": "blackpool-v-leyton-orient",
          "runners": [
            "Blackpool",
            "Leyton Orient",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888845,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645624,
            "match_id": 90830,
            "event_id": 32555295,
            "market_id": "1.217061105",
            "market_name": "Match Odds",
            "runners": "[\"Blackpool\",\"Leyton Orient\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Blackpool\",\"selection_id\":64964},{\"runner_name\":\"Leyton Orient\",\"selection_id\":69717},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217061105",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 64964,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.7,
                      "size": 1344.3
                    },
                    {
                      "price": 1.69,
                      "size": 483.58
                    },
                    {
                      "price": 1.68,
                      "size": 1629.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.72,
                      "size": 413.83
                    },
                    {
                      "price": 1.73,
                      "size": 1352.99
                    },
                    {
                      "price": 1.74,
                      "size": 1353.83
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 69717,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.7,
                      "size": 151.88
                    },
                    {
                      "price": 5.6,
                      "size": 257.47
                    },
                    {
                      "price": 5.5,
                      "size": 272.69
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.9,
                      "size": 690.51
                    },
                    {
                      "price": 6,
                      "size": 559.65
                    },
                    {
                      "price": 6.2,
                      "size": 965.3
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.1,
                      "size": 920.63
                    },
                    {
                      "price": 4,
                      "size": 1939.6
                    },
                    {
                      "price": 3.95,
                      "size": 1300.08
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.2,
                      "size": 206.13
                    },
                    {
                      "price": 4.3,
                      "size": 1268.54
                    },
                    {
                      "price": 4.4,
                      "size": 178.87
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90829,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555302,
          "market_id": "1.217060565",
          "event_name": "Barnsley v Oxford Utd",
          "slug": "barnsley-v-oxford-utd-57",
          "runners": [
            "Barnsley",
            "Oxford Utd",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888843,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645614,
            "match_id": 90829,
            "event_id": 32555302,
            "market_id": "1.217060565",
            "market_name": "Match Odds",
            "runners": "[\"Barnsley\",\"Oxford Utd\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Barnsley\",\"selection_id\":1117},{\"runner_name\":\"Oxford Utd\",\"selection_id\":256171},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217060565",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 1117,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.16,
                      "size": 214.72
                    },
                    {
                      "price": 2.14,
                      "size": 435.86
                    },
                    {
                      "price": 2.12,
                      "size": 769.36
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.2,
                      "size": 1745.24
                    },
                    {
                      "price": 2.22,
                      "size": 2307.4
                    },
                    {
                      "price": 2.24,
                      "size": 1456.01
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 256171,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.8,
                      "size": 1276.25
                    },
                    {
                      "price": 3.75,
                      "size": 3310.47
                    },
                    {
                      "price": 3.7,
                      "size": 1381.13
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.85,
                      "size": 17.81
                    },
                    {
                      "price": 3.9,
                      "size": 157.67
                    },
                    {
                      "price": 3.95,
                      "size": 141.49
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.55,
                      "size": 658.3
                    },
                    {
                      "price": 3.5,
                      "size": 1205.5
                    },
                    {
                      "price": 3.45,
                      "size": 1055.3
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 1114.47
                    },
                    {
                      "price": 3.65,
                      "size": 416.92
                    },
                    {
                      "price": 3.7,
                      "size": 656.4
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90828,
          "sport_id": 1,
          "league_id": 17,
          "event_id": 32555287,
          "market_id": "1.217061657",
          "event_name": "Carlisle v Exeter",
          "slug": "carlisle-v-exeter",
          "runners": [
            "Carlisle",
            "Exeter",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41888851,
          "is_deleted": 0,
          "league_name": "English League 1",
          "league_slug": "english-league-1",
          "league_code": 35,
          "markets": [],
          "main_market": {
            "id": 645604,
            "match_id": 90828,
            "event_id": 32555287,
            "market_id": "1.217061657",
            "market_name": "Match Odds",
            "runners": "[\"Carlisle\",\"Exeter\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 50000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"Carlisle\",\"selection_id\":18561},{\"runner_name\":\"Exeter\",\"selection_id\":66243},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217061657",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 18561,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.82,
                      "size": 147.46
                    },
                    {
                      "price": 2.8,
                      "size": 509.35
                    },
                    {
                      "price": 2.78,
                      "size": 2427.72
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.86,
                      "size": 60.18
                    },
                    {
                      "price": 2.88,
                      "size": 162.44
                    },
                    {
                      "price": 2.9,
                      "size": 91.82
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 66243,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.78,
                      "size": 75.8
                    },
                    {
                      "price": 2.76,
                      "size": 197.02
                    },
                    {
                      "price": 2.74,
                      "size": 209.56
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.8,
                      "size": 112.26
                    },
                    {
                      "price": 2.82,
                      "size": 5691.05
                    },
                    {
                      "price": 2.84,
                      "size": 77.79
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.4,
                      "size": 341.62
                    },
                    {
                      "price": 3.35,
                      "size": 1584.88
                    },
                    {
                      "price": 3.3,
                      "size": 435.3
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.45,
                      "size": 31.02
                    },
                    {
                      "price": 3.5,
                      "size": 1223.99
                    },
                    {
                      "price": 3.55,
                      "size": 158.64
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 50000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90816,
          "sport_id": 1,
          "league_id": 10,
          "event_id": 32553529,
          "market_id": "1.217036459",
          "event_name": "Standard v Cercle Brugge",
          "slug": "standard-v-cercle-brugge-60",
          "runners": [
            "Standard",
            "Cercle Brugge",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692453600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41893727,
          "is_deleted": 0,
          "league_name": "Belgian First Division A",
          "league_slug": "belgian-first-division-a",
          "league_code": 89979,
          "markets": [],
          "main_market": {
            "id": 645484,
            "match_id": 90816,
            "event_id": 32553529,
            "market_id": "1.217036459",
            "market_name": "Match Odds",
            "runners": "[\"Standard\",\"Cercle Brugge\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Standard\",\"selection_id\":571279},{\"runner_name\":\"Cercle Brugge\",\"selection_id\":259394},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217036459",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 571279,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 169.56
                    },
                    {
                      "price": 2.98,
                      "size": 134.54
                    },
                    {
                      "price": 2.96,
                      "size": 864.06
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.15,
                      "size": 441.86
                    },
                    {
                      "price": 3.2,
                      "size": 1439.24
                    },
                    {
                      "price": 3.25,
                      "size": 694.22
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 259394,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.38,
                      "size": 249.36
                    },
                    {
                      "price": 2.36,
                      "size": 250.23
                    },
                    {
                      "price": 2.34,
                      "size": 397.34
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.46,
                      "size": 379.02
                    },
                    {
                      "price": 2.48,
                      "size": 574.16
                    },
                    {
                      "price": 2.5,
                      "size": 1622.96
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.8,
                      "size": 468.89
                    },
                    {
                      "price": 3.75,
                      "size": 63.93
                    },
                    {
                      "price": 3.7,
                      "size": 768.45
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.95,
                      "size": 812.3
                    },
                    {
                      "price": 4,
                      "size": 179.54
                    },
                    {
                      "price": 4.1,
                      "size": 1790.99
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90857,
          "sport_id": 1,
          "league_id": 22,
          "event_id": 32555750,
          "market_id": "1.217072128",
          "event_name": "Guimaraes v Gil Vicente",
          "slug": "guimaraes-v-gil-vicente-57",
          "runners": [
            "Guimaraes",
            "Gil Vicente",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692455400,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42146133,
          "is_deleted": 0,
          "league_name": "Portuguese Primeira Liga",
          "league_slug": "portuguese-primeira-liga",
          "league_code": 99,
          "markets": [],
          "main_market": {
            "id": 645892,
            "match_id": 90857,
            "event_id": 32555750,
            "market_id": "1.217072128",
            "market_name": "Match Odds",
            "runners": "[\"Guimaraes\",\"Gil Vicente\",\"The Draw\"]",
            "stake_limit": 10000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Guimaraes\",\"selection_id\":50085},{\"runner_name\":\"Gil Vicente\",\"selection_id\":48784},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217072128",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 50085,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.14,
                      "size": 387.3
                    },
                    {
                      "price": 2.12,
                      "size": 657.33
                    },
                    {
                      "price": 2.1,
                      "size": 4577.73
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.18,
                      "size": 113.71
                    },
                    {
                      "price": 2.2,
                      "size": 1804.48
                    },
                    {
                      "price": 2.22,
                      "size": 2684.08
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 48784,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.95,
                      "size": 799.43
                    },
                    {
                      "price": 3.9,
                      "size": 49.89
                    },
                    {
                      "price": 3.85,
                      "size": 154.15
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 876.23
                    },
                    {
                      "price": 4.2,
                      "size": 376.88
                    },
                    {
                      "price": 4.3,
                      "size": 1368.18
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.45,
                      "size": 23.9
                    },
                    {
                      "price": 3.4,
                      "size": 831.15
                    },
                    {
                      "price": 3.35,
                      "size": 223.61
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.55,
                      "size": 755.55
                    },
                    {
                      "price": 3.6,
                      "size": 339.95
                    },
                    {
                      "price": 3.65,
                      "size": 471.56
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 10000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90826,
          "sport_id": 1,
          "league_id": 56,
          "event_id": 32555537,
          "market_id": "1.217068262",
          "event_name": "Tondela v Academico de Viseu",
          "slug": "tondela-v-academico-de-viseu-89",
          "runners": [
            "Tondela",
            "Academico de Viseu",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692455400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42146991,
          "is_deleted": 0,
          "league_name": "Portuguese Segunda Liga",
          "league_slug": "portuguese-segunda-liga",
          "league_code": 9513,
          "markets": [],
          "main_market": {
            "id": 645582,
            "match_id": 90826,
            "event_id": 32555537,
            "market_id": "1.217068262",
            "market_name": "Match Odds",
            "runners": "[\"Tondela\",\"Academico de Viseu\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "7",
            "selection_runner": "[{\"runner_name\":\"Tondela\",\"selection_id\":4240339},{\"runner_name\":\"Academico de Viseu\",\"selection_id\":7611327},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217068262",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 4240339,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.4,
                      "size": 137.77
                    },
                    {
                      "price": 2.38,
                      "size": 237.96
                    },
                    {
                      "price": 2.36,
                      "size": 216.24
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.48,
                      "size": 109.72
                    },
                    {
                      "price": 2.5,
                      "size": 79.79
                    },
                    {
                      "price": 2.52,
                      "size": 199.58
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7611327,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.25,
                      "size": 19.95
                    },
                    {
                      "price": 3.2,
                      "size": 282.22
                    },
                    {
                      "price": 3.15,
                      "size": 244.99
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.4,
                      "size": 93.46
                    },
                    {
                      "price": 3.45,
                      "size": 89.77
                    },
                    {
                      "price": 3.5,
                      "size": 178.64
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 162.28
                    },
                    {
                      "price": 3.3,
                      "size": 182.2
                    },
                    {
                      "price": 3.25,
                      "size": 99.96
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.5,
                      "size": 203.07
                    },
                    {
                      "price": 3.55,
                      "size": 39.7
                    },
                    {
                      "price": 3.6,
                      "size": 134.75
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90786,
          "sport_id": 1,
          "league_id": 14,
          "event_id": 32542223,
          "market_id": "1.216877086",
          "event_name": "Excelsior v Ajax",
          "slug": "excelsior-v-ajax-80",
          "runners": [
            "Excelsior",
            "Ajax",
            "The Draw"
          ],
          "event_date": "2023-08-19T14:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692455400,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 41980121,
          "is_deleted": 0,
          "league_name": "Dutch Eredivisie",
          "league_slug": "dutch-eredivisie",
          "league_code": 9404054,
          "markets": [],
          "main_market": {
            "id": 645275,
            "match_id": 90786,
            "event_id": 32542223,
            "market_id": "1.216877086",
            "market_name": "Match Odds",
            "runners": "[\"Excelsior\",\"Ajax\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Excelsior\",\"selection_id\":67164},{\"runner_name\":\"Ajax\",\"selection_id\":52494689},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216877086",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 67164,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 12,
                      "size": 261.64
                    },
                    {
                      "price": 11.5,
                      "size": 695.86
                    },
                    {
                      "price": 11,
                      "size": 593.15
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 12.5,
                      "size": 26.13
                    },
                    {
                      "price": 13,
                      "size": 1039.11
                    },
                    {
                      "price": 13.5,
                      "size": 2245.6
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 52494689,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.28,
                      "size": 496.67
                    },
                    {
                      "price": 1.27,
                      "size": 3073.82
                    },
                    {
                      "price": 1.26,
                      "size": 12512.97
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.29,
                      "size": 1627.78
                    },
                    {
                      "price": 1.3,
                      "size": 6996.22
                    },
                    {
                      "price": 1.31,
                      "size": 3135.89
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 7,
                      "size": 492.04
                    },
                    {
                      "price": 6.8,
                      "size": 461.98
                    },
                    {
                      "price": 6.6,
                      "size": 1571.57
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 7.2,
                      "size": 278.43
                    },
                    {
                      "price": 7.4,
                      "size": 350.93
                    },
                    {
                      "price": 7.6,
                      "size": 174.81
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90820,
          "sport_id": 1,
          "league_id": 13,
          "event_id": 32553661,
          "market_id": "1.217036567",
          "event_name": "Eibar v Elche",
          "slug": "eibar-v-elche",
          "runners": [
            "Eibar",
            "Elche",
            "The Draw"
          ],
          "event_date": "2023-08-19T15:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692457200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41983825,
          "is_deleted": 0,
          "league_name": "Spanish Segunda Division",
          "league_slug": "spanish-segunda-division",
          "league_code": 12204313,
          "markets": [],
          "main_market": {
            "id": 645524,
            "match_id": 90820,
            "event_id": 32553661,
            "market_id": "1.217036567",
            "market_name": "Match Odds",
            "runners": "[\"Eibar\",\"Elche\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Eibar\",\"selection_id\":247969},{\"runner_name\":\"Elche\",\"selection_id\":309111},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217036567",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 247969,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.28,
                      "size": 52.86
                    },
                    {
                      "price": 2.26,
                      "size": 1736.48
                    },
                    {
                      "price": 2.24,
                      "size": 1389.46
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.32,
                      "size": 67.07
                    },
                    {
                      "price": 2.34,
                      "size": 166.05
                    },
                    {
                      "price": 2.36,
                      "size": 159.59
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 309111,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.9,
                      "size": 39.9
                    },
                    {
                      "price": 3.85,
                      "size": 795.28
                    },
                    {
                      "price": 3.8,
                      "size": 342.99
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 490.08
                    },
                    {
                      "price": 4.2,
                      "size": 149.61
                    },
                    {
                      "price": 4.3,
                      "size": 1500.42
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.2,
                      "size": 60.64
                    },
                    {
                      "price": 3.1,
                      "size": 159.59
                    },
                    {
                      "price": 3.05,
                      "size": 1136.4
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.25,
                      "size": 107.73
                    },
                    {
                      "price": 3.3,
                      "size": 1466.33
                    },
                    {
                      "price": 3.35,
                      "size": 1127.58
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90861,
          "sport_id": 1,
          "league_id": 24,
          "event_id": 32486975,
          "market_id": "1.216076018",
          "event_name": "Real Sociedad v Celta Vigo",
          "slug": "real-sociedad-v-celta-vigo",
          "runners": [
            "Real Sociedad",
            "Celta Vigo",
            "The Draw"
          ],
          "event_date": "2023-08-19T15:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692457200,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 41892931,
          "is_deleted": 0,
          "league_name": "Spanish La Liga",
          "league_slug": "spanish-la-liga",
          "league_code": 117,
          "markets": [],
          "main_market": {
            "id": 645936,
            "match_id": 90861,
            "event_id": 32486975,
            "market_id": "1.216076018",
            "market_name": "Match Odds",
            "runners": "[\"Real Sociedad\",\"Celta Vigo\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Real Sociedad\",\"selection_id\":18573},{\"runner_name\":\"Celta Vigo\",\"selection_id\":66483},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216076018",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 18573,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.83,
                      "size": 1366.12
                    },
                    {
                      "price": 1.82,
                      "size": 4087.02
                    },
                    {
                      "price": 1.81,
                      "size": 7234.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.85,
                      "size": 8625.04
                    },
                    {
                      "price": 1.86,
                      "size": 3397.48
                    },
                    {
                      "price": 1.87,
                      "size": 10901.02
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 66483,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.7,
                      "size": 1266.57
                    },
                    {
                      "price": 5.6,
                      "size": 2147.63
                    },
                    {
                      "price": 5.5,
                      "size": 3029.72
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.8,
                      "size": 964.42
                    },
                    {
                      "price": 5.9,
                      "size": 2395.32
                    },
                    {
                      "price": 6,
                      "size": 4832.58
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.55,
                      "size": 2649.04
                    },
                    {
                      "price": 3.5,
                      "size": 2901.13
                    },
                    {
                      "price": 3.45,
                      "size": 10015.71
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 1689.2
                    },
                    {
                      "price": 3.65,
                      "size": 3533.91
                    },
                    {
                      "price": 3.7,
                      "size": 3232.24
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90879,
          "sport_id": 1,
          "league_id": 264,
          "event_id": 32546664,
          "market_id": "1.216932075",
          "event_name": "Gefle v Orebro",
          "slug": "gefle-v-orebro",
          "runners": [
            "Gefle",
            "Orebro",
            "The Draw"
          ],
          "event_date": "2023-08-19T15:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692457200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37899239,
          "is_deleted": 0,
          "league_name": "Swedish Superettan",
          "league_slug": "swedish-superettan",
          "league_code": 12202373,
          "markets": [],
          "main_market": {
            "id": 646112,
            "match_id": 90879,
            "event_id": 32546664,
            "market_id": "1.216932075",
            "market_name": "Match Odds",
            "runners": "[\"Gefle\",\"Orebro\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Gefle\",\"selection_id\":151470},{\"runner_name\":\"Orebro\",\"selection_id\":42617},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216932075",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 151470,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.8,
                      "size": 518.66
                    },
                    {
                      "price": 3.75,
                      "size": 786.67
                    },
                    {
                      "price": 3.7,
                      "size": 457.7
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.9,
                      "size": 21.34
                    },
                    {
                      "price": 4,
                      "size": 199.48
                    },
                    {
                      "price": 4.1,
                      "size": 987.94
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 42617,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.02,
                      "size": 330.46
                    },
                    {
                      "price": 2,
                      "size": 3178.38
                    },
                    {
                      "price": 1.99,
                      "size": 139.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.08,
                      "size": 513.27
                    },
                    {
                      "price": 2.1,
                      "size": 335.31
                    },
                    {
                      "price": 2.12,
                      "size": 448.73
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.8,
                      "size": 61.8
                    },
                    {
                      "price": 3.75,
                      "size": 109.72
                    },
                    {
                      "price": 3.7,
                      "size": 1039.33
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4,
                      "size": 784.67
                    },
                    {
                      "price": 4.1,
                      "size": 159.59
                    },
                    {
                      "price": 4.2,
                      "size": 258.81
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90855,
          "sport_id": 1,
          "league_id": 21,
          "event_id": 32550822,
          "market_id": "1.216992533",
          "event_name": "Rakow Czestochowa v Stal Mielec",
          "slug": "rakow-czestochowa-v-stal-mielec",
          "runners": [
            "Rakow Czestochowa",
            "Stal Mielec",
            "The Draw"
          ],
          "event_date": "2023-08-19T15:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692459000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41755135,
          "is_deleted": 0,
          "league_name": "Polish Ekstraklasa",
          "league_slug": "polish-ekstraklasa",
          "league_code": 97,
          "markets": [],
          "main_market": {
            "id": 645872,
            "match_id": 90855,
            "event_id": 32550822,
            "market_id": "1.216992533",
            "market_name": "Match Odds",
            "runners": "[\"Rakow Czestochowa\",\"Stal Mielec\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Rakow Czestochowa\",\"selection_id\":5876552},{\"runner_name\":\"Stal Mielec\",\"selection_id\":10133739},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216992533",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5876552,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.54,
                      "size": 449.8
                    },
                    {
                      "price": 1.53,
                      "size": 874.6
                    },
                    {
                      "price": 1.52,
                      "size": 2367.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.57,
                      "size": 299.23
                    },
                    {
                      "price": 1.58,
                      "size": 622.63
                    },
                    {
                      "price": 1.59,
                      "size": 3860.85
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10133739,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 6.8,
                      "size": 167.87
                    },
                    {
                      "price": 6.6,
                      "size": 453.63
                    },
                    {
                      "price": 6.4,
                      "size": 173.15
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 7.2,
                      "size": 79.79
                    },
                    {
                      "price": 7.4,
                      "size": 385.9
                    },
                    {
                      "price": 7.6,
                      "size": 172.25
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.6,
                      "size": 70.6
                    },
                    {
                      "price": 4.5,
                      "size": 661.58
                    },
                    {
                      "price": 4.4,
                      "size": 353.5
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.8,
                      "size": 304.11
                    },
                    {
                      "price": 4.9,
                      "size": 516.16
                    },
                    {
                      "price": 5,
                      "size": 208.36
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90866,
          "sport_id": 1,
          "league_id": 272,
          "event_id": 32545386,
          "market_id": "1.216915144",
          "event_name": "Varbergs BoIS v Varnamo",
          "slug": "varbergs-bois-v-varnamo",
          "runners": [
            "Varbergs BoIS",
            "Varnamo",
            "The Draw"
          ],
          "event_date": "2023-08-19T15:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692459000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37844297,
          "is_deleted": 0,
          "league_name": "Swedish Allsvenskan",
          "league_slug": "swedish-allsvenskan",
          "league_code": 129,
          "markets": [],
          "main_market": {
            "id": 645982,
            "match_id": 90866,
            "event_id": 32545386,
            "market_id": "1.216915144",
            "market_name": "Match Odds",
            "runners": "[\"Varbergs BoIS\",\"Varnamo\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Varbergs BoIS\",\"selection_id\":6225055},{\"runner_name\":\"Varnamo\",\"selection_id\":384107},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216915144",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 6225055,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.05,
                      "size": 102.1
                    },
                    {
                      "price": 3,
                      "size": 183.12
                    },
                    {
                      "price": 2.98,
                      "size": 67.24
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.1,
                      "size": 104.64
                    },
                    {
                      "price": 3.15,
                      "size": 2223.03
                    },
                    {
                      "price": 3.2,
                      "size": 1047.86
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 384107,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.54,
                      "size": 78.01
                    },
                    {
                      "price": 2.52,
                      "size": 313.73
                    },
                    {
                      "price": 2.5,
                      "size": 2921.61
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.56,
                      "size": 192.32
                    },
                    {
                      "price": 2.6,
                      "size": 60.33
                    },
                    {
                      "price": 2.62,
                      "size": 188.23
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.45,
                      "size": 301.75
                    },
                    {
                      "price": 3.4,
                      "size": 272.42
                    },
                    {
                      "price": 3.35,
                      "size": 1262.97
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 459.55
                    },
                    {
                      "price": 3.65,
                      "size": 349.6
                    },
                    {
                      "price": 3.7,
                      "size": 2112.04
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90890,
          "sport_id": 1,
          "league_id": 37,
          "event_id": 32557051,
          "market_id": "1.217101262",
          "event_name": "Centro Atletico Fenix v Defensor Sporting",
          "slug": "centro-atletico-fenix-v-defensor-sporting-40",
          "runners": [
            "Centro Atletico Fenix",
            "Defensor Sporting",
            "The Draw"
          ],
          "event_date": "2023-08-19T15:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692459000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42708123,
          "is_deleted": 0,
          "league_name": "Uruguayan Primera Division",
          "league_slug": "uruguayan-primera-division",
          "league_code": 843454,
          "markets": [],
          "main_market": {
            "id": 646222,
            "match_id": 90890,
            "event_id": 32557051,
            "market_id": "1.217101262",
            "market_name": "Match Odds",
            "runners": "[\"Centro Atletico Fenix\",\"Defensor Sporting\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Centro Atletico Fenix\",\"selection_id\":5313392},{\"runner_name\":\"Defensor Sporting\",\"selection_id\":1222679},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217101262",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5313392,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.5,
                      "size": 21.34
                    },
                    {
                      "price": 3.45,
                      "size": 419.02
                    },
                    {
                      "price": 3.4,
                      "size": 32.08
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.65,
                      "size": 19.95
                    },
                    {
                      "price": 3.7,
                      "size": 19.95
                    },
                    {
                      "price": 3.75,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 1222679,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.42,
                      "size": 135.95
                    },
                    {
                      "price": 2.38,
                      "size": 561.21
                    },
                    {
                      "price": 2.36,
                      "size": 29.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.52,
                      "size": 89.77
                    },
                    {
                      "price": 2.54,
                      "size": 19.95
                    },
                    {
                      "price": 2.56,
                      "size": 624.3
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.1,
                      "size": 19.95
                    },
                    {
                      "price": 3.05,
                      "size": 59.85
                    },
                    {
                      "price": 3,
                      "size": 589.77
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 488.39
                    },
                    {
                      "price": 3.4,
                      "size": 94.74
                    },
                    {
                      "price": 3.45,
                      "size": 365.26
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90874,
          "sport_id": 1,
          "league_id": 355,
          "event_id": 32541055,
          "market_id": "1.216857320",
          "event_name": "Molde v Valerenga",
          "slug": "molde-v-valerenga",
          "runners": [
            "Molde",
            "Valerenga",
            "The Draw"
          ],
          "event_date": "2023-08-19T16:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692460800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37966187,
          "is_deleted": 0,
          "league_name": "Norwegian Eliteserien",
          "league_slug": "norwegian-eliteserien",
          "league_code": 11068551,
          "markets": [],
          "main_market": {
            "id": 646064,
            "match_id": 90874,
            "event_id": 32541055,
            "market_id": "1.216857320",
            "market_name": "Match Odds",
            "runners": "[\"Molde\",\"Valerenga\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Molde\",\"selection_id\":31321},{\"runner_name\":\"Valerenga\",\"selection_id\":132563},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216857320",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 31321,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.51,
                      "size": 1643.49
                    },
                    {
                      "price": 1.5,
                      "size": 6777.52
                    },
                    {
                      "price": 1.49,
                      "size": 3797.33
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.53,
                      "size": 10.44
                    },
                    {
                      "price": 1.54,
                      "size": 854.81
                    },
                    {
                      "price": 1.55,
                      "size": 2655.76
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 132563,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 6.6,
                      "size": 458.12
                    },
                    {
                      "price": 6.4,
                      "size": 563.29
                    },
                    {
                      "price": 6.2,
                      "size": 1176.99
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 7,
                      "size": 319.17
                    },
                    {
                      "price": 7.2,
                      "size": 1309.37
                    },
                    {
                      "price": 7.4,
                      "size": 739.8
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.1,
                      "size": 62.84
                    },
                    {
                      "price": 5,
                      "size": 509.22
                    },
                    {
                      "price": 4.9,
                      "size": 43.23
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.3,
                      "size": 1490.38
                    },
                    {
                      "price": 5.4,
                      "size": 592.34
                    },
                    {
                      "price": 5.5,
                      "size": 243.23
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90873,
          "sport_id": 1,
          "league_id": 355,
          "event_id": 32541058,
          "market_id": "1.216857194",
          "event_name": "Odds BK v Sarpsborg",
          "slug": "odds-bk-v-sarpsborg-34",
          "runners": [
            "Odds BK",
            "Sarpsborg",
            "The Draw"
          ],
          "event_date": "2023-08-19T16:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692460800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 37966189,
          "is_deleted": 0,
          "league_name": "Norwegian Eliteserien",
          "league_slug": "norwegian-eliteserien",
          "league_code": 11068551,
          "markets": [],
          "main_market": {
            "id": 646054,
            "match_id": 90873,
            "event_id": 32541058,
            "market_id": "1.216857194",
            "market_name": "Match Odds",
            "runners": "[\"Odds BK\",\"Sarpsborg\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Odds BK\",\"selection_id\":10833201},{\"runner_name\":\"Sarpsborg\",\"selection_id\":778903},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216857194",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 10833201,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.8,
                      "size": 1638.37
                    },
                    {
                      "price": 2.78,
                      "size": 699.04
                    },
                    {
                      "price": 2.76,
                      "size": 292.59
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.88,
                      "size": 105.9
                    },
                    {
                      "price": 2.9,
                      "size": 2447.23
                    },
                    {
                      "price": 2.92,
                      "size": 596.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 778903,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.48,
                      "size": 207.2
                    },
                    {
                      "price": 2.46,
                      "size": 614.14
                    },
                    {
                      "price": 2.44,
                      "size": 2342.33
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.52,
                      "size": 358.61
                    },
                    {
                      "price": 2.54,
                      "size": 377.78
                    },
                    {
                      "price": 2.56,
                      "size": 1064.76
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 407.66
                    },
                    {
                      "price": 3.95,
                      "size": 778.6
                    },
                    {
                      "price": 3.9,
                      "size": 1437.28
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 316.86
                    },
                    {
                      "price": 4.2,
                      "size": 1536.97
                    },
                    {
                      "price": 4.3,
                      "size": 3822.5
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90794,
          "sport_id": 1,
          "league_id": 15,
          "event_id": 32549648,
          "market_id": "1.216974296",
          "event_name": "Beroe Stara Za v Slavia Sofia",
          "slug": "beroe-stara-za-v-slavia-sofia-53",
          "runners": [
            "Beroe Stara Za",
            "Slavia Sofia",
            "The Draw"
          ],
          "event_date": "2023-08-19T16:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692460800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41753879,
          "is_deleted": 0,
          "league_name": "Bulgarian A League",
          "league_slug": "bulgarian-a-league",
          "league_code": 15,
          "markets": [],
          "main_market": {
            "id": 645353,
            "match_id": 90794,
            "event_id": 32549648,
            "market_id": "1.216974296",
            "market_name": "Match Odds",
            "runners": "[\"Beroe Stara Za\",\"Slavia Sofia\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Beroe Stara Za\",\"selection_id\":4127866},{\"runner_name\":\"Slavia Sofia\",\"selection_id\":1255221},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216974296",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 4127866,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 281.6
                    },
                    {
                      "price": 3.3,
                      "size": 140.34
                    },
                    {
                      "price": 3.25,
                      "size": 992.06
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.45,
                      "size": 669.97
                    },
                    {
                      "price": 3.5,
                      "size": 850.51
                    },
                    {
                      "price": 3.55,
                      "size": 49.87
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 1255221,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.48,
                      "size": 424.49
                    },
                    {
                      "price": 2.46,
                      "size": 151.31
                    },
                    {
                      "price": 2.44,
                      "size": 1523.72
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.6,
                      "size": 167.93
                    },
                    {
                      "price": 2.62,
                      "size": 49.87
                    },
                    {
                      "price": 2.64,
                      "size": 114.48
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.1,
                      "size": 72.01
                    },
                    {
                      "price": 3.05,
                      "size": 217.11
                    },
                    {
                      "price": 3,
                      "size": 89.83
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.25,
                      "size": 220.74
                    },
                    {
                      "price": 3.3,
                      "size": 342.61
                    },
                    {
                      "price": 3.35,
                      "size": 360.41
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90796,
          "sport_id": 1,
          "league_id": 16,
          "event_id": 32546937,
          "market_id": "1.216935759",
          "event_name": "Slaven Belupo v NK Istra",
          "slug": "slaven-belupo-v-nk-istra-34",
          "runners": [
            "Slaven Belupo",
            "NK Istra",
            "The Draw"
          ],
          "event_date": "2023-08-19T16:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692462600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41736667,
          "is_deleted": 0,
          "league_name": "Croatian 1 HNL",
          "league_slug": "croatian-1-hnl",
          "league_code": 17,
          "markets": [],
          "main_market": {
            "id": 645375,
            "match_id": 90796,
            "event_id": 32546937,
            "market_id": "1.216935759",
            "market_name": "Match Odds",
            "runners": "[\"Slaven Belupo\",\"NK Istra\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Slaven Belupo\",\"selection_id\":170923},{\"runner_name\":\"NK Istra\",\"selection_id\":3991406},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216935759",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 170923,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.56,
                      "size": 66.93
                    },
                    {
                      "price": 2.54,
                      "size": 79.79
                    },
                    {
                      "price": 2.52,
                      "size": 516.98
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.6,
                      "size": 127.97
                    },
                    {
                      "price": 2.64,
                      "size": 92.15
                    },
                    {
                      "price": 2.68,
                      "size": 49.87
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 3991406,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 213.42
                    },
                    {
                      "price": 2.98,
                      "size": 124.88
                    },
                    {
                      "price": 2.96,
                      "size": 80.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.1,
                      "size": 79.79
                    },
                    {
                      "price": 3.15,
                      "size": 370.54
                    },
                    {
                      "price": 3.2,
                      "size": 52.94
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.4,
                      "size": 75.65
                    },
                    {
                      "price": 3.35,
                      "size": 65.38
                    },
                    {
                      "price": 3.3,
                      "size": 409.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.55,
                      "size": 89.77
                    },
                    {
                      "price": 3.6,
                      "size": 138.74
                    },
                    {
                      "price": 3.65,
                      "size": 55.3
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90844,
          "sport_id": 1,
          "league_id": 18,
          "event_id": 32456029,
          "market_id": "1.215651303",
          "event_name": "Dortmund v FC Koln",
          "slug": "dortmund-v-fc-koln-80",
          "runners": [
            "Dortmund",
            "FC Koln",
            "The Draw"
          ],
          "event_date": "2023-08-19T16:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692462600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42022935,
          "is_deleted": 0,
          "league_name": "German Bundesliga",
          "league_slug": "german-bundesliga",
          "league_code": 59,
          "markets": [],
          "main_market": {
            "id": 645766,
            "match_id": 90844,
            "event_id": 32456029,
            "market_id": "1.215651303",
            "market_name": "Match Odds",
            "runners": "[\"Dortmund\",\"FC Koln\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Dortmund\",\"selection_id\":44785},{\"runner_name\":\"FC Koln\",\"selection_id\":44783},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.215651303",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 44785,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.44,
                      "size": 19272.74
                    },
                    {
                      "price": 1.43,
                      "size": 15684.55
                    },
                    {
                      "price": 1.42,
                      "size": 24244.06
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.45,
                      "size": 15380.08
                    },
                    {
                      "price": 1.46,
                      "size": 11810.46
                    },
                    {
                      "price": 1.47,
                      "size": 15031.12
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 44783,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 7.6,
                      "size": 2012.25
                    },
                    {
                      "price": 7.4,
                      "size": 3510.28
                    },
                    {
                      "price": 7.2,
                      "size": 1246.7
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 8,
                      "size": 4154.83
                    },
                    {
                      "price": 8.2,
                      "size": 2171.19
                    },
                    {
                      "price": 8.4,
                      "size": 2155.58
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.6,
                      "size": 4005.31
                    },
                    {
                      "price": 5.5,
                      "size": 3408.83
                    },
                    {
                      "price": 5.4,
                      "size": 918.89
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.7,
                      "size": 3741.4
                    },
                    {
                      "price": 5.8,
                      "size": 6502.4
                    },
                    {
                      "price": 5.9,
                      "size": 2610.51
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90787,
          "sport_id": 1,
          "league_id": 14,
          "event_id": 32550583,
          "market_id": "1.216988117",
          "event_name": "Vitesse Arnhem v PSV",
          "slug": "vitesse-arnhem-v-psv-55",
          "runners": [
            "Vitesse Arnhem",
            "PSV",
            "The Draw"
          ],
          "event_date": "2023-08-19T16:45:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692463500,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 41980117,
          "is_deleted": 0,
          "league_name": "Dutch Eredivisie",
          "league_slug": "dutch-eredivisie",
          "league_code": 9404054,
          "markets": [],
          "main_market": {
            "id": 645285,
            "match_id": 90787,
            "event_id": 32550583,
            "market_id": "1.216988117",
            "market_name": "Match Odds",
            "runners": "[\"Vitesse Arnhem\",\"PSV\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Vitesse Arnhem\",\"selection_id\":56363},{\"runner_name\":\"PSV\",\"selection_id\":48451},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216988117",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 56363,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 6.4,
                      "size": 15.04
                    },
                    {
                      "price": 6.2,
                      "size": 679
                    },
                    {
                      "price": 6,
                      "size": 1358.35
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.6,
                      "size": 791.07
                    },
                    {
                      "price": 6.8,
                      "size": 1619.89
                    },
                    {
                      "price": 7,
                      "size": 293.86
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 48451,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.58,
                      "size": 857.88
                    },
                    {
                      "price": 1.57,
                      "size": 955.04
                    },
                    {
                      "price": 1.56,
                      "size": 1646.8
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.59,
                      "size": 787.07
                    },
                    {
                      "price": 1.6,
                      "size": 3881.61
                    },
                    {
                      "price": 1.61,
                      "size": 2457.75
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.7,
                      "size": 1051.59
                    },
                    {
                      "price": 4.6,
                      "size": 333.65
                    },
                    {
                      "price": 4.5,
                      "size": 495.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.8,
                      "size": 364.26
                    },
                    {
                      "price": 4.9,
                      "size": 612.73
                    },
                    {
                      "price": 5,
                      "size": 1489.38
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90818,
          "sport_id": 1,
          "league_id": 11,
          "event_id": 32547112,
          "market_id": "1.216937658",
          "event_name": "Lyon v Montpellier",
          "slug": "lyon-v-montpellier-74",
          "runners": [
            "Lyon",
            "Montpellier",
            "The Draw"
          ],
          "event_date": "2023-08-19T17:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692464400,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42004547,
          "is_deleted": 0,
          "league_name": "French Ligue 1",
          "league_slug": "french-ligue-1",
          "league_code": 55,
          "markets": [],
          "main_market": {
            "id": 645506,
            "match_id": 90818,
            "event_id": 32547112,
            "market_id": "1.216937658",
            "market_name": "Match Odds",
            "runners": "[\"Lyon\",\"Montpellier\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Lyon\",\"selection_id\":55271},{\"runner_name\":\"Montpellier\",\"selection_id\":44797},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216937658",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 55271,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.78,
                      "size": 2542.68
                    },
                    {
                      "price": 1.77,
                      "size": 6262.62
                    },
                    {
                      "price": 1.76,
                      "size": 1674.95
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.79,
                      "size": 502.97
                    },
                    {
                      "price": 1.8,
                      "size": 644.51
                    },
                    {
                      "price": 1.81,
                      "size": 2145.37
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 44797,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.7,
                      "size": 274.83
                    },
                    {
                      "price": 4.6,
                      "size": 2177.15
                    },
                    {
                      "price": 4.5,
                      "size": 2222.69
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.8,
                      "size": 1691.63
                    },
                    {
                      "price": 4.9,
                      "size": 3212.09
                    },
                    {
                      "price": 5,
                      "size": 5488.86
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.3,
                      "size": 3063.95
                    },
                    {
                      "price": 4.2,
                      "size": 6455.15
                    },
                    {
                      "price": 4.1,
                      "size": 2658.08
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 686.8
                    },
                    {
                      "price": 4.5,
                      "size": 6753.48
                    },
                    {
                      "price": 4.6,
                      "size": 9783.73
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90821,
          "sport_id": 1,
          "league_id": 13,
          "event_id": 32555070,
          "market_id": "1.217059804",
          "event_name": "Espanyol v Racing Santander",
          "slug": "espanyol-v-racing-santander",
          "runners": [
            "Espanyol",
            "Racing Santander",
            "The Draw"
          ],
          "event_date": "2023-08-19T17:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692464400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41983827,
          "is_deleted": 0,
          "league_name": "Spanish Segunda Division",
          "league_slug": "spanish-segunda-division",
          "league_code": 12204313,
          "markets": [],
          "main_market": {
            "id": 645534,
            "match_id": 90821,
            "event_id": 32555070,
            "market_id": "1.217059804",
            "market_name": "Match Odds",
            "runners": "[\"Espanyol\",\"Racing Santander\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Espanyol\",\"selection_id\":59044},{\"runner_name\":\"Racing Santander\",\"selection_id\":24072},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217059804",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 59044,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.86,
                      "size": 243.39
                    },
                    {
                      "price": 1.85,
                      "size": 99.94
                    },
                    {
                      "price": 1.83,
                      "size": 119.69
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.88,
                      "size": 959.5
                    },
                    {
                      "price": 1.89,
                      "size": 179.54
                    },
                    {
                      "price": 1.9,
                      "size": 2550.4
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 24072,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.5,
                      "size": 259.33
                    },
                    {
                      "price": 5.4,
                      "size": 39.9
                    },
                    {
                      "price": 5.3,
                      "size": 1167.12
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.7,
                      "size": 117.24
                    },
                    {
                      "price": 5.8,
                      "size": 591.54
                    },
                    {
                      "price": 5.9,
                      "size": 81.21
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.5,
                      "size": 109.72
                    },
                    {
                      "price": 3.45,
                      "size": 965.8
                    },
                    {
                      "price": 3.4,
                      "size": 888.86
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 612.83
                    },
                    {
                      "price": 3.65,
                      "size": 70.6
                    },
                    {
                      "price": 3.7,
                      "size": 59.2
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90858,
          "sport_id": 1,
          "league_id": 22,
          "event_id": 32555784,
          "market_id": "1.217072586",
          "event_name": "Chaves v Braga",
          "slug": "chaves-v-braga-82",
          "runners": [
            "Chaves",
            "Braga",
            "The Draw"
          ],
          "event_date": "2023-08-19T17:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692464400,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42146141,
          "is_deleted": 0,
          "league_name": "Portuguese Primeira Liga",
          "league_slug": "portuguese-primeira-liga",
          "league_code": 99,
          "markets": [],
          "main_market": {
            "id": 645904,
            "match_id": 90858,
            "event_id": 32555784,
            "market_id": "1.217072586",
            "market_name": "Match Odds",
            "runners": "[\"Chaves\",\"Braga\",\"The Draw\"]",
            "stake_limit": 10000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Chaves\",\"selection_id\":311029},{\"runner_name\":\"Braga\",\"selection_id\":48799},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217072586",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 311029,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.3,
                      "size": 419.6
                    },
                    {
                      "price": 5.2,
                      "size": 139.4
                    },
                    {
                      "price": 5.1,
                      "size": 935.35
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.4,
                      "size": 307.26
                    },
                    {
                      "price": 5.5,
                      "size": 598.29
                    },
                    {
                      "price": 5.6,
                      "size": 390.8
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 48799,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.69,
                      "size": 500.22
                    },
                    {
                      "price": 1.68,
                      "size": 2246.98
                    },
                    {
                      "price": 1.67,
                      "size": 1334.49
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.7,
                      "size": 1664.34
                    },
                    {
                      "price": 1.71,
                      "size": 109.72
                    },
                    {
                      "price": 1.72,
                      "size": 688.82
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 349.1
                    },
                    {
                      "price": 4.4,
                      "size": 906.04
                    },
                    {
                      "price": 4.3,
                      "size": 3415.88
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 1160.7
                    },
                    {
                      "price": 4.7,
                      "size": 373.66
                    },
                    {
                      "price": 4.8,
                      "size": 537.75
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 10000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90822,
          "sport_id": 1,
          "league_id": 13,
          "event_id": 32555067,
          "market_id": "1.217059912",
          "event_name": "Levante v Burgos",
          "slug": "levante-v-burgos-84",
          "runners": [
            "Levante",
            "Burgos",
            "The Draw"
          ],
          "event_date": "2023-08-19T17:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692466200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41983831,
          "is_deleted": 0,
          "league_name": "Spanish Segunda Division",
          "league_slug": "spanish-segunda-division",
          "league_code": 12204313,
          "markets": [],
          "main_market": {
            "id": 645544,
            "match_id": 90822,
            "event_id": 32555067,
            "market_id": "1.217059912",
            "market_name": "Match Odds",
            "runners": "[\"Levante\",\"Burgos\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Levante\",\"selection_id\":214865},{\"runner_name\":\"Burgos\",\"selection_id\":968180},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217059912",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 214865,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.76,
                      "size": 272.3
                    },
                    {
                      "price": 1.75,
                      "size": 199.48
                    },
                    {
                      "price": 1.74,
                      "size": 512.12
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.8,
                      "size": 89.77
                    },
                    {
                      "price": 1.81,
                      "size": 1840.24
                    },
                    {
                      "price": 1.82,
                      "size": 189.51
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 968180,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 6.2,
                      "size": 381.21
                    },
                    {
                      "price": 6,
                      "size": 82.69
                    },
                    {
                      "price": 5.9,
                      "size": 59.85
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.6,
                      "size": 79.79
                    },
                    {
                      "price": 6.8,
                      "size": 79.79
                    },
                    {
                      "price": 7,
                      "size": 586.18
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.45,
                      "size": 145.62
                    },
                    {
                      "price": 3.4,
                      "size": 157.24
                    },
                    {
                      "price": 3.35,
                      "size": 1085.15
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.65,
                      "size": 1082.7
                    },
                    {
                      "price": 3.7,
                      "size": 238.34
                    },
                    {
                      "price": 3.75,
                      "size": 172.89
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90862,
          "sport_id": 1,
          "league_id": 24,
          "event_id": 32487008,
          "market_id": "1.216074972",
          "event_name": "Almeria v Real Madrid",
          "slug": "almeria-v-real-madrid-68",
          "runners": [
            "Almeria",
            "Real Madrid",
            "The Draw"
          ],
          "event_date": "2023-08-19T17:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692466200,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 41892917,
          "is_deleted": 0,
          "league_name": "Spanish La Liga",
          "league_slug": "spanish-la-liga",
          "league_code": 117,
          "markets": [],
          "main_market": {
            "id": 645946,
            "match_id": 90862,
            "event_id": 32487008,
            "market_id": "1.216074972",
            "market_name": "Match Odds",
            "runners": "[\"Almeria\",\"Real Madrid\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Almeria\",\"selection_id\":248020},{\"runner_name\":\"Real Madrid\",\"selection_id\":2426},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216074972",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 248020,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 9.6,
                      "size": 627.63
                    },
                    {
                      "price": 9.4,
                      "size": 1447.6
                    },
                    {
                      "price": 9.2,
                      "size": 2431.18
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 9.8,
                      "size": 792.88
                    },
                    {
                      "price": 10,
                      "size": 2269.28
                    },
                    {
                      "price": 10.5,
                      "size": 2946.35
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 2426,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.38,
                      "size": 19276.82
                    },
                    {
                      "price": 1.37,
                      "size": 32125.18
                    },
                    {
                      "price": 1.36,
                      "size": 9055.68
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.39,
                      "size": 8619.65
                    },
                    {
                      "price": 1.4,
                      "size": 22140.28
                    },
                    {
                      "price": 1.41,
                      "size": 19240.52
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.7,
                      "size": 520.47
                    },
                    {
                      "price": 5.6,
                      "size": 3798.32
                    },
                    {
                      "price": 5.5,
                      "size": 2768.57
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.8,
                      "size": 766.13
                    },
                    {
                      "price": 5.9,
                      "size": 1992.54
                    },
                    {
                      "price": 6,
                      "size": 3819.18
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90856,
          "sport_id": 1,
          "league_id": 21,
          "event_id": 32550820,
          "market_id": "1.216991986",
          "event_name": "Ruch Chorzow v Jagiellonia Bialystock",
          "slug": "ruch-chorzow-v-jagiellonia-bialystock",
          "runners": [
            "Ruch Chorzow",
            "Jagiellonia Bialystock",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692468000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41755137,
          "is_deleted": 0,
          "league_name": "Polish Ekstraklasa",
          "league_slug": "polish-ekstraklasa",
          "league_code": 97,
          "markets": [],
          "main_market": {
            "id": 645882,
            "match_id": 90856,
            "event_id": 32550820,
            "market_id": "1.216991986",
            "market_name": "Match Odds",
            "runners": "[\"Ruch Chorzow\",\"Jagiellonia Bialystock\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Ruch Chorzow\",\"selection_id\":2160683},{\"runner_name\":\"Jagiellonia Bialystock\",\"selection_id\":7391394},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216991986",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 2160683,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.68,
                      "size": 149.61
                    },
                    {
                      "price": 2.66,
                      "size": 129.66
                    },
                    {
                      "price": 2.64,
                      "size": 781.18
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.76,
                      "size": 123.84
                    },
                    {
                      "price": 2.78,
                      "size": 129.66
                    },
                    {
                      "price": 2.8,
                      "size": 130.29
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7391394,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.84,
                      "size": 113.69
                    },
                    {
                      "price": 2.82,
                      "size": 89.77
                    },
                    {
                      "price": 2.8,
                      "size": 89.77
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.92,
                      "size": 34.01
                    },
                    {
                      "price": 2.94,
                      "size": 665.78
                    },
                    {
                      "price": 2.96,
                      "size": 89.77
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.45,
                      "size": 36.21
                    },
                    {
                      "price": 3.4,
                      "size": 616.51
                    },
                    {
                      "price": 3.35,
                      "size": 228.28
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 213.83
                    },
                    {
                      "price": 3.65,
                      "size": 205.06
                    },
                    {
                      "price": 3.7,
                      "size": 657.91
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90882,
          "sport_id": 1,
          "league_id": 245,
          "event_id": 32560368,
          "market_id": "1.217154172",
          "event_name": "Deinze v KV Oostende",
          "slug": "deinze-v-kv-oostende",
          "runners": [
            "Deinze",
            "KV Oostende",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692468000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41894195,
          "is_deleted": 0,
          "league_name": "Belgian First Division B",
          "league_slug": "belgian-first-division-b",
          "league_code": 11717188,
          "markets": [],
          "main_market": {
            "id": 646142,
            "match_id": 90882,
            "event_id": 32560368,
            "market_id": "1.217154172",
            "market_name": "Match Odds",
            "runners": "[\"Deinze\",\"KV Oostende\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Deinze\",\"selection_id\":505713},{\"runner_name\":\"KV Oostende\",\"selection_id\":13053079},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217154172",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 505713,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.6,
                      "size": 39.9
                    },
                    {
                      "price": 2.58,
                      "size": 29.92
                    },
                    {
                      "price": 2.56,
                      "size": 29.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.72,
                      "size": 96.35
                    },
                    {
                      "price": 2.74,
                      "size": 29.92
                    },
                    {
                      "price": 2.76,
                      "size": 29.92
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 13053079,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.74,
                      "size": 39.9
                    },
                    {
                      "price": 2.72,
                      "size": 29.92
                    },
                    {
                      "price": 2.7,
                      "size": 29.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.86,
                      "size": 29.92
                    },
                    {
                      "price": 2.88,
                      "size": 69.22
                    },
                    {
                      "price": 2.9,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.65,
                      "size": 67.13
                    },
                    {
                      "price": 3.6,
                      "size": 29.92
                    },
                    {
                      "price": 3.55,
                      "size": 29.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.9,
                      "size": 19.95
                    },
                    {
                      "price": 3.95,
                      "size": 19.95
                    },
                    {
                      "price": 4,
                      "size": 75.8
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90788,
          "sport_id": 1,
          "league_id": 14,
          "event_id": 32542226,
          "market_id": "1.216876959",
          "event_name": "Fortuna Sittard v Almere City",
          "slug": "fortuna-sittard-v-almere-city",
          "runners": [
            "Fortuna Sittard",
            "Almere City",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692468000,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 41980119,
          "is_deleted": 0,
          "league_name": "Dutch Eredivisie",
          "league_slug": "dutch-eredivisie",
          "league_code": 9404054,
          "markets": [],
          "main_market": {
            "id": 645295,
            "match_id": 90788,
            "event_id": 32542226,
            "market_id": "1.216876959",
            "market_name": "Match Odds",
            "runners": "[\"Fortuna Sittard\",\"Almere City\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Fortuna Sittard\",\"selection_id\":49058},{\"runner_name\":\"Almere City\",\"selection_id\":4835124},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216876959",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 49058,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.98,
                      "size": 344.2
                    },
                    {
                      "price": 1.97,
                      "size": 710.16
                    },
                    {
                      "price": 1.96,
                      "size": 2080.69
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2,
                      "size": 1832.79
                    },
                    {
                      "price": 2.02,
                      "size": 1770.14
                    },
                    {
                      "price": 2.04,
                      "size": 2239.67
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 4835124,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 841.5
                    },
                    {
                      "price": 3.95,
                      "size": 2474.59
                    },
                    {
                      "price": 3.9,
                      "size": 1467.5
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 466.83
                    },
                    {
                      "price": 4.2,
                      "size": 2955.29
                    },
                    {
                      "price": 4.3,
                      "size": 789.16
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 1565.24
                    },
                    {
                      "price": 3.95,
                      "size": 132.61
                    },
                    {
                      "price": 3.9,
                      "size": 832.2
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 2172
                    },
                    {
                      "price": 4.2,
                      "size": 2009.69
                    },
                    {
                      "price": 4.3,
                      "size": 2519.67
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90721,
          "sport_id": 1,
          "league_id": 50,
          "event_id": 32565446,
          "market_id": "1.217227087",
          "event_name": "Alianza Atletico v Union Comercio",
          "slug": "alianza-atletico-v-union-comercio",
          "runners": [
            "Alianza Atletico",
            "Union Comercio",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692468000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42684571,
          "is_deleted": 0,
          "league_name": "Peruvian Primera Division",
          "league_slug": "peruvian-primera-division",
          "league_code": 8594603,
          "markets": [],
          "main_market": {
            "id": 644783,
            "match_id": 90721,
            "event_id": 32565446,
            "market_id": "1.217227087",
            "market_name": "Match Odds",
            "runners": "[\"Alianza Atletico\",\"Union Comercio\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Alianza Atletico\",\"selection_id\":898396},{\"runner_name\":\"Union Comercio\",\"selection_id\":5481419},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217227087",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 898396,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.82,
                      "size": 825.28
                    },
                    {
                      "price": 1.81,
                      "size": 168.9
                    },
                    {
                      "price": 1.77,
                      "size": 267.39
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.88,
                      "size": 151.61
                    },
                    {
                      "price": 1.89,
                      "size": 418.42
                    },
                    {
                      "price": 1.91,
                      "size": 137.86
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 5481419,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.8,
                      "size": 54.86
                    },
                    {
                      "price": 4.7,
                      "size": 211.65
                    },
                    {
                      "price": 4.5,
                      "size": 244.31
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5,
                      "size": 61.14
                    },
                    {
                      "price": 5.4,
                      "size": 38.9
                    },
                    {
                      "price": 5.5,
                      "size": 204.28
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 81.49
                    },
                    {
                      "price": 3.7,
                      "size": 304.64
                    },
                    {
                      "price": 3.5,
                      "size": 264.33
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4,
                      "size": 148.22
                    },
                    {
                      "price": 4.1,
                      "size": 19.95
                    },
                    {
                      "price": 4.2,
                      "size": 62.69
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90881,
          "sport_id": 1,
          "league_id": 245,
          "event_id": 32560366,
          "market_id": "1.217154262",
          "event_name": "Waasland-Beveren v Seraing Utd",
          "slug": "waasland-beveren-v-seraing-utd",
          "runners": [
            "Waasland-Beveren",
            "Seraing Utd",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692468000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Belgian First Division B",
          "league_slug": "belgian-first-division-b",
          "league_code": 11717188,
          "markets": [],
          "main_market": {
            "id": 646132,
            "match_id": 90881,
            "event_id": 32560366,
            "market_id": "1.217154262",
            "market_name": "Match Odds",
            "runners": "[\"Waasland-Beveren\",\"Seraing Utd\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Waasland-Beveren\",\"selection_id\":4910879},{\"runner_name\":\"Seraing Utd\",\"selection_id\":8727584},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217154262",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 4910879,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.79,
                      "size": 129.66
                    },
                    {
                      "price": 1.78,
                      "size": 69.82
                    },
                    {
                      "price": 1.77,
                      "size": 442.56
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.84,
                      "size": 159.59
                    },
                    {
                      "price": 1.85,
                      "size": 59.85
                    },
                    {
                      "price": 1.86,
                      "size": 152.51
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 8727584,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 79.99
                    },
                    {
                      "price": 4.4,
                      "size": 59.85
                    },
                    {
                      "price": 4.3,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.8,
                      "size": 230.1
                    },
                    {
                      "price": 4.9,
                      "size": 589.84
                    },
                    {
                      "price": 5,
                      "size": 838.46
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.2,
                      "size": 49.87
                    },
                    {
                      "price": 4.1,
                      "size": 248.76
                    },
                    {
                      "price": 4,
                      "size": 259.15
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.5,
                      "size": 152.51
                    },
                    {
                      "price": 4.6,
                      "size": 275.47
                    },
                    {
                      "price": 4.7,
                      "size": 57.13
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90795,
          "sport_id": 1,
          "league_id": 15,
          "event_id": 32549644,
          "market_id": "1.216974566",
          "event_name": "Botev Vratsa v CSKA Sofia",
          "slug": "botev-vratsa-v-cska-sofia-57",
          "runners": [
            "Botev Vratsa",
            "CSKA Sofia",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:15:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692468900,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41753875,
          "is_deleted": 0,
          "league_name": "Bulgarian A League",
          "league_slug": "bulgarian-a-league",
          "league_code": 15,
          "markets": [],
          "main_market": {
            "id": 645363,
            "match_id": 90795,
            "event_id": 32549644,
            "market_id": "1.216974566",
            "market_name": "Match Odds",
            "runners": "[\"Botev Vratsa\",\"CSKA Sofia\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Botev Vratsa\",\"selection_id\":5618938},{\"runner_name\":\"CSKA Sofia\",\"selection_id\":46982},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216974566",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5618938,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 14,
                      "size": 78.8
                    },
                    {
                      "price": 13,
                      "size": 26.23
                    },
                    {
                      "price": 12.5,
                      "size": 35.72
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 16,
                      "size": 37.56
                    },
                    {
                      "price": 17,
                      "size": 60.04
                    },
                    {
                      "price": 17.5,
                      "size": 41.61
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 46982,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.3,
                      "size": 148.02
                    },
                    {
                      "price": 1.29,
                      "size": 564.44
                    },
                    {
                      "price": 1.28,
                      "size": 488.74
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.32,
                      "size": 1514.06
                    },
                    {
                      "price": 1.33,
                      "size": 309.37
                    },
                    {
                      "price": 1.34,
                      "size": 535.51
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 6,
                      "size": 166.49
                    },
                    {
                      "price": 5.9,
                      "size": 19.95
                    },
                    {
                      "price": 5.7,
                      "size": 168.17
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.4,
                      "size": 104.17
                    },
                    {
                      "price": 6.6,
                      "size": 295.94
                    },
                    {
                      "price": 6.8,
                      "size": 46.8
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90798,
          "sport_id": 1,
          "league_id": 319,
          "event_id": 32551051,
          "market_id": "1.216995632",
          "event_name": "Avai v Tombense MG",
          "slug": "avai-v-tombense-mg",
          "runners": [
            "Avai",
            "Tombense MG",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692469800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39464083,
          "is_deleted": 0,
          "league_name": "Brazilian Serie B",
          "league_slug": "brazilian-serie-b",
          "league_code": 321319,
          "markets": [],
          "main_market": {
            "id": 645395,
            "match_id": 90798,
            "event_id": 32551051,
            "market_id": "1.216995632",
            "market_name": "Match Odds",
            "runners": "[\"Avai\",\"Tombense MG\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Avai\",\"selection_id\":3859186},{\"runner_name\":\"Tombense MG\",\"selection_id\":14163917},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216995632",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 3859186,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.14,
                      "size": 1373.82
                    },
                    {
                      "price": 2.12,
                      "size": 1919.98
                    },
                    {
                      "price": 2.1,
                      "size": 701.39
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.22,
                      "size": 820.96
                    },
                    {
                      "price": 2.24,
                      "size": 1193.45
                    },
                    {
                      "price": 2.26,
                      "size": 878.72
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 14163917,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.1,
                      "size": 658.35
                    },
                    {
                      "price": 4,
                      "size": 669.79
                    },
                    {
                      "price": 3.95,
                      "size": 684.73
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.3,
                      "size": 201.7
                    },
                    {
                      "price": 4.4,
                      "size": 419.03
                    },
                    {
                      "price": 4.5,
                      "size": 817.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.25,
                      "size": 238.42
                    },
                    {
                      "price": 3.2,
                      "size": 127.92
                    },
                    {
                      "price": 3.15,
                      "size": 829.71
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 371.06
                    },
                    {
                      "price": 3.4,
                      "size": 838.89
                    },
                    {
                      "price": 3.45,
                      "size": 399.08
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90848,
          "sport_id": 1,
          "league_id": 19,
          "event_id": 32524104,
          "market_id": "1.216608463",
          "event_name": "Hamburger SV v Hertha Berlin",
          "slug": "hamburger-sv-v-hertha-berlin",
          "runners": [
            "Hamburger SV",
            "Hertha Berlin",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692469800,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42023741,
          "is_deleted": 0,
          "league_name": "German Bundesliga 2",
          "league_slug": "german-bundesliga-2",
          "league_code": 61,
          "markets": [],
          "main_market": {
            "id": 645802,
            "match_id": 90848,
            "event_id": 32524104,
            "market_id": "1.216608463",
            "market_name": "Match Odds",
            "runners": "[\"Hamburger SV\",\"Hertha Berlin\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Hamburger SV\",\"selection_id\":44784},{\"runner_name\":\"Hertha Berlin\",\"selection_id\":44518},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216608463",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 44784,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.9,
                      "size": 40.1
                    },
                    {
                      "price": 1.89,
                      "size": 69.82
                    },
                    {
                      "price": 1.88,
                      "size": 312.89
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.91,
                      "size": 147.52
                    },
                    {
                      "price": 1.92,
                      "size": 99.74
                    },
                    {
                      "price": 1.93,
                      "size": 596.47
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 44518,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 125.77
                    },
                    {
                      "price": 3.95,
                      "size": 543.38
                    },
                    {
                      "price": 3.9,
                      "size": 371.47
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 349.6
                    },
                    {
                      "price": 4.2,
                      "size": 2594.08
                    },
                    {
                      "price": 4.3,
                      "size": 1459.04
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.3,
                      "size": 1377.73
                    },
                    {
                      "price": 4.2,
                      "size": 1357.71
                    },
                    {
                      "price": 4.1,
                      "size": 450
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.5,
                      "size": 513.94
                    },
                    {
                      "price": 4.6,
                      "size": 593.01
                    },
                    {
                      "price": 4.7,
                      "size": 1680.2
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90891,
          "sport_id": 1,
          "league_id": 37,
          "event_id": 32557269,
          "market_id": "1.217104574",
          "event_name": "Cerro v Penarol",
          "slug": "cerro-v-penarol",
          "runners": [
            "Cerro",
            "Penarol",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692469800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42708119,
          "is_deleted": 0,
          "league_name": "Uruguayan Primera Division",
          "league_slug": "uruguayan-primera-division",
          "league_code": 843454,
          "markets": [],
          "main_market": {
            "id": 646232,
            "match_id": 90891,
            "event_id": 32557269,
            "market_id": "1.217104574",
            "market_name": "Match Odds",
            "runners": "[\"Cerro\",\"Penarol\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Cerro\",\"selection_id\":2329297},{\"runner_name\":\"Penarol\",\"selection_id\":328191},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217104574",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 2329297,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 6.2,
                      "size": 140.84
                    },
                    {
                      "price": 6,
                      "size": 50.01
                    },
                    {
                      "price": 5.9,
                      "size": 54
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.6,
                      "size": 43.2
                    },
                    {
                      "price": 6.8,
                      "size": 48.63
                    },
                    {
                      "price": 7,
                      "size": 237.94
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 328191,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.74,
                      "size": 28.52
                    },
                    {
                      "price": 1.73,
                      "size": 125.51
                    },
                    {
                      "price": 1.72,
                      "size": 285.28
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.77,
                      "size": 49.87
                    },
                    {
                      "price": 1.78,
                      "size": 86.41
                    },
                    {
                      "price": 1.79,
                      "size": 275.98
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.6,
                      "size": 100.82
                    },
                    {
                      "price": 3.55,
                      "size": 59.85
                    },
                    {
                      "price": 3.5,
                      "size": 85.07
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.7,
                      "size": 107.62
                    },
                    {
                      "price": 3.75,
                      "size": 66.83
                    },
                    {
                      "price": 3.8,
                      "size": 356.37
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90802,
          "sport_id": 1,
          "league_id": 528,
          "event_id": 32561942,
          "market_id": "1.217176353",
          "event_name": "AEK Athens v Dinamo Zagreb",
          "slug": "aek-athens-v-dinamo-zagreb-28",
          "runners": [
            "AEK Athens",
            "Dinamo Zagreb",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:45:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692470700,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42845773,
          "is_deleted": 0,
          "league_name": "UEFA Champions League Qualifiers",
          "league_slug": "uefa-champions-league-qualifiers",
          "league_code": 12242357,
          "markets": [],
          "main_market": {
            "id": 645435,
            "match_id": 90802,
            "event_id": 32561942,
            "market_id": "1.217176353",
            "market_name": "Match Odds",
            "runners": "[\"AEK Athens\",\"Dinamo Zagreb\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "8",
            "selection_runner": "[{\"runner_name\":\"AEK Athens\",\"selection_id\":10758},{\"runner_name\":\"Dinamo Zagreb\",\"selection_id\":52628041},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217176353",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 10758,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.97,
                      "size": 1003.6
                    },
                    {
                      "price": 1.96,
                      "size": 39.9
                    },
                    {
                      "price": 1.95,
                      "size": 35.8
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.98,
                      "size": 339.12
                    },
                    {
                      "price": 1.99,
                      "size": 1461.15
                    },
                    {
                      "price": 2,
                      "size": 2610.78
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 52628041,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.6,
                      "size": 576.01
                    },
                    {
                      "price": 4.5,
                      "size": 289.25
                    },
                    {
                      "price": 4.4,
                      "size": 173.19
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.7,
                      "size": 470.42
                    },
                    {
                      "price": 4.8,
                      "size": 3108.69
                    },
                    {
                      "price": 4.9,
                      "size": 272.58
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.6,
                      "size": 939.67
                    },
                    {
                      "price": 3.55,
                      "size": 2826.82
                    },
                    {
                      "price": 3.5,
                      "size": 99.74
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.65,
                      "size": 541.67
                    },
                    {
                      "price": 3.7,
                      "size": 79.9
                    },
                    {
                      "price": 3.75,
                      "size": 137.05
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90817,
          "sport_id": 1,
          "league_id": 10,
          "event_id": 32553880,
          "market_id": "1.217038600",
          "event_name": "Yellow-Red Mechelen v Union St Gilloise",
          "slug": "yellow-red-mechelen-v-union-st-gilloise-15",
          "runners": [
            "Yellow-Red Mechelen",
            "Union St Gilloise",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:45:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692470700,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Belgian First Division A",
          "league_slug": "belgian-first-division-a",
          "league_code": 89979,
          "markets": [],
          "main_market": {
            "id": 645494,
            "match_id": 90817,
            "event_id": 32553880,
            "market_id": "1.217038600",
            "market_name": "Match Odds",
            "runners": "[\"Yellow-Red Mechelen\",\"Union St Gilloise\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Yellow-Red Mechelen\",\"selection_id\":13052998},{\"runner_name\":\"Union St Gilloise\",\"selection_id\":892024},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217038600",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 13052998,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.7,
                      "size": 454.62
                    },
                    {
                      "price": 4.6,
                      "size": 965.67
                    },
                    {
                      "price": 4.5,
                      "size": 293.22
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.9,
                      "size": 52.72
                    },
                    {
                      "price": 5,
                      "size": 899.67
                    },
                    {
                      "price": 5.1,
                      "size": 666.26
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 892024,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.77,
                      "size": 145.95
                    },
                    {
                      "price": 1.76,
                      "size": 32.91
                    },
                    {
                      "price": 1.75,
                      "size": 548.58
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.79,
                      "size": 310.39
                    },
                    {
                      "price": 1.8,
                      "size": 383.85
                    },
                    {
                      "price": 1.81,
                      "size": 586.89
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.3,
                      "size": 167.27
                    },
                    {
                      "price": 4.2,
                      "size": 1234.56
                    },
                    {
                      "price": 4.1,
                      "size": 1106.62
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 239.18
                    },
                    {
                      "price": 4.5,
                      "size": 611.32
                    },
                    {
                      "price": 4.6,
                      "size": 112.34
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90868,
          "sport_id": 1,
          "league_id": 25,
          "event_id": 32552327,
          "market_id": "1.217014909",
          "event_name": "FC Voluntari v Dinamo Bucharest",
          "slug": "fc-voluntari-v-dinamo-bucharest",
          "runners": [
            "FC Voluntari",
            "Dinamo Bucharest",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:45:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692470700,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41978213,
          "is_deleted": 0,
          "league_name": "Romanian Liga I",
          "league_slug": "romanian-liga-i",
          "league_code": 4905,
          "markets": [],
          "main_market": {
            "id": 646002,
            "match_id": 90868,
            "event_id": 32552327,
            "market_id": "1.217014909",
            "market_name": "Match Odds",
            "runners": "[\"FC Voluntari\",\"Dinamo Bucharest\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"FC Voluntari\",\"selection_id\":8838645},{\"runner_name\":\"Dinamo Bucharest\",\"selection_id\":46937},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217014909",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 8838645,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.99,
                      "size": 139.64
                    },
                    {
                      "price": 1.98,
                      "size": 303.58
                    },
                    {
                      "price": 1.97,
                      "size": 521.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.06,
                      "size": 707.67
                    },
                    {
                      "price": 2.08,
                      "size": 229.41
                    },
                    {
                      "price": 2.1,
                      "size": 835.1
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 46937,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.3,
                      "size": 99.74
                    },
                    {
                      "price": 4.2,
                      "size": 391.1
                    },
                    {
                      "price": 4.1,
                      "size": 108.42
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 332.85
                    },
                    {
                      "price": 4.7,
                      "size": 79.79
                    },
                    {
                      "price": 4.8,
                      "size": 39.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.45,
                      "size": 252.32
                    },
                    {
                      "price": 3.4,
                      "size": 2209.39
                    },
                    {
                      "price": 3.35,
                      "size": 1034.01
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 139.54
                    },
                    {
                      "price": 3.65,
                      "size": 19.95
                    },
                    {
                      "price": 3.7,
                      "size": 209.46
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90887,
          "sport_id": 1,
          "league_id": 512,
          "event_id": 32568205,
          "market_id": "1.217270976",
          "event_name": "Sliema Wanderers FC v Valletta",
          "slug": "sliema-wanderers-fc-v-valletta",
          "runners": [
            "Sliema Wanderers FC",
            "Valletta",
            "The Draw"
          ],
          "event_date": "2023-08-19T18:45:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692470700,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Friendly Matches",
          "league_slug": "friendly-matches",
          "league_code": 12005859,
          "markets": [],
          "main_market": {
            "id": 646192,
            "match_id": 90887,
            "event_id": 32568205,
            "market_id": "1.217270976",
            "market_name": "Match Odds",
            "runners": "[\"Sliema Wanderers FC\",\"Valletta\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Sliema Wanderers FC\",\"selection_id\":21900459},{\"runner_name\":\"Valletta\",\"selection_id\":166888},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217270976",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 21900459,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.7,
                      "size": 49.87
                    },
                    {
                      "price": 2.08,
                      "size": 138.54
                    },
                    {
                      "price": 1.87,
                      "size": 108.62
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5,
                      "size": 35.18
                    },
                    {
                      "price": 10.5,
                      "size": 68.62
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 166888,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.88,
                      "size": 93.56
                    },
                    {
                      "price": 1.28,
                      "size": 952.49
                    },
                    {
                      "price": 1.14,
                      "size": 162.53
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.16,
                      "size": 85.43
                    },
                    {
                      "price": 2.96,
                      "size": 68.62
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 49.87
                    },
                    {
                      "price": 2.42,
                      "size": 29.92
                    },
                    {
                      "price": 2.1,
                      "size": 136.05
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.1,
                      "size": 34.49
                    },
                    {
                      "price": 7.8,
                      "size": 68.62
                    },
                    {
                      "price": 32,
                      "size": 49.87
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90914,
          "sport_id": 1,
          "league_id": 151,
          "event_id": 32563870,
          "market_id": "1.217205448",
          "event_name": "Estudiantes de Merida v Monagas",
          "slug": "estudiantes-de-merida-v-monagas",
          "runners": [
            "Estudiantes de Merida",
            "Monagas",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39191497,
          "is_deleted": 0,
          "league_name": "Venezuelan Primera Division",
          "league_slug": "venezuelan-primera-division",
          "league_code": 1065530,
          "markets": [],
          "main_market": {
            "id": 646462,
            "match_id": 90914,
            "event_id": 32563870,
            "market_id": "1.217205448",
            "market_name": "Match Odds",
            "runners": "[\"Estudiantes de Merida\",\"Monagas\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Estudiantes de Merida\",\"selection_id\":7838019},{\"runner_name\":\"Monagas\",\"selection_id\":224547},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217205448",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 7838019,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.62,
                      "size": 30.52
                    },
                    {
                      "price": 2.6,
                      "size": 71.52
                    },
                    {
                      "price": 2.5,
                      "size": 123.68
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.78,
                      "size": 108.53
                    },
                    {
                      "price": 2.86,
                      "size": 123.1
                    },
                    {
                      "price": 2.94,
                      "size": 97.22
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 224547,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.94,
                      "size": 58.95
                    },
                    {
                      "price": 2.8,
                      "size": 47.88
                    },
                    {
                      "price": 2.74,
                      "size": 170.49
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.15,
                      "size": 55.31
                    },
                    {
                      "price": 3.2,
                      "size": 127.01
                    },
                    {
                      "price": 3.25,
                      "size": 129.19
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 48.67
                    },
                    {
                      "price": 3.25,
                      "size": 97.85
                    },
                    {
                      "price": 3.15,
                      "size": 159.45
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 271.57
                    },
                    {
                      "price": 3.65,
                      "size": 624.02
                    },
                    {
                      "price": 3.7,
                      "size": 74.81
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90917,
          "sport_id": 1,
          "league_id": 227,
          "event_id": 32566995,
          "market_id": "1.217245127",
          "event_name": "CA Union de Sunchales v Def Belgrano VR",
          "slug": "ca-union-de-sunchales-v-def-belgrano-vr-72",
          "runners": [
            "CA Union de Sunchales",
            "Def Belgrano VR",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39554013,
          "is_deleted": 0,
          "league_name": "Argentinian Torneo A",
          "league_slug": "argentinian-torneo-a",
          "league_code": 12103652,
          "markets": [],
          "main_market": {
            "id": 646492,
            "match_id": 90917,
            "event_id": 32566995,
            "market_id": "1.217245127",
            "market_name": "Match Odds",
            "runners": "[\"CA Union de Sunchales\",\"Def Belgrano VR\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"CA Union de Sunchales\",\"selection_id\":10103811},{\"runner_name\":\"Def Belgrano VR\",\"selection_id\":11198678},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217245127",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 10103811,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.04,
                      "size": 110.12
                    },
                    {
                      "price": 1.97,
                      "size": 23.04
                    },
                    {
                      "price": 1.94,
                      "size": 127.29
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.22,
                      "size": 58.55
                    },
                    {
                      "price": 2.24,
                      "size": 97.18
                    },
                    {
                      "price": 2.26,
                      "size": 20.38
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 11198678,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.1,
                      "size": 10.87
                    },
                    {
                      "price": 4,
                      "size": 53.26
                    },
                    {
                      "price": 3.95,
                      "size": 55.53
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5,
                      "size": 33.06
                    },
                    {
                      "price": 5.1,
                      "size": 25.06
                    },
                    {
                      "price": 5.2,
                      "size": 66.82
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.25,
                      "size": 50.87
                    },
                    {
                      "price": 3.05,
                      "size": 15.56
                    },
                    {
                      "price": 2.96,
                      "size": 23.41
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.75,
                      "size": 34.26
                    },
                    {
                      "price": 3.8,
                      "size": 11.73
                    },
                    {
                      "price": 3.85,
                      "size": 46.77
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90916,
          "sport_id": 1,
          "league_id": 227,
          "event_id": 32566998,
          "market_id": "1.217245394",
          "event_name": "Club Mutual Crucero del Norte v Sarmiento de Resis",
          "slug": "club-mutual-crucero-del-norte-v-sarmiento-de-resis",
          "runners": [
            "Club Mutual Crucero",
            "Sarmiento de Resis",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39554305,
          "is_deleted": 0,
          "league_name": "Argentinian Torneo A",
          "league_slug": "argentinian-torneo-a",
          "league_code": 12103652,
          "markets": [],
          "main_market": {
            "id": 646482,
            "match_id": 90916,
            "event_id": 32566998,
            "market_id": "1.217245394",
            "market_name": "Match Odds",
            "runners": "[\"Club Mutual Crucero\",\"Sarmiento de Resis\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Club Mutual Crucero\",\"selection_id\":21482013},{\"runner_name\":\"Sarmiento de Resis\",\"selection_id\":39265691},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217245394",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 21482013,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.22,
                      "size": 22.84
                    },
                    {
                      "price": 2.2,
                      "size": 155.01
                    },
                    {
                      "price": 2.18,
                      "size": 92.62
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.52,
                      "size": 57.37
                    },
                    {
                      "price": 2.54,
                      "size": 44.22
                    },
                    {
                      "price": 2.56,
                      "size": 90.38
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 39265691,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 13.07
                    },
                    {
                      "price": 3.7,
                      "size": 98.45
                    },
                    {
                      "price": 3.65,
                      "size": 44.52
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 10.87
                    },
                    {
                      "price": 4.5,
                      "size": 48.32
                    },
                    {
                      "price": 4.6,
                      "size": 37.23
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.82,
                      "size": 16.96
                    },
                    {
                      "price": 2.8,
                      "size": 17.72
                    },
                    {
                      "price": 2.66,
                      "size": 17.98
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.25,
                      "size": 14.96
                    },
                    {
                      "price": 3.3,
                      "size": 16.36
                    },
                    {
                      "price": 3.55,
                      "size": 13.8
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90819,
          "sport_id": 1,
          "league_id": 11,
          "event_id": 32547134,
          "market_id": "1.216937778",
          "event_name": "Toulouse v Paris St-G",
          "slug": "toulouse-v-paris-st-g-29",
          "runners": [
            "Toulouse",
            "Paris St-G",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42004539,
          "is_deleted": 0,
          "league_name": "French Ligue 1",
          "league_slug": "french-ligue-1",
          "league_code": 55,
          "markets": [],
          "main_market": {
            "id": 645516,
            "match_id": 90819,
            "event_id": 32547134,
            "market_id": "1.216937778",
            "market_name": "Match Odds",
            "runners": "[\"Toulouse\",\"Paris St-G\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Toulouse\",\"selection_id\":305969},{\"runner_name\":\"Paris St-G\",\"selection_id\":489720},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216937778",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 305969,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.5,
                      "size": 642.55
                    },
                    {
                      "price": 5.4,
                      "size": 2305.46
                    },
                    {
                      "price": 5.3,
                      "size": 2686.4
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.6,
                      "size": 1531.73
                    },
                    {
                      "price": 5.7,
                      "size": 2812.12
                    },
                    {
                      "price": 5.8,
                      "size": 2120.75
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 489720,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.66,
                      "size": 2404.98
                    },
                    {
                      "price": 1.65,
                      "size": 7945.34
                    },
                    {
                      "price": 1.64,
                      "size": 10187.88
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.67,
                      "size": 4717.32
                    },
                    {
                      "price": 1.68,
                      "size": 35151.44
                    },
                    {
                      "price": 1.69,
                      "size": 5281.91
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 1460.02
                    },
                    {
                      "price": 4.4,
                      "size": 5423.46
                    },
                    {
                      "price": 4.3,
                      "size": 6863.73
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 3843.44
                    },
                    {
                      "price": 4.7,
                      "size": 7890.12
                    },
                    {
                      "price": 4.8,
                      "size": 4413.86
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90791,
          "sport_id": 1,
          "league_id": 312,
          "event_id": 32548007,
          "market_id": "1.216947101",
          "event_name": "Internacional v Fortaleza EC",
          "slug": "internacional-v-fortaleza-ec",
          "runners": [
            "Internacional",
            "Fortaleza EC",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 39439341,
          "is_deleted": 0,
          "league_name": "Brazilian Serie A",
          "league_slug": "brazilian-serie-a",
          "league_code": 13,
          "markets": [],
          "main_market": {
            "id": 645327,
            "match_id": 90791,
            "event_id": 32548007,
            "market_id": "1.216947101",
            "market_name": "Match Odds",
            "runners": "[\"Internacional\",\"Fortaleza EC\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Internacional\",\"selection_id\":198137},{\"runner_name\":\"Fortaleza EC\",\"selection_id\":5287007},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216947101",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 198137,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.28,
                      "size": 1894.91
                    },
                    {
                      "price": 2.26,
                      "size": 869.44
                    },
                    {
                      "price": 2.24,
                      "size": 5526.96
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.3,
                      "size": 680.05
                    },
                    {
                      "price": 2.32,
                      "size": 129.66
                    },
                    {
                      "price": 2.34,
                      "size": 586.97
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 5287007,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 279.07
                    },
                    {
                      "price": 3.7,
                      "size": 291.58
                    },
                    {
                      "price": 3.65,
                      "size": 350.26
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.8,
                      "size": 97.29
                    },
                    {
                      "price": 3.85,
                      "size": 1160.57
                    },
                    {
                      "price": 3.9,
                      "size": 1125.39
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.3,
                      "size": 1305.52
                    },
                    {
                      "price": 3.25,
                      "size": 896.6
                    },
                    {
                      "price": 3.2,
                      "size": 193.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 115.7
                    },
                    {
                      "price": 3.4,
                      "size": 1765.3
                    },
                    {
                      "price": 3.45,
                      "size": 683.12
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90790,
          "sport_id": 1,
          "league_id": 312,
          "event_id": 32547981,
          "market_id": "1.216946189",
          "event_name": "Sao Paulo v Botafogo",
          "slug": "sao-paulo-v-botafogo-98",
          "runners": [
            "Sao Paulo",
            "Botafogo",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 39439333,
          "is_deleted": 0,
          "league_name": "Brazilian Serie A",
          "league_slug": "brazilian-serie-a",
          "league_code": 13,
          "markets": [],
          "main_market": {
            "id": 645317,
            "match_id": 90790,
            "event_id": 32547981,
            "market_id": "1.216946189",
            "market_name": "Match Odds",
            "runners": "[\"Sao Paulo\",\"Botafogo\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Sao Paulo\",\"selection_id\":198126},{\"runner_name\":\"Botafogo\",\"selection_id\":198128},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216946189",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 198126,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.2,
                      "size": 2433.75
                    },
                    {
                      "price": 2.18,
                      "size": 2603.76
                    },
                    {
                      "price": 2.16,
                      "size": 2614.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.24,
                      "size": 1602.78
                    },
                    {
                      "price": 2.26,
                      "size": 1947.18
                    },
                    {
                      "price": 2.28,
                      "size": 1180.6
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 198128,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.9,
                      "size": 430.71
                    },
                    {
                      "price": 3.85,
                      "size": 2240.21
                    },
                    {
                      "price": 3.8,
                      "size": 1419.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.95,
                      "size": 573.13
                    },
                    {
                      "price": 4,
                      "size": 639.45
                    },
                    {
                      "price": 4.1,
                      "size": 1520.56
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 812.59
                    },
                    {
                      "price": 3.3,
                      "size": 1242.52
                    },
                    {
                      "price": 3.25,
                      "size": 1298.3
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.4,
                      "size": 273.83
                    },
                    {
                      "price": 3.45,
                      "size": 899.19
                    },
                    {
                      "price": 3.5,
                      "size": 2317.15
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90789,
          "sport_id": 1,
          "league_id": 14,
          "event_id": 32542235,
          "market_id": "1.216876525",
          "event_name": "Go Ahead Eagles v FC Volendam",
          "slug": "go-ahead-eagles-v-fc-volendam-16",
          "runners": [
            "Go Ahead Eagles",
            "FC Volendam",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692471600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 41980123,
          "is_deleted": 0,
          "league_name": "Dutch Eredivisie",
          "league_slug": "dutch-eredivisie",
          "league_code": 9404054,
          "markets": [],
          "main_market": {
            "id": 645305,
            "match_id": 90789,
            "event_id": 32542235,
            "market_id": "1.216876525",
            "market_name": "Match Odds",
            "runners": "[\"Go Ahead Eagles\",\"FC Volendam\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Go Ahead Eagles\",\"selection_id\":419123},{\"runner_name\":\"FC Volendam\",\"selection_id\":14170968},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216876525",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 419123,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.67,
                      "size": 44.97
                    },
                    {
                      "price": 1.66,
                      "size": 3436.72
                    },
                    {
                      "price": 1.65,
                      "size": 3407.46
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.68,
                      "size": 8114.39
                    },
                    {
                      "price": 1.69,
                      "size": 602.81
                    },
                    {
                      "price": 1.7,
                      "size": 3170.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 14170968,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.4,
                      "size": 44.97
                    },
                    {
                      "price": 5.3,
                      "size": 2151.92
                    },
                    {
                      "price": 5.2,
                      "size": 68.41
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.5,
                      "size": 897.53
                    },
                    {
                      "price": 5.6,
                      "size": 1391.24
                    },
                    {
                      "price": 5.7,
                      "size": 79.79
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 1184.82
                    },
                    {
                      "price": 4.4,
                      "size": 3982.76
                    },
                    {
                      "price": 4.3,
                      "size": 2704.79
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 1374.01
                    },
                    {
                      "price": 4.7,
                      "size": 41.91
                    },
                    {
                      "price": 4.8,
                      "size": 1009.79
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90859,
          "sport_id": 1,
          "league_id": 22,
          "event_id": 32555783,
          "market_id": "1.217072694",
          "event_name": "Portimonense v Boavista",
          "slug": "portimonense-v-boavista",
          "runners": [
            "Portimonense",
            "Boavista",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692473400,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 42146145,
          "is_deleted": 0,
          "league_name": "Portuguese Primeira Liga",
          "league_slug": "portuguese-primeira-liga",
          "league_code": 99,
          "markets": [],
          "main_market": {
            "id": 645914,
            "match_id": 90859,
            "event_id": 32555783,
            "market_id": "1.217072694",
            "market_name": "Match Odds",
            "runners": "[\"Portimonense\",\"Boavista\",\"The Draw\"]",
            "stake_limit": 10000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Portimonense\",\"selection_id\":505982},{\"runner_name\":\"Boavista\",\"selection_id\":10761},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217072694",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 505982,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.96,
                      "size": 1207.08
                    },
                    {
                      "price": 2.94,
                      "size": 453.8
                    },
                    {
                      "price": 2.92,
                      "size": 1132.77
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 336.15
                    },
                    {
                      "price": 3.1,
                      "size": 1274.07
                    },
                    {
                      "price": 3.15,
                      "size": 2127.5
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 10761,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.72,
                      "size": 119.69
                    },
                    {
                      "price": 2.7,
                      "size": 109.72
                    },
                    {
                      "price": 2.68,
                      "size": 1086.89
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.76,
                      "size": 260.27
                    },
                    {
                      "price": 2.8,
                      "size": 742.15
                    },
                    {
                      "price": 2.82,
                      "size": 109.72
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.3,
                      "size": 629.71
                    },
                    {
                      "price": 3.25,
                      "size": 111.37
                    },
                    {
                      "price": 3.2,
                      "size": 358.29
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 1645.89
                    },
                    {
                      "price": 3.4,
                      "size": 436.55
                    },
                    {
                      "price": 3.45,
                      "size": 3025.3
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 10000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90860,
          "sport_id": 1,
          "league_id": 22,
          "event_id": 32555779,
          "market_id": "1.217072802",
          "event_name": "Benfica v Club Football Estrela",
          "slug": "benfica-v-club-football-estrela",
          "runners": [
            "Benfica",
            "Club Football Estrela",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692473400,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Portuguese Primeira Liga",
          "league_slug": "portuguese-primeira-liga",
          "league_code": 99,
          "markets": [],
          "main_market": {
            "id": 645924,
            "match_id": 90860,
            "event_id": 32555779,
            "market_id": "1.217072802",
            "market_name": "Match Odds",
            "runners": "[\"Benfica\",\"Club Football Estrela\",\"The Draw\"]",
            "stake_limit": 10000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Benfica\",\"selection_id\":48783},{\"runner_name\":\"Club Football Estrela\",\"selection_id\":36362918},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217072802",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 48783,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.11,
                      "size": 17300.34
                    },
                    {
                      "price": 1.1,
                      "size": 26726.82
                    },
                    {
                      "price": 1.09,
                      "size": 85046.99
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.12,
                      "size": 55577.44
                    },
                    {
                      "price": 1.13,
                      "size": 20579.2
                    },
                    {
                      "price": 1.14,
                      "size": 7100.11
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 36362918,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 40,
                      "size": 511.31
                    },
                    {
                      "price": 38,
                      "size": 19.95
                    },
                    {
                      "price": 36,
                      "size": 19.95
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 42,
                      "size": 214.15
                    },
                    {
                      "price": 44,
                      "size": 109.27
                    },
                    {
                      "price": 46,
                      "size": 39.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 13,
                      "size": 68.97
                    },
                    {
                      "price": 12.5,
                      "size": 455.85
                    },
                    {
                      "price": 12,
                      "size": 1080.96
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 13.5,
                      "size": 1763.78
                    },
                    {
                      "price": 14,
                      "size": 593.03
                    },
                    {
                      "price": 14.5,
                      "size": 49.87
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 10000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90863,
          "sport_id": 1,
          "league_id": 24,
          "event_id": 32486976,
          "market_id": "1.216075898",
          "event_name": "Osasuna v Athletic Bilbao",
          "slug": "osasuna-v-athletic-bilbao-18",
          "runners": [
            "Osasuna",
            "Athletic Bilbao",
            "The Draw"
          ],
          "event_date": "2023-08-19T19:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692473400,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 41892927,
          "is_deleted": 0,
          "league_name": "Spanish La Liga",
          "league_slug": "spanish-la-liga",
          "league_code": 117,
          "markets": [],
          "main_market": {
            "id": 645956,
            "match_id": 90863,
            "event_id": 32486976,
            "market_id": "1.216075898",
            "market_name": "Match Odds",
            "runners": "[\"Osasuna\",\"Athletic Bilbao\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 500000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Osasuna\",\"selection_id\":10543},{\"runner_name\":\"Athletic Bilbao\",\"selection_id\":9162},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216075898",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 10543,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 2926.09
                    },
                    {
                      "price": 2.98,
                      "size": 5020.71
                    },
                    {
                      "price": 2.96,
                      "size": 15877.04
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.1,
                      "size": 5834.24
                    },
                    {
                      "price": 3.15,
                      "size": 5868.6
                    },
                    {
                      "price": 3.2,
                      "size": 6869.23
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 9162,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.8,
                      "size": 1057.8
                    },
                    {
                      "price": 2.78,
                      "size": 1632.89
                    },
                    {
                      "price": 2.76,
                      "size": 2606.24
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.84,
                      "size": 2108.57
                    },
                    {
                      "price": 2.86,
                      "size": 4080.73
                    },
                    {
                      "price": 2.88,
                      "size": 11542.73
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.15,
                      "size": 5684.11
                    },
                    {
                      "price": 3.1,
                      "size": 7190.32
                    },
                    {
                      "price": 3.05,
                      "size": 9730.11
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.2,
                      "size": 7479.36
                    },
                    {
                      "price": 3.25,
                      "size": 19084.09
                    },
                    {
                      "price": 3.3,
                      "size": 5266.38
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 500000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90799,
          "sport_id": 1,
          "league_id": 319,
          "event_id": 32554016,
          "market_id": "1.217039848",
          "event_name": "ABC RN v CRB",
          "slug": "abc-rn-v-crb",
          "runners": [
            "ABC RN",
            "CRB",
            "The Draw"
          ],
          "event_date": "2023-08-19T20:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692475200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39464097,
          "is_deleted": 0,
          "league_name": "Brazilian Serie B",
          "league_slug": "brazilian-serie-b",
          "league_code": 321319,
          "markets": [],
          "main_market": {
            "id": 645405,
            "match_id": 90799,
            "event_id": 32554016,
            "market_id": "1.217039848",
            "market_name": "Match Odds",
            "runners": "[\"ABC RN\",\"CRB\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"ABC RN\",\"selection_id\":5330507},{\"runner_name\":\"CRB\",\"selection_id\":6368159},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217039848",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5330507,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.96,
                      "size": 59.65
                    },
                    {
                      "price": 2.94,
                      "size": 119.92
                    },
                    {
                      "price": 2.92,
                      "size": 49.87
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.98,
                      "size": 63.55
                    },
                    {
                      "price": 3,
                      "size": 203.67
                    },
                    {
                      "price": 3.05,
                      "size": 696.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 6368159,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 417.05
                    },
                    {
                      "price": 2.98,
                      "size": 119.92
                    },
                    {
                      "price": 2.96,
                      "size": 240.82
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 484
                    },
                    {
                      "price": 3.1,
                      "size": 236.6
                    },
                    {
                      "price": 3.15,
                      "size": 307.89
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.96,
                      "size": 342.81
                    },
                    {
                      "price": 2.94,
                      "size": 307.69
                    },
                    {
                      "price": 2.92,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 348.25
                    },
                    {
                      "price": 3.1,
                      "size": 518.14
                    },
                    {
                      "price": 3.15,
                      "size": 640.15
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90800,
          "sport_id": 1,
          "league_id": 319,
          "event_id": 32554017,
          "market_id": "1.217039740",
          "event_name": "Ituano v Criciuma",
          "slug": "ituano-v-criciuma",
          "runners": [
            "Ituano",
            "Criciuma",
            "The Draw"
          ],
          "event_date": "2023-08-19T20:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692475200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39464085,
          "is_deleted": 0,
          "league_name": "Brazilian Serie B",
          "league_slug": "brazilian-serie-b",
          "league_code": 321319,
          "markets": [],
          "main_market": {
            "id": 645415,
            "match_id": 90800,
            "event_id": 32554017,
            "market_id": "1.217039740",
            "market_name": "Match Odds",
            "runners": "[\"Ituano\",\"Criciuma\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Ituano\",\"selection_id\":1040280},{\"runner_name\":\"Criciuma\",\"selection_id\":356589},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217039740",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 1040280,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.64,
                      "size": 367.5
                    },
                    {
                      "price": 2.62,
                      "size": 550.05
                    },
                    {
                      "price": 2.6,
                      "size": 446.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.74,
                      "size": 276.4
                    },
                    {
                      "price": 2.76,
                      "size": 725.57
                    },
                    {
                      "price": 2.78,
                      "size": 622.91
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 356589,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 1020.8
                    },
                    {
                      "price": 3.3,
                      "size": 490.53
                    },
                    {
                      "price": 3.25,
                      "size": 737.47
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.45,
                      "size": 224.55
                    },
                    {
                      "price": 3.5,
                      "size": 353.14
                    },
                    {
                      "price": 3.55,
                      "size": 661.41
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.96,
                      "size": 491.4
                    },
                    {
                      "price": 2.94,
                      "size": 267.3
                    },
                    {
                      "price": 2.92,
                      "size": 119.81
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.05,
                      "size": 1446.73
                    },
                    {
                      "price": 3.1,
                      "size": 1042.05
                    },
                    {
                      "price": 3.15,
                      "size": 3777.23
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90823,
          "sport_id": 1,
          "league_id": 13,
          "event_id": 32555061,
          "market_id": "1.217060020",
          "event_name": "Alcorcon v Leganes",
          "slug": "alcorcon-v-leganes",
          "runners": [
            "Alcorcon",
            "Leganes",
            "The Draw"
          ],
          "event_date": "2023-08-19T20:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692475200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 41983821,
          "is_deleted": 0,
          "league_name": "Spanish Segunda Division",
          "league_slug": "spanish-segunda-division",
          "league_code": 12204313,
          "markets": [],
          "main_market": {
            "id": 645554,
            "match_id": 90823,
            "event_id": 32555061,
            "market_id": "1.217060020",
            "market_name": "Match Odds",
            "runners": "[\"Alcorcon\",\"Leganes\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "15",
            "selection_runner": "[{\"runner_name\":\"Alcorcon\",\"selection_id\":2250328},{\"runner_name\":\"Leganes\",\"selection_id\":309109},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217060020",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 2250328,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.58,
                      "size": 22.64
                    },
                    {
                      "price": 2.56,
                      "size": 327.37
                    },
                    {
                      "price": 2.54,
                      "size": 408.98
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.64,
                      "size": 717.91
                    },
                    {
                      "price": 2.66,
                      "size": 139.64
                    },
                    {
                      "price": 2.68,
                      "size": 356.66
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 309109,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.55,
                      "size": 706.67
                    },
                    {
                      "price": 3.5,
                      "size": 227.1
                    },
                    {
                      "price": 3.45,
                      "size": 289.09
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.65,
                      "size": 125.72
                    },
                    {
                      "price": 3.7,
                      "size": 1210.85
                    },
                    {
                      "price": 3.75,
                      "size": 350.56
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.96,
                      "size": 497.97
                    },
                    {
                      "price": 2.92,
                      "size": 139.44
                    },
                    {
                      "price": 2.9,
                      "size": 97.02
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.98,
                      "size": 760.43
                    },
                    {
                      "price": 3.05,
                      "size": 19.15
                    },
                    {
                      "price": 3.1,
                      "size": 1546
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90905,
          "sport_id": 1,
          "league_id": 285,
          "event_id": 32554010,
          "market_id": "1.217039485",
          "event_name": "Atletico FC Cali v Cucuta Deportivo",
          "slug": "atletico-fc-cali-v-cucuta-deportivo-68",
          "runners": [
            "Atletico FC Cali",
            "Cucuta Deportivo",
            "The Draw"
          ],
          "event_date": "2023-08-19T20:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692477000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42607781,
          "is_deleted": 0,
          "league_name": "Colombian Primera B",
          "league_slug": "colombian-primera-b",
          "league_code": 856134,
          "markets": [],
          "main_market": {
            "id": 646372,
            "match_id": 90905,
            "event_id": 32554010,
            "market_id": "1.217039485",
            "market_name": "Match Odds",
            "runners": "[\"Atletico FC Cali\",\"Cucuta Deportivo\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Atletico FC Cali\",\"selection_id\":18225671},{\"runner_name\":\"Cucuta Deportivo\",\"selection_id\":2301978},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217039485",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 18225671,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 19.95
                    },
                    {
                      "price": 3.95,
                      "size": 19.95
                    },
                    {
                      "price": 3.9,
                      "size": 46.48
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 39.9
                    },
                    {
                      "price": 4.5,
                      "size": 92.1
                    },
                    {
                      "price": 4.6,
                      "size": 30.74
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 2301978,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.14,
                      "size": 100.44
                    },
                    {
                      "price": 2.12,
                      "size": 49.87
                    },
                    {
                      "price": 2.1,
                      "size": 93.16
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.24,
                      "size": 119.69
                    },
                    {
                      "price": 2.26,
                      "size": 29.92
                    },
                    {
                      "price": 2.28,
                      "size": 99.48
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.25,
                      "size": 50.87
                    },
                    {
                      "price": 3.2,
                      "size": 28.33
                    },
                    {
                      "price": 3.15,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.45,
                      "size": 29.92
                    },
                    {
                      "price": 3.5,
                      "size": 50.57
                    },
                    {
                      "price": 3.55,
                      "size": 42.43
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90912,
          "sport_id": 1,
          "league_id": 50,
          "event_id": 32565563,
          "market_id": "1.217226997",
          "event_name": "Cusco FC v Melgar",
          "slug": "cusco-fc-v-melgar",
          "runners": [
            "Cusco FC",
            "Melgar",
            "The Draw"
          ],
          "event_date": "2023-08-19T20:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692477000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42684629,
          "is_deleted": 0,
          "league_name": "Peruvian Primera Division",
          "league_slug": "peruvian-primera-division",
          "league_code": 8594603,
          "markets": [],
          "main_market": {
            "id": 646442,
            "match_id": 90912,
            "event_id": 32565563,
            "market_id": "1.217226997",
            "market_name": "Match Odds",
            "runners": "[\"Cusco FC\",\"Melgar\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Cusco FC\",\"selection_id\":27767097},{\"runner_name\":\"Melgar\",\"selection_id\":5839079},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217226997",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 27767097,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.88,
                      "size": 69.82
                    },
                    {
                      "price": 2.86,
                      "size": 247.78
                    },
                    {
                      "price": 2.84,
                      "size": 146.79
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.96,
                      "size": 26.13
                    },
                    {
                      "price": 2.98,
                      "size": 151.31
                    },
                    {
                      "price": 3,
                      "size": 39.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 5839079,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.74,
                      "size": 65.73
                    },
                    {
                      "price": 2.72,
                      "size": 36.11
                    },
                    {
                      "price": 2.7,
                      "size": 36.66
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.84,
                      "size": 141.22
                    },
                    {
                      "price": 2.86,
                      "size": 113.37
                    },
                    {
                      "price": 2.88,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.3,
                      "size": 39.9
                    },
                    {
                      "price": 3.25,
                      "size": 52.61
                    },
                    {
                      "price": 3.2,
                      "size": 199.56
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.45,
                      "size": 99.74
                    },
                    {
                      "price": 3.5,
                      "size": 187.11
                    },
                    {
                      "price": 3.55,
                      "size": 57.59
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90801,
          "sport_id": 1,
          "league_id": 319,
          "event_id": 32553059,
          "market_id": "1.217025828",
          "event_name": "Juventude v Sampaio Correa FC",
          "slug": "juventude-v-sampaio-correa-fc",
          "runners": [
            "Juventude",
            "Sampaio Correa FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T21:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692478800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39464093,
          "is_deleted": 0,
          "league_name": "Brazilian Serie B",
          "league_slug": "brazilian-serie-b",
          "league_code": 321319,
          "markets": [],
          "main_market": {
            "id": 645425,
            "match_id": 90801,
            "event_id": 32553059,
            "market_id": "1.217025828",
            "market_name": "Match Odds",
            "runners": "[\"Juventude\",\"Sampaio Correa FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 100000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "10",
            "selection_runner": "[{\"runner_name\":\"Juventude\",\"selection_id\":198144},{\"runner_name\":\"Sampaio Correa FC\",\"selection_id\":11135997},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217025828",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 198144,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.68,
                      "size": 2878.39
                    },
                    {
                      "price": 1.67,
                      "size": 2301.44
                    },
                    {
                      "price": 1.66,
                      "size": 2580.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.69,
                      "size": 159.7
                    },
                    {
                      "price": 1.7,
                      "size": 2152.03
                    },
                    {
                      "price": 1.71,
                      "size": 3456.31
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 11135997,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 7.2,
                      "size": 501.18
                    },
                    {
                      "price": 7,
                      "size": 402.68
                    },
                    {
                      "price": 6.8,
                      "size": 880.56
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 7.4,
                      "size": 1564.7
                    },
                    {
                      "price": 7.6,
                      "size": 506.45
                    },
                    {
                      "price": 7.8,
                      "size": 1257.6
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.7,
                      "size": 322.97
                    },
                    {
                      "price": 3.65,
                      "size": 538.39
                    },
                    {
                      "price": 3.6,
                      "size": 1787.26
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.75,
                      "size": 272.31
                    },
                    {
                      "price": 3.8,
                      "size": 1460.22
                    },
                    {
                      "price": 3.85,
                      "size": 418.49
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 100000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90892,
          "sport_id": 1,
          "league_id": 37,
          "event_id": 32557216,
          "market_id": "1.217104195",
          "event_name": "Wanderers (Uru) v La Luz FC",
          "slug": "wanderers-uru-v-la-luz-fc",
          "runners": [
            "Wanderers (Uru)",
            "La Luz FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T21:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692478800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42708147,
          "is_deleted": 0,
          "league_name": "Uruguayan Primera Division",
          "league_slug": "uruguayan-primera-division",
          "league_code": 843454,
          "markets": [],
          "main_market": {
            "id": 646242,
            "match_id": 90892,
            "event_id": 32557216,
            "market_id": "1.217104195",
            "market_name": "Match Odds",
            "runners": "[\"Wanderers (Uru)\",\"La Luz FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Wanderers (Uru)\",\"selection_id\":2794560},{\"runner_name\":\"La Luz FC\",\"selection_id\":19417077},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217104195",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 2794560,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.26,
                      "size": 180.95
                    },
                    {
                      "price": 2.22,
                      "size": 86.75
                    },
                    {
                      "price": 2.2,
                      "size": 184.66
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.3,
                      "size": 92.9
                    },
                    {
                      "price": 2.32,
                      "size": 79.79
                    },
                    {
                      "price": 2.34,
                      "size": 91.82
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 19417077,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.55,
                      "size": 59.85
                    },
                    {
                      "price": 3.5,
                      "size": 71.3
                    },
                    {
                      "price": 3.45,
                      "size": 192.19
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 59.5
                    },
                    {
                      "price": 3.75,
                      "size": 101.8
                    },
                    {
                      "price": 3.8,
                      "size": 100.14
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.55,
                      "size": 44.88
                    },
                    {
                      "price": 3.4,
                      "size": 69.82
                    },
                    {
                      "price": 3.35,
                      "size": 74.33
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 109.72
                    },
                    {
                      "price": 3.65,
                      "size": 142.04
                    },
                    {
                      "price": 3.7,
                      "size": 89.38
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90910,
          "sport_id": 1,
          "league_id": 208,
          "event_id": 32557733,
          "market_id": "1.217114165",
          "event_name": "Deportivo Pereira v Jaguares de Cordoba",
          "slug": "deportivo-pereira-v-jaguares-de-cordoba",
          "runners": [
            "Deportivo Pereira",
            "Jaguares de Cordoba",
            "The Draw"
          ],
          "event_date": "2023-08-19T21:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692478800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42744639,
          "is_deleted": 0,
          "league_name": "Colombian Primera A",
          "league_slug": "colombian-primera-a",
          "league_code": 844197,
          "markets": [],
          "main_market": {
            "id": 646422,
            "match_id": 90910,
            "event_id": 32557733,
            "market_id": "1.217114165",
            "market_name": "Match Odds",
            "runners": "[\"Deportivo Pereira\",\"Jaguares de Cordoba\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Deportivo Pereira\",\"selection_id\":5284708},{\"runner_name\":\"Jaguares de Cordoba\",\"selection_id\":7055314},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217114165",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5284708,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2,
                      "size": 502.6
                    },
                    {
                      "price": 1.99,
                      "size": 79.79
                    },
                    {
                      "price": 1.98,
                      "size": 79.79
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.04,
                      "size": 74.64
                    },
                    {
                      "price": 2.06,
                      "size": 139.64
                    },
                    {
                      "price": 2.08,
                      "size": 109.72
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7055314,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.4,
                      "size": 109.72
                    },
                    {
                      "price": 4.3,
                      "size": 125.18
                    },
                    {
                      "price": 4.2,
                      "size": 395.34
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.7,
                      "size": 329.65
                    },
                    {
                      "price": 4.8,
                      "size": 89.77
                    },
                    {
                      "price": 4.9,
                      "size": 159.79
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.4,
                      "size": 129.66
                    },
                    {
                      "price": 3.35,
                      "size": 135.22
                    },
                    {
                      "price": 3.3,
                      "size": 441.05
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.6,
                      "size": 139.64
                    },
                    {
                      "price": 3.65,
                      "size": 348.1
                    },
                    {
                      "price": 3.7,
                      "size": 180.34
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90792,
          "sport_id": 1,
          "league_id": 312,
          "event_id": 32547982,
          "market_id": "1.216946068",
          "event_name": "Cuiaba v SE Palmeiras",
          "slug": "cuiaba-v-se-palmeiras",
          "runners": [
            "Cuiaba",
            "SE Palmeiras",
            "The Draw"
          ],
          "event_date": "2023-08-19T21:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692480600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 39439347,
          "is_deleted": 0,
          "league_name": "Brazilian Serie A",
          "league_slug": "brazilian-serie-a",
          "league_code": 13,
          "markets": [],
          "main_market": {
            "id": 645337,
            "match_id": 90792,
            "event_id": 32547982,
            "market_id": "1.216946068",
            "market_name": "Match Odds",
            "runners": "[\"Cuiaba\",\"SE Palmeiras\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Cuiaba\",\"selection_id\":5327095},{\"runner_name\":\"SE Palmeiras\",\"selection_id\":22498185},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216946068",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5327095,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.35,
                      "size": 53.14
                    },
                    {
                      "price": 3.3,
                      "size": 1047.05
                    },
                    {
                      "price": 3.25,
                      "size": 1388.5
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.4,
                      "size": 354.07
                    },
                    {
                      "price": 3.45,
                      "size": 584.17
                    },
                    {
                      "price": 3.5,
                      "size": 1484.24
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 22498185,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.5,
                      "size": 302.88
                    },
                    {
                      "price": 2.48,
                      "size": 501.09
                    },
                    {
                      "price": 2.46,
                      "size": 360
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.54,
                      "size": 1317.96
                    },
                    {
                      "price": 2.56,
                      "size": 307.24
                    },
                    {
                      "price": 2.58,
                      "size": 1211.94
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.25,
                      "size": 1155.79
                    },
                    {
                      "price": 3.2,
                      "size": 702.24
                    },
                    {
                      "price": 3.15,
                      "size": 699.04
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.3,
                      "size": 168.99
                    },
                    {
                      "price": 3.35,
                      "size": 3540.63
                    },
                    {
                      "price": 3.4,
                      "size": 488.88
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90793,
          "sport_id": 1,
          "league_id": 312,
          "event_id": 32548019,
          "market_id": "1.216946861",
          "event_name": "Fluminense v America MG",
          "slug": "fluminense-v-america-mg",
          "runners": [
            "Fluminense",
            "America MG",
            "The Draw"
          ],
          "event_date": "2023-08-19T21:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692480600,
          "is_added_tv": 0,
          "inplay_status": 1,
          "sport_radar_id": 39439329,
          "is_deleted": 0,
          "league_name": "Brazilian Serie A",
          "league_slug": "brazilian-serie-a",
          "league_code": 13,
          "markets": [],
          "main_market": {
            "id": 645347,
            "match_id": 90793,
            "event_id": 32548019,
            "market_id": "1.216946861",
            "market_name": "Match Odds",
            "runners": "[\"Fluminense\",\"America MG\",\"The Draw\"]",
            "stake_limit": 25000,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 200000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "20",
            "selection_runner": "[{\"runner_name\":\"Fluminense\",\"selection_id\":198133},{\"runner_name\":\"America MG\",\"selection_id\":4516149},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.216946861",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 198133,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.51,
                      "size": 2599.47
                    },
                    {
                      "price": 1.5,
                      "size": 3868.03
                    },
                    {
                      "price": 1.49,
                      "size": 2243.68
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.52,
                      "size": 3167.44
                    },
                    {
                      "price": 1.53,
                      "size": 840.21
                    },
                    {
                      "price": 1.54,
                      "size": 5574.4
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 4516149,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 8,
                      "size": 698.09
                    },
                    {
                      "price": 7.8,
                      "size": 209.74
                    },
                    {
                      "price": 7.6,
                      "size": 528.45
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 8.2,
                      "size": 296.63
                    },
                    {
                      "price": 8.4,
                      "size": 860.79
                    },
                    {
                      "price": 8.6,
                      "size": 1406.67
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.6,
                      "size": 560.84
                    },
                    {
                      "price": 4.5,
                      "size": 3575.94
                    },
                    {
                      "price": 4.4,
                      "size": 587.76
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.7,
                      "size": 727.58
                    },
                    {
                      "price": 4.8,
                      "size": 1140.96
                    },
                    {
                      "price": 4.9,
                      "size": 666.31
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 25000,
          "inplay_stake_limit": 200000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90915,
          "sport_id": 1,
          "league_id": 151,
          "event_id": 32563876,
          "market_id": "1.217205888",
          "event_name": "Puerto Cabello v Mineros Guayana",
          "slug": "puerto-cabello-v-mineros-guayana-77",
          "runners": [
            "Puerto Cabello",
            "Mineros Guayana",
            "The Draw"
          ],
          "event_date": "2023-08-19T21:40:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692481200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39191503,
          "is_deleted": 0,
          "league_name": "Venezuelan Primera Division",
          "league_slug": "venezuelan-primera-division",
          "league_code": 1065530,
          "markets": [],
          "main_market": {
            "id": 646472,
            "match_id": 90915,
            "event_id": 32563876,
            "market_id": "1.217205888",
            "market_name": "Match Odds",
            "runners": "[\"Puerto Cabello\",\"Mineros Guayana\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Puerto Cabello\",\"selection_id\":13442344},{\"runner_name\":\"Mineros Guayana\",\"selection_id\":7456728},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217205888",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 13442344,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.35,
                      "size": 327.15
                    },
                    {
                      "price": 1.34,
                      "size": 59.85
                    },
                    {
                      "price": 1.33,
                      "size": 59.85
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.38,
                      "size": 79.79
                    },
                    {
                      "price": 1.39,
                      "size": 99.74
                    },
                    {
                      "price": 1.4,
                      "size": 44.29
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 7456728,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 9.6,
                      "size": 13.27
                    },
                    {
                      "price": 9,
                      "size": 24.22
                    },
                    {
                      "price": 8.8,
                      "size": 34.12
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 12,
                      "size": 46.18
                    },
                    {
                      "price": 13,
                      "size": 37.5
                    },
                    {
                      "price": 13.5,
                      "size": 58.85
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.3,
                      "size": 34.01
                    },
                    {
                      "price": 5.2,
                      "size": 48.41
                    },
                    {
                      "price": 5,
                      "size": 27.73
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.6,
                      "size": 19.3
                    },
                    {
                      "price": 6.8,
                      "size": 45.37
                    },
                    {
                      "price": 7,
                      "size": 22.64
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90918,
          "sport_id": 1,
          "league_id": 227,
          "event_id": 32567385,
          "market_id": "1.217251209",
          "event_name": "Santamarina v Olimpo",
          "slug": "santamarina-v-olimpo-51",
          "runners": [
            "Santamarina",
            "Olimpo",
            "The Draw"
          ],
          "event_date": "2023-08-19T22:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692482400,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39553707,
          "is_deleted": 0,
          "league_name": "Argentinian Torneo A",
          "league_slug": "argentinian-torneo-a",
          "league_code": 12103652,
          "markets": [],
          "main_market": {
            "id": 646502,
            "match_id": 90918,
            "event_id": 32567385,
            "market_id": "1.217251209",
            "market_name": "Match Odds",
            "runners": "[\"Santamarina\",\"Olimpo\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 10000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "4",
            "selection_runner": "[{\"runner_name\":\"Santamarina\",\"selection_id\":5985057},{\"runner_name\":\"Olimpo\",\"selection_id\":194517},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217251209",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5985057,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.94,
                      "size": 58.95
                    },
                    {
                      "price": 2.88,
                      "size": 91.81
                    },
                    {
                      "price": 2.86,
                      "size": 53.78
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 59.15
                    },
                    {
                      "price": 3.45,
                      "size": 73.08
                    },
                    {
                      "price": 3.5,
                      "size": 158.36
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 194517,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.8,
                      "size": 63.54
                    },
                    {
                      "price": 2.72,
                      "size": 90.5
                    },
                    {
                      "price": 2.7,
                      "size": 189.43
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.15,
                      "size": 67.53
                    },
                    {
                      "price": 3.25,
                      "size": 171.22
                    },
                    {
                      "price": 3.3,
                      "size": 67.85
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.84,
                      "size": 62.24
                    },
                    {
                      "price": 2.78,
                      "size": 17.95
                    },
                    {
                      "price": 2.68,
                      "size": 29.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.98,
                      "size": 72.81
                    },
                    {
                      "price": 3,
                      "size": 88.1
                    },
                    {
                      "price": 3.25,
                      "size": 18.15
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 10000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90900,
          "sport_id": 1,
          "league_id": 216,
          "event_id": 32567614,
          "market_id": "1.217253481",
          "event_name": "Gavilanes Matamoros v Correcaminos (Premier)",
          "slug": "gavilanes-matamoros-v-correcaminos-premier",
          "runners": [
            "Gavilanes Matamoros",
            "Correcaminos (Premier)",
            "The Draw"
          ],
          "event_date": "2023-08-19T22:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692484200,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42643329,
          "is_deleted": 0,
          "league_name": "Mexican Segunda Division",
          "league_slug": "mexican-segunda-division",
          "league_code": 12201163,
          "markets": [],
          "main_market": {
            "id": 646322,
            "match_id": 90900,
            "event_id": 32567614,
            "market_id": "1.217253481",
            "market_name": "Match Odds",
            "runners": "[\"Gavilanes Matamoros\",\"Correcaminos (Premier)\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Gavilanes Matamoros\",\"selection_id\":14775452},{\"runner_name\":\"Correcaminos (Premier)\",\"selection_id\":20642576},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217253481",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 14775452,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.65,
                      "size": 176.14
                    },
                    {
                      "price": 1.59,
                      "size": 51.47
                    },
                    {
                      "price": 1.56,
                      "size": 331.64
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.75,
                      "size": 79.94
                    },
                    {
                      "price": 1.77,
                      "size": 419.54
                    },
                    {
                      "price": 1.78,
                      "size": 59.45
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 20642576,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.5,
                      "size": 25.43
                    },
                    {
                      "price": 5.2,
                      "size": 17.65
                    },
                    {
                      "price": 5,
                      "size": 169.45
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.6,
                      "size": 113.84
                    },
                    {
                      "price": 6.8,
                      "size": 99.49
                    },
                    {
                      "price": 7,
                      "size": 44.44
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.1,
                      "size": 57.15
                    },
                    {
                      "price": 3.9,
                      "size": 34.13
                    },
                    {
                      "price": 3.55,
                      "size": 34.68
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.8,
                      "size": 29.14
                    },
                    {
                      "price": 5,
                      "size": 18.36
                    },
                    {
                      "price": 5.1,
                      "size": 38.99
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90913,
          "sport_id": 1,
          "league_id": 50,
          "event_id": 32565578,
          "market_id": "1.217226817",
          "event_name": "Sport Huancayo v Carlos Mannucci",
          "slug": "sport-huancayo-v-carlos-mannucci-63",
          "runners": [
            "Sport Huancayo",
            "Carlos Mannucci",
            "The Draw"
          ],
          "event_date": "2023-08-19T22:45:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692485100,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42684631,
          "is_deleted": 0,
          "league_name": "Peruvian Primera Division",
          "league_slug": "peruvian-primera-division",
          "league_code": 8594603,
          "markets": [],
          "main_market": {
            "id": 646452,
            "match_id": 90913,
            "event_id": 32565578,
            "market_id": "1.217226817",
            "market_name": "Match Odds",
            "runners": "[\"Sport Huancayo\",\"Carlos Mannucci\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Sport Huancayo\",\"selection_id\":4972227},{\"runner_name\":\"Carlos Mannucci\",\"selection_id\":9569210},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217226817",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 4972227,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.34,
                      "size": 776.44
                    },
                    {
                      "price": 1.33,
                      "size": 2043
                    },
                    {
                      "price": 1.32,
                      "size": 445.67
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.35,
                      "size": 204.37
                    },
                    {
                      "price": 1.36,
                      "size": 538.61
                    },
                    {
                      "price": 1.37,
                      "size": 996.74
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 9569210,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 11.5,
                      "size": 383.06
                    },
                    {
                      "price": 11,
                      "size": 157.37
                    },
                    {
                      "price": 10.5,
                      "size": 115.16
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 12.5,
                      "size": 41.79
                    },
                    {
                      "price": 13,
                      "size": 37.8
                    },
                    {
                      "price": 14.5,
                      "size": 324.66
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.5,
                      "size": 50.16
                    },
                    {
                      "price": 5.4,
                      "size": 246.63
                    },
                    {
                      "price": 5.3,
                      "size": 131.6
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.7,
                      "size": 86.28
                    },
                    {
                      "price": 5.8,
                      "size": 49.87
                    },
                    {
                      "price": 5.9,
                      "size": 19.95
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90884,
          "sport_id": 1,
          "league_id": 123,
          "event_id": 32557323,
          "market_id": "1.217107015",
          "event_name": "Hartford Athletic FC v Miami FC",
          "slug": "hartford-athletic-fc-v-miami-fc-34",
          "runners": [
            "Hartford Athletic FC",
            "Miami FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38568287,
          "is_deleted": 0,
          "league_name": "US United Soccer League",
          "league_slug": "us-united-soccer-league",
          "league_code": 12216637,
          "markets": [],
          "main_market": {
            "id": 646162,
            "match_id": 90884,
            "event_id": 32557323,
            "market_id": "1.217107015",
            "market_name": "Match Odds",
            "runners": "[\"Hartford Athletic FC\",\"Miami FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Hartford Athletic FC\",\"selection_id\":23254090},{\"runner_name\":\"Miami FC\",\"selection_id\":3155358},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217107015",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 23254090,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.1,
                      "size": 23.55
                    },
                    {
                      "price": 3.05,
                      "size": 71.68
                    },
                    {
                      "price": 3,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.25,
                      "size": 112.11
                    },
                    {
                      "price": 3.3,
                      "size": 68.79
                    },
                    {
                      "price": 3.35,
                      "size": 130.23
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 3155358,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.36,
                      "size": 38.62
                    },
                    {
                      "price": 2.34,
                      "size": 105.33
                    },
                    {
                      "price": 2.32,
                      "size": 39.9
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.44,
                      "size": 29.92
                    },
                    {
                      "price": 2.46,
                      "size": 49.87
                    },
                    {
                      "price": 2.48,
                      "size": 29.92
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.65,
                      "size": 93.06
                    },
                    {
                      "price": 3.6,
                      "size": 53.26
                    },
                    {
                      "price": 3.55,
                      "size": 59.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.7,
                      "size": 21.27
                    },
                    {
                      "price": 4,
                      "size": 175.55
                    },
                    {
                      "price": 4.1,
                      "size": 171.73
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90901,
          "sport_id": 1,
          "league_id": 216,
          "event_id": 32568188,
          "market_id": "1.217270595",
          "event_name": "Aguacateros de Peribán F.C v Montaneses FC",
          "slug": "aguacateros-de-periban-fc-v-montaneses-fc",
          "runners": [
            "Aguacateros de Peribán F.C",
            "Montaneses FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Mexican Segunda Division",
          "league_slug": "mexican-segunda-division",
          "league_code": 12201163,
          "markets": [],
          "main_market": {
            "id": 646332,
            "match_id": 90901,
            "event_id": 32568188,
            "market_id": "1.217270595",
            "market_name": "Match Odds",
            "runners": "[\"Aguacateros de Perib\\u00e1n F.C\",\"Montaneses FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Aguacateros de Perib\\u00e1n F.C\",\"selection_id\":59280744},{\"runner_name\":\"Montaneses FC\",\"selection_id\":41283106},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217270595",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 59280744,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 57.25
                    },
                    {
                      "price": 1.04,
                      "size": 1706.6
                    },
                    {
                      "price": 1.03,
                      "size": 1706.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 46.56
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 41283106,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.3,
                      "size": 88.07
                    },
                    {
                      "price": 1.04,
                      "size": 1706.6
                    },
                    {
                      "price": 1.03,
                      "size": 1706.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.5,
                      "size": 62.39
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.75,
                      "size": 41.59
                    },
                    {
                      "price": 1.02,
                      "size": 11.3
                    },
                    {
                      "price": 1.01,
                      "size": 59.85
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.4,
                      "size": 39.04
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90902,
          "sport_id": 1,
          "league_id": 216,
          "event_id": 32567639,
          "market_id": "1.217269196",
          "event_name": "Inter de Queretaro FC v Escorpiones FC",
          "slug": "inter-de-queretaro-fc-v-escorpiones-fc",
          "runners": [
            "Inter de Queretaro FC",
            "Escorpiones FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": null,
          "is_deleted": 0,
          "league_name": "Mexican Segunda Division",
          "league_slug": "mexican-segunda-division",
          "league_code": 12201163,
          "markets": [],
          "main_market": {
            "id": 646342,
            "match_id": 90902,
            "event_id": 32567639,
            "market_id": "1.217269196",
            "market_name": "Match Odds",
            "runners": "[\"Inter de Queretaro FC\",\"Escorpiones FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Inter de Queretaro FC\",\"selection_id\":38460741},{\"runner_name\":\"Escorpiones FC\",\"selection_id\":41283107},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217269196",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 38460741,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 5.5,
                      "size": 25.43
                    },
                    {
                      "price": 1.04,
                      "size": 1706.6
                    },
                    {
                      "price": 1.03,
                      "size": 1706.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 6.8,
                      "size": 22.41
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 41283107,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.67,
                      "size": 170.86
                    },
                    {
                      "price": 1.04,
                      "size": 1706.6
                    },
                    {
                      "price": 1.03,
                      "size": 1706.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.76,
                      "size": 79.48
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4,
                      "size": 38.1
                    },
                    {
                      "price": 1.02,
                      "size": 11.84
                    },
                    {
                      "price": 1.01,
                      "size": 59.85
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.6,
                      "size": 30.41
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90903,
          "sport_id": 1,
          "league_id": 216,
          "event_id": 32568260,
          "market_id": "1.217271735",
          "event_name": "Club Sporting Canamy v Halcones de Zapopan",
          "slug": "club-sporting-canamy-v-halcones-de-zapopan",
          "runners": [
            "Club Sporting Canamy",
            "Halcones de Zapopan",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42643307,
          "is_deleted": 0,
          "league_name": "Mexican Segunda Division",
          "league_slug": "mexican-segunda-division",
          "league_code": 12201163,
          "markets": [],
          "main_market": {
            "id": 646352,
            "match_id": 90903,
            "event_id": 32568260,
            "market_id": "1.217271735",
            "market_name": "Match Odds",
            "runners": "[\"Club Sporting Canamy\",\"Halcones de Zapopan\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "3",
            "selection_runner": "[{\"runner_name\":\"Club Sporting Canamy\",\"selection_id\":11739967},{\"runner_name\":\"Halcones de Zapopan\",\"selection_id\":48369785},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217271735",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 11739967,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.75,
                      "size": 152.71
                    },
                    {
                      "price": 1.04,
                      "size": 1706.6
                    },
                    {
                      "price": 1.03,
                      "size": 1706.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.88,
                      "size": 77.3
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 48369785,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.7,
                      "size": 30.92
                    },
                    {
                      "price": 1.04,
                      "size": 1706.6
                    },
                    {
                      "price": 1.03,
                      "size": 1706.94
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.8,
                      "size": 26.42
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.95,
                      "size": 38.8
                    },
                    {
                      "price": 1.02,
                      "size": 11.99
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.7,
                      "size": 30.92
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90921,
          "sport_id": 1,
          "league_id": 297,
          "event_id": 32567512,
          "market_id": "1.217253027",
          "event_name": "Forge v HFX Wanderers",
          "slug": "forge-v-hfx-wanderers-83",
          "runners": [
            "Forge",
            "HFX Wanderers",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:00:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486000,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 39092297,
          "is_deleted": 0,
          "league_name": "Canadian Premier League",
          "league_slug": "canadian-premier-league",
          "league_code": 12231751,
          "markets": [],
          "main_market": {
            "id": 646532,
            "match_id": 90921,
            "event_id": 32567512,
            "market_id": "1.217253027",
            "market_name": "Match Odds",
            "runners": "[\"Forge\",\"HFX Wanderers\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Forge\",\"selection_id\":24213752},{\"runner_name\":\"HFX Wanderers\",\"selection_id\":24201651},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217253027",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 24213752,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.73,
                      "size": 511.68
                    },
                    {
                      "price": 1.71,
                      "size": 138.44
                    },
                    {
                      "price": 1.7,
                      "size": 1016.08
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.94,
                      "size": 170.36
                    },
                    {
                      "price": 1.97,
                      "size": 502
                    },
                    {
                      "price": 1.98,
                      "size": 290.54
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 24201651,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 98.17
                    },
                    {
                      "price": 4.4,
                      "size": 522.08
                    },
                    {
                      "price": 4.3,
                      "size": 12.15
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 5.7,
                      "size": 68.32
                    },
                    {
                      "price": 5.8,
                      "size": 178.59
                    },
                    {
                      "price": 5.9,
                      "size": 54.54
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.5,
                      "size": 84.78
                    },
                    {
                      "price": 3.45,
                      "size": 112.61
                    },
                    {
                      "price": 3.4,
                      "size": 108
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.3,
                      "size": 108.22
                    },
                    {
                      "price": 4.5,
                      "size": 78.43
                    },
                    {
                      "price": 5,
                      "size": 25.52
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90883,
          "sport_id": 1,
          "league_id": 187,
          "event_id": 32557697,
          "market_id": "1.217114345",
          "event_name": "Celaya v CD Tepatitlan De Morelos",
          "slug": "celaya-v-cd-tepatitlan-de-morelos-71",
          "runners": [
            "Celaya",
            "CD Tepatitlan de Morelos",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:05:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486300,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42305573,
          "is_deleted": 0,
          "league_name": "Mexican Ascenso MX",
          "league_slug": "mexican-ascenso-mx",
          "league_code": 827754,
          "markets": [],
          "main_market": {
            "id": 646152,
            "match_id": 90883,
            "event_id": 32557697,
            "market_id": "1.217114345",
            "market_name": "Match Odds",
            "runners": "[\"Celaya\",\"CD Tepatitlan de Morelos\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Celaya\",\"selection_id\":5901260},{\"runner_name\":\"CD Tepatitlan de Morelos\",\"selection_id\":15976071},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217114345",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5901260,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.89,
                      "size": 59.85
                    },
                    {
                      "price": 1.88,
                      "size": 59.85
                    },
                    {
                      "price": 1.87,
                      "size": 59.85
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.99,
                      "size": 109.72
                    },
                    {
                      "price": 2,
                      "size": 248.56
                    },
                    {
                      "price": 2.02,
                      "size": 135.29
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 15976071,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.5,
                      "size": 55.86
                    },
                    {
                      "price": 4.3,
                      "size": 59.85
                    },
                    {
                      "price": 4.2,
                      "size": 382.76
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.8,
                      "size": 49.87
                    },
                    {
                      "price": 4.9,
                      "size": 39.9
                    },
                    {
                      "price": 5,
                      "size": 39.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.6,
                      "size": 49.87
                    },
                    {
                      "price": 3.55,
                      "size": 49.87
                    },
                    {
                      "price": 3.5,
                      "size": 49.87
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.9,
                      "size": 41.39
                    },
                    {
                      "price": 3.95,
                      "size": 29.92
                    },
                    {
                      "price": 4,
                      "size": 59.85
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90911,
          "sport_id": 1,
          "league_id": 208,
          "event_id": 32557731,
          "market_id": "1.217114255",
          "event_name": "Union Magdalena v Santa Fe",
          "slug": "union-magdalena-v-santa-fe-18",
          "runners": [
            "Union Magdalena",
            "Santa Fe",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:10:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692486600,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 42744641,
          "is_deleted": 0,
          "league_name": "Colombian Primera A",
          "league_slug": "colombian-primera-a",
          "league_code": 844197,
          "markets": [],
          "main_market": {
            "id": 646432,
            "match_id": 90911,
            "event_id": 32557731,
            "market_id": "1.217114255",
            "market_name": "Match Odds",
            "runners": "[\"Union Magdalena\",\"Santa Fe\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "6",
            "selection_runner": "[{\"runner_name\":\"Union Magdalena\",\"selection_id\":5343365},{\"runner_name\":\"Santa Fe\",\"selection_id\":4908158},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217114255",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 5343365,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3,
                      "size": 59.85
                    },
                    {
                      "price": 2.98,
                      "size": 69.82
                    },
                    {
                      "price": 2.96,
                      "size": 95.29
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.15,
                      "size": 372.04
                    },
                    {
                      "price": 3.2,
                      "size": 79.79
                    },
                    {
                      "price": 3.25,
                      "size": 128.74
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 4908158,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 2.66,
                      "size": 506.49
                    },
                    {
                      "price": 2.64,
                      "size": 89.77
                    },
                    {
                      "price": 2.62,
                      "size": 49.87
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 2.74,
                      "size": 59.85
                    },
                    {
                      "price": 2.76,
                      "size": 20.75
                    },
                    {
                      "price": 2.78,
                      "size": 39.9
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.2,
                      "size": 59.85
                    },
                    {
                      "price": 3.15,
                      "size": 99.74
                    },
                    {
                      "price": 3.1,
                      "size": 141.19
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.35,
                      "size": 388.1
                    },
                    {
                      "price": 3.4,
                      "size": 19.95
                    },
                    {
                      "price": 3.45,
                      "size": 111.88
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90885,
          "sport_id": 1,
          "league_id": 123,
          "event_id": 32557324,
          "market_id": "1.217106925",
          "event_name": "Detroit City FC v Las Vegas Lights FC",
          "slug": "detroit-city-fc-v-las-vegas-lights-fc",
          "runners": [
            "Detroit City FC",
            "Las Vegas Lights FC",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692487800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38568283,
          "is_deleted": 0,
          "league_name": "US United Soccer League",
          "league_slug": "us-united-soccer-league",
          "league_code": 12216637,
          "markets": [],
          "main_market": {
            "id": 646172,
            "match_id": 90885,
            "event_id": 32557324,
            "market_id": "1.217106925",
            "market_name": "Match Odds",
            "runners": "[\"Detroit City FC\",\"Las Vegas Lights FC\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Detroit City FC\",\"selection_id\":8681930},{\"runner_name\":\"Las Vegas Lights FC\",\"selection_id\":18489317},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217106925",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 8681930,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.92,
                      "size": 124.48
                    },
                    {
                      "price": 1.89,
                      "size": 39.9
                    },
                    {
                      "price": 1.88,
                      "size": 114.7
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.98,
                      "size": 117.7
                    },
                    {
                      "price": 1.99,
                      "size": 29.92
                    },
                    {
                      "price": 2,
                      "size": 302.22
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 18489317,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.4,
                      "size": 160.19
                    },
                    {
                      "price": 4.3,
                      "size": 39.9
                    },
                    {
                      "price": 4.2,
                      "size": 19.95
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.7,
                      "size": 29.92
                    },
                    {
                      "price": 4.8,
                      "size": 29.92
                    },
                    {
                      "price": 4.9,
                      "size": 52.21
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.65,
                      "size": 29.92
                    },
                    {
                      "price": 3.6,
                      "size": 29.92
                    },
                    {
                      "price": 3.55,
                      "size": 29.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 3.9,
                      "size": 63.83
                    },
                    {
                      "price": 3.95,
                      "size": 152.61
                    },
                    {
                      "price": 4,
                      "size": 99.65
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        },
        {
          "id": 90886,
          "sport_id": 1,
          "league_id": 123,
          "event_id": 32557319,
          "market_id": "1.217107286",
          "event_name": "Loudoun United FC v Sacramento Republic",
          "slug": "loudoun-united-fc-v-sacramento-republic",
          "runners": [
            "Loudoun United FC",
            "Sacramento Republic",
            "The Draw"
          ],
          "event_date": "2023-08-19T23:30:00.000Z",
          "is_populer": 0,
          "is_active": 1,
          "is_bet_lock": 0,
          "is_sus": 0,
          "is_custom": 0,
          "tv_url": null,
          "event_timestamp_date": 1692487800,
          "is_added_tv": 0,
          "inplay_status": 0,
          "sport_radar_id": 38568289,
          "is_deleted": 0,
          "league_name": "US United Soccer League",
          "league_slug": "us-united-soccer-league",
          "league_code": 12216637,
          "markets": [],
          "main_market": {
            "id": 646182,
            "match_id": 90886,
            "event_id": 32557319,
            "market_id": "1.217107286",
            "market_name": "Match Odds",
            "runners": "[\"Loudoun United FC\",\"Sacramento Republic\",\"The Draw\"]",
            "stake_limit": 1,
            "min_stake_limit": null,
            "max_stake_limit": null,
            "inplay_stake_limit": 25000,
            "max_market_limit": null,
            "is_sus": 0,
            "is_active": 1,
            "is_declared": 0,
            "odd_limit": "5",
            "selection_runner": "[{\"runner_name\":\"Loudoun United FC\",\"selection_id\":23254245},{\"runner_name\":\"Sacramento Republic\",\"selection_id\":8582482},{\"runner_name\":\"The Draw\",\"selection_id\":58805}]",
            "stack_odds_time": null,
            "data": null,
            "main_market_status": 1
          },
          "match_setting": null,
          "data": {
            "marketId": "1.217107286",
            "status": "OPEN",
            "isMarketDataDelayed": false,
            "betDelay": 0,
            "inplay": false,
            "runners": [
              {
                "selectionId": 23254245,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 4.4,
                      "size": 69.82
                    },
                    {
                      "price": 4.3,
                      "size": 39.9
                    },
                    {
                      "price": 4.2,
                      "size": 175.75
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.7,
                      "size": 26.13
                    },
                    {
                      "price": 4.8,
                      "size": 21.44
                    },
                    {
                      "price": 4.9,
                      "size": 159.09
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 8582482,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 1.87,
                      "size": 59.85
                    },
                    {
                      "price": 1.85,
                      "size": 298.93
                    },
                    {
                      "price": 1.84,
                      "size": 223.05
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 1.95,
                      "size": 29.92
                    },
                    {
                      "price": 1.96,
                      "size": 29.92
                    },
                    {
                      "price": 1.97,
                      "size": 68.4
                    }
                  ],
                  "tradedVolume": []
                }
              },
              {
                "selectionId": 58805,
                "status": "ACTIVE",
                "ex": {
                  "availableToBack": [
                    {
                      "price": 3.8,
                      "size": 19.95
                    },
                    {
                      "price": 3.75,
                      "size": 29.92
                    },
                    {
                      "price": 3.7,
                      "size": 29.92
                    }
                  ],
                  "availableToLay": [
                    {
                      "price": 4.1,
                      "size": 140.64
                    },
                    {
                      "price": 4.2,
                      "size": 203.77
                    },
                    {
                      "price": 4.3,
                      "size": 49.43
                    }
                  ],
                  "tradedVolume": []
                }
              }
            ]
          },
          "inplay": false,
          "real_runners": true,
          "min_stake_limit": null,
          "max_stake_limit": null,
          "stake_limit": 1,
          "inplay_stake_limit": 25000,
          "stack_conversion": 1,
          "bookmakers_count": 0,
          "fancies_count": 0
        }
      ]
    }
  ],
  "status": 200,
  "server_timestamp": "1692422162"
};
export default Rdata;



// WEBPACK FOOTER //
// ./src/components/configure/rdata.js